{
  "ZDeutsch membership": {
    "fr": "Abonnement ZDeutsch",
    "ar": "خطط الاشتراك في ZDeutsch"
  },
  "Choose the plan that works for you": {
    "fr": "Choisissez la formule qui vous convient",
    "ar": "اختر الخطة التي تناسبك"
  },
  "Every plan gives you full access to the Lesen, Hören, Schreiben, and Sprechen practice library.": {
    "fr": "Chaque formule donne accès à toute la bibliothèque d’exercices de lecture, d’écoute, d’écriture et d’expression orale.",
    "ar": "تمنحك جميع الخطط وصولاً كاملاً إلى تمارين القراءة والاستماع والكتابة والمحادثة."
  },
  "30 days": {
    "fr": "30 jours",
    "ar": "30 يوماً"
  },
  "Choose plan": {
    "fr": "Choisir cette formule",
    "ar": "اختر هذه الخطة"
  },
  "Active subscription": {
    "fr": "Abonnement actif",
    "ar": "اشتراكك فعّال"
  },
  "Waiting for payment approval": {
    "fr": "En attente de validation du paiement",
    "ar": "بانتظار تأكيد التحويل"
  },
  "Invite one friend to add 6 more days": {
    "fr": "Invitez un ami pour obtenir 6 jours de plus",
    "ar": "ادعُ صديقاً واحداً لتحصل على 6 أيام إضافية"
  },
  "1 day free + 6 bonus days": {
    "fr": "1 jour gratuit + 6 jours offerts",
    "ar": "يوم مجاني + 6 أيام إضافية"
  },
  "Your first day starts immediately. To add six more days, invite one new friend to create an account. They do not need to choose a plan or wait for activation, but must register from a different device and IP address.": {
    "fr": "Votre premier jour commence immédiatement. Pour obtenir six jours de plus, invitez un nouvel ami à créer un compte. Il n’a pas besoin de choisir une formule ni d’attendre l’activation, mais doit s’inscrire depuis un autre appareil et une autre adresse IP.",
    "ar": "يبدأ يومك المجاني فوراً. ولإضافة ستة أيام أخرى، ادعُ صديقاً جديداً لإنشاء حساب. لا يحتاج صديقك إلى اختيار خطة أو انتظار التفعيل، لكن يجب أن يسجّل من جهاز وعنوان IP مختلفين."
  },
  "Friend signups": {
    "fr": "Inscriptions de vos amis",
    "ar": "تسجيلات الأصدقاء"
  },
  "Share invitation": {
    "fr": "Partager l’invitation",
    "ar": "شارك رابط الدعوة"
  },
  "Copy link": {
    "fr": "Copier le lien",
    "ar": "نسخ الرابط"
  },
  "Link copied": {
    "fr": "Lien copié",
    "ar": "تم نسخ رابط الدعوة"
  },
  "To prevent duplicate invitations, ZDeutsch compares protected browser and network identifiers. Raw IP addresses are never stored.": {
    "fr": "Pour éviter les invitations en double, ZDeutsch compare des identifiants protégés du navigateur et du réseau. Les adresses IP brutes ne sont jamais enregistrées.",
    "ar": "لمنع احتساب الدعوة أكثر من مرة، يقارن ZDeutsch معرّفات محمية للمتصفح والشبكة، من دون حفظ عنوان IP الأصلي."
  },
  "Open the library": {
    "fr": "Ouvrir la bibliothèque",
    "ar": "الذهاب إلى المكتبة"
  },
  "Choose how you want to pay": {
    "fr": "Choisissez votre mode de paiement",
    "ar": "اختر طريقة الدفع المناسبة لك"
  },
  "Pay instantly by card or PayPal for automatic activation, or contact us on WhatsApp to arrange a bank transfer.": {
    "fr": "Payez par carte ou PayPal pour une activation immédiate, ou contactez-nous sur WhatsApp pour organiser un virement bancaire.",
    "ar": "ادفع فوراً بالبطاقة البنكية أو عبر PayPal لتفعيل خطتك تلقائياً، أو تواصل معنا عبر واتساب لإتمام التحويل البنكي."
  },
  "Ask for the bank details on WhatsApp.": {
    "fr": "Demandez les coordonnées bancaires sur WhatsApp.",
    "ar": "اطلب بيانات الحساب البنكي عبر واتساب."
  },
  "Send the exact amount and your transfer receipt.": {
    "fr": "Envoyez le montant exact et votre reçu de virement.",
    "ar": "حوّل المبلغ المحدد وأرسل صورة الوصل."
  },
  "An admin verifies the transfer and activates your plan.": {
    "fr": "Un administrateur vérifie le virement et active votre formule.",
    "ar": "تراجع الإدارة التحويل ثم تفعّل خطتك."
  },
  "Contact us on WhatsApp": {
    "fr": "Nous contacter sur WhatsApp",
    "ar": "تواصل معنا عبر واتساب"
  },
  "Pay securely with PayPal": {
    "fr": "Payer en toute sécurité avec PayPal",
    "ar": "الدفع الآمن عبر PayPal"
  },
  "Automatic activation after payment": {
    "fr": "Activation automatique après le paiement",
    "ar": "تفعيل تلقائي فور نجاح الدفع"
  },
  "PayPal is temporarily unavailable. You can still pay by bank transfer.": {
    "fr": "PayPal est temporairement indisponible. Vous pouvez payer par virement bancaire.",
    "ar": "PayPal غير متاح مؤقتاً. يمكنك إتمام الدفع بالتحويل البنكي."
  },
  "Bank transfer": {
    "fr": "Virement bancaire",
    "ar": "تحويل بنكي"
  },
  "Personal help through WhatsApp": {
    "fr": "Assistance personnelle sur WhatsApp",
    "ar": "مساعدة مباشرة عبر واتساب"
  },
  "Display currency": {
    "fr": "Devise d’affichage",
    "ar": "عملة العرض"
  },
  "Conversions are estimates. PayPal shows the exact EUR or USD charge before confirmation.": {
    "fr": "Les conversions sont indicatives. PayPal affiche le montant exact en EUR ou USD avant confirmation.",
    "ar": "التحويلات تقريبية، وسيعرض PayPal المبلغ النهائي باليورو أو الدولار قبل التأكيد."
  },
  "Payment confirmed. Your ZDeutsch plan is now active.": {
    "fr": "Paiement confirmé. Votre formule ZDeutsch est maintenant active.",
    "ar": "تم تأكيد الدفع وتفعيل خطتك على ZDeutsch."
  },
  "PayPal checkout was cancelled. No payment was taken.": {
    "fr": "Le paiement PayPal a été annulé. Aucun montant n’a été prélevé.",
    "ar": "أُلغيت عملية PayPal ولم يتم خصم أي مبلغ."
  },
  "You will finish payment securely on PayPal.": {
    "fr": "Vous terminerez le paiement en toute sécurité sur PayPal.",
    "ar": "ستُكمل عملية الدفع بأمان على موقع PayPal."
  },
  "Debit or credit card": {
    "fr": "Carte de débit ou de crédit",
    "ar": "بطاقة بنكية"
  },
  "Pay as a guest with your card through PayPal": {
    "fr": "Payer par carte sans compte PayPal",
    "ar": "ادفع بالبطاقة كزائر من خلال PayPal"
  },
  "Loading PayPal card checkout…": {
    "fr": "Chargement du paiement par carte PayPal…",
    "ar": "جارٍ تحميل الدفع بالبطاقة عبر PayPal…"
  },
  "PayPal’s card button is unavailable in this browser. Continue with the PayPal button or bank transfer.": {
    "fr": "Le bouton de paiement par carte PayPal est indisponible dans ce navigateur. Utilisez PayPal ou le virement bancaire.",
    "ar": "زر الدفع بالبطاقة من PayPal غير متاح في هذا المتصفح. يمكنك المتابعة عبر زر PayPal أو التحويل البنكي."
  },
  "The card payment could not be completed. Check your card details and try again.": {
    "fr": "Le paiement par carte a échoué. Vérifiez vos coordonnées et réessayez.",
    "ar": "تعذّر إتمام الدفع بالبطاقة. تحقق من بيانات البطاقة وحاول مرة أخرى."
  },
  "Card verification was cancelled. You can try again.": {
    "fr": "La vérification de la carte a été annulée. Vous pouvez réessayer.",
    "ar": "أُلغيت عملية التحقق من البطاقة. يمكنك المحاولة مرة أخرى."
  },
  "Your card is entered and processed in PayPal’s secure checkout. ZDeutsch never receives or stores its details.": {
    "fr": "Vos coordonnées bancaires sont traitées dans l’espace sécurisé de PayPal. ZDeutsch ne les reçoit et ne les conserve jamais.",
    "ar": "تُدخل بيانات بطاقتك وتُعالج داخل نافذة PayPal الآمنة، ولا يستلمها ZDeutsch أو يحفظها."
  },
  "All four TELC skills": {
    "fr": "Les quatre compétences TELC",
    "ar": "المهارات الأربع لامتحان TELC"
  },
  "Progress saved automatically": {
    "fr": "Progression enregistrée automatiquement",
    "ar": "حفظ التقدم تلقائياً"
  },
  "Explanations in your mother language": {
    "fr": "Explications dans votre langue",
    "ar": "شرح بلغتك الأم"
  },
  "Most popular": {
    "fr": "La plus populaire",
    "ar": "الأكثر اختياراً"
  },
  "Back to plans": {
    "fr": "Retour aux formules",
    "ar": "العودة إلى الخطط"
  },
  "Selected plan": {
    "fr": "Formule sélectionnée",
    "ar": "الخطة المختارة"
  },
  "Loading your membership…": {
    "fr": "Chargement de votre abonnement…",
    "ar": "جارٍ تحميل بيانات اشتراكك…"
  },
  "We could not load your membership. Please try again.": {
    "fr": "Impossible de charger votre abonnement. Veuillez réessayer.",
    "ar": "تعذّر تحميل بيانات اشتراكك. حاول مرة أخرى."
  },
  "Try again": {
    "fr": "Réessayer",
    "ar": "إعادة المحاولة"
  },
  "Verify your email before starting the free trial.": {
    "fr": "Vérifiez votre adresse e-mail avant de commencer l’essai gratuit.",
    "ar": "أكّد بريدك الإلكتروني لبدء الفترة التجريبية المجانية."
  },
  "Verify email": {
    "fr": "Vérifier l’adresse e-mail",
    "ar": "تأكيد البريد الإلكتروني"
  },
  "Payment instructions": {
    "fr": "Instructions de paiement",
    "ar": "تعليمات الدفع"
  },
  "Trial already used": {
    "fr": "Essai déjà utilisé",
    "ar": "تم استخدام الفترة المجانية"
  },
  "Your ZDeutsch account": {
    "fr": "Votre compte ZDeutsch",
    "ar": "حسابك على ZDeutsch"
  },
  "Manage your plan, mother language, usage, and password from one place.": {
    "fr": "Gérez votre formule, votre langue, votre utilisation et votre mot de passe au même endroit.",
    "ar": "أدِر خطتك ولغتك الأم ونسبة الاستخدام وكلمة المرور من مكان واحد."
  },
  "Current plan": {
    "fr": "Formule actuelle",
    "ar": "الخطة الحالية"
  },
  "You do not have an active plan. Choose a plan to continue using ZDeutsch.": {
    "fr": "Vous n’avez pas de formule active. Choisissez-en une pour continuer à utiliser ZDeutsch.",
    "ar": "ليست لديك خطة فعّالة حالياً. اختر خطة لمواصلة التدريب على ZDeutsch."
  },
  "Upgrade plan": {
    "fr": "Changer de formule",
    "ar": "ترقية الخطة"
  },
  "Plan usage": {
    "fr": "Utilisation de la formule",
    "ar": "نسبة استخدام الخطة"
  },
  "Change password": {
    "fr": "Changer le mot de passe",
    "ar": "تغيير كلمة المرور"
  },
  "Current password": {
    "fr": "Mot de passe actuel",
    "ar": "كلمة المرور الحالية"
  },
  "New password": {
    "fr": "Nouveau mot de passe",
    "ar": "كلمة المرور الجديدة"
  },
  "Confirm new password": {
    "fr": "Confirmer le nouveau mot de passe",
    "ar": "تأكيد كلمة المرور الجديدة"
  },
  "Update password": {
    "fr": "Mettre à jour le mot de passe",
    "ar": "تحديث كلمة المرور"
  },
  "Forgot your current password? Reset it by email.": {
    "fr": "Mot de passe actuel oublié ? Réinitialisez-le par e-mail.",
    "ar": "نسيت كلمة المرور الحالية؟ يمكنك إعادة تعيينها عبر البريد الإلكتروني."
  },
  "Requested plan awaiting payment approval": {
    "fr": "Changement de formule en attente de validation du paiement",
    "ar": "طلب الترقية بانتظار تأكيد التحويل"
  },
  "Account details": {
    "fr": "Informations du compte",
    "ar": "بيانات الحساب"
  },
  "Email": {
    "fr": "E-mail",
    "ar": "البريد الإلكتروني"
  },
  "Mother language": {
    "fr": "Langue maternelle",
    "ar": "اللغة الأم"
  },
  "Translations and word explanations will use this language.": {
    "fr": "Les traductions et les explications des mots utiliseront cette langue.",
    "ar": "سنستخدم هذه اللغة في ترجمة النصوص وشرح الكلمات."
  },
  "Save language": {
    "fr": "Enregistrer la langue",
    "ar": "حفظ اللغة"
  },
  "Your mother language was updated successfully.": {
    "fr": "Votre langue a bien été mise à jour.",
    "ar": "تم تحديث لغتك الأم بنجاح."
  },
  "Access until": {
    "fr": "Accès jusqu’au",
    "ar": "الاشتراك صالح حتى"
  },
  "Percentage of the AI allowance included with your plan. If a plan has no AI allowance, this shows elapsed subscription time.": {
    "fr": "Part du crédit IA de votre formule déjà utilisée. Si la formule ne contient aucun crédit IA, la durée écoulée de l’abonnement est affichée.",
    "ar": "توضّح هذه النسبة ما استُخدم من حصة الذكاء الاصطناعي في خطتك. إذا لم تتضمن الخطة حصة، فتعرض المدة المنقضية من الاشتراك."
  },
  "The new passwords do not match.": {
    "fr": "Les nouveaux mots de passe ne correspondent pas.",
    "ar": "كلمتا المرور الجديدتان غير متطابقتين."
  },
  "Your new password must contain at least 8 characters.": {
    "fr": "Votre nouveau mot de passe doit contenir au moins 8 caractères.",
    "ar": "يجب أن تتكون كلمة المرور الجديدة من 8 أحرف على الأقل."
  },
  "Your password was updated successfully.": {
    "fr": "Votre mot de passe a bien été mis à jour.",
    "ar": "تم تحديث كلمة المرور بنجاح."
  },
  "Saving…": {
    "fr": "Enregistrement…",
    "ar": "جارٍ الحفظ…"
  },
  "One last step": {
    "fr": "Une dernière étape",
    "ar": "خطوة أخيرة"
  },
  "Complete your profile": {
    "fr": "Complétez votre profil",
    "ar": "أكمل بيانات حسابك"
  },
  "Complete all required fields to use ZDeutsch. If you prefer not to continue, use Log out in the header.": {
    "fr": "Remplissez tous les champs obligatoires pour utiliser ZDeutsch. Si vous ne souhaitez pas continuer, utilisez le bouton de déconnexion dans l’en-tête.",
    "ar": "أكمل جميع الحقول المطلوبة لاستخدام ZDeutsch. إذا كنت لا تريد المتابعة، اضغط على تسجيل الخروج في أعلى الصفحة."
  },
  "Phone number": {
    "fr": "Numéro de téléphone",
    "ar": "رقم الهاتف"
  },
  "+212 6 00 00 00 00": {
    "fr": "+212 6 00 00 00 00",
    "ar": "+212 6 00 00 00 00"
  },
  "Country": {
    "fr": "Pays",
    "ar": "البلد"
  },
  "Choose your country": {
    "fr": "Choisissez votre pays",
    "ar": "اختر بلدك"
  },
  "Gender": {
    "fr": "Genre",
    "ar": "الجنس"
  },
  "Choose your gender": {
    "fr": "Choisissez votre genre",
    "ar": "اختر الجنس"
  },
  "Female": {
    "en": "Female",
    "fr": "Femme",
    "ar": "أنثى"
  },
  "Male": {
    "en": "Male",
    "fr": "Homme",
    "ar": "ذكر"
  },
  "Prefer not to say": {
    "fr": "Je préfère ne pas répondre",
    "ar": "أفضل عدم الإفصاح"
  },
  "Birthday": {
    "fr": "Date de naissance",
    "ar": "تاريخ الميلاد"
  },
  "Target exam level": {
    "fr": "Niveau d’examen visé",
    "ar": "المستوى المستهدف في الامتحان"
  },
  "Choose B1 or B2": {
    "fr": "Choisissez B1 ou B2",
    "ar": "اختر B1 أو B2"
  },
  "Save and continue": {
    "fr": "Enregistrer et continuer",
    "ar": "حفظ البيانات والمتابعة"
  },
  "Required": {
    "fr": "Obligatoire",
    "ar": "مطلوب"
  },
  "Fields marked with * are required. A later plan or target-level change is reviewed by the ZDeutsch team.": {
    "fr": "Les champs marqués d’un * sont obligatoires. Tout changement ultérieur de formule ou de niveau est vérifié par l’équipe ZDeutsch.",
    "ar": "الحقول المعلّمة بعلامة * مطلوبة. أي تغيير لاحق للخطة أو المستوى يراجعه فريق ZDeutsch."
  },
  "Enter a valid phone number.": {
    "fr": "Saisissez un numéro de téléphone valide.",
    "ar": "أدخل رقم هاتف صحيحاً."
  },
  "Choose your country.": {
    "fr": "Choisissez votre pays.",
    "ar": "اختر بلدك."
  },
  "Choose your gender.": {
    "fr": "Choisissez votre genre.",
    "ar": "اختر الجنس."
  },
  "Enter a valid birthday.": {
    "fr": "Saisissez une date de naissance valide.",
    "ar": "أدخل تاريخ ميلاد صحيحاً."
  },
  "Choose your target exam level.": {
    "fr": "Choisissez le niveau d’examen visé.",
    "ar": "اختر مستوى الامتحان المستهدف."
  },
  "We could not save your profile. Please check the information and try again.": {
    "fr": "Impossible d’enregistrer votre profil. Vérifiez les informations et réessayez.",
    "ar": "تعذّر حفظ بياناتك. تحقق من المعلومات وحاول مرة أخرى."
  },
  "Dashboard": {
    "fr": "Tableau de bord",
    "ar": "لوحة التحكم"
  },
  "Overview": {
    "fr": "Vue d’ensemble",
    "ar": "نظرة عامة"
  },
  "Practice": {
    "fr": "Exercices",
    "ar": "التمارين"
  },
  "Exams": {
    "fr": "Examens",
    "ar": "الامتحانات"
  },
  "My words": {
    "fr": "Mes mots",
    "ar": "كلماتي"
  },
  "My texts": {
    "fr": "Mes textes",
    "ar": "نصوصي"
  },
  "Progress": {
    "fr": "Progression",
    "ar": "تقدّمي"
  },
  "My account": {
    "fr": "Mon compte",
    "ar": "حسابي"
  },
  "A little practice today brings you closer to your exam.": {
    "fr": "Un peu de pratique aujourd’hui vous rapproche de votre examen.",
    "ar": "تدرّب قليلاً اليوم لتقترب من هدفك."
  },
  "Choose a skill and practise at your level.": {
    "fr": "Choisissez une compétence et entraînez-vous à votre niveau.",
    "ar": "اختر مهارة وتدرّب على مستواك."
  },
  "Practise on your own or with a group, and find your previous exams here.": {
    "fr": "Entraînez-vous seul ou en groupe et retrouvez vos examens précédents ici.",
    "ar": "تدرّب وحدك أو مع مجموعة، وراجع امتحاناتك السابقة هنا."
  },
  "Review the words you saved while practising.": {
    "fr": "Révisez les mots enregistrés pendant vos exercices.",
    "ar": "راجع الكلمات التي حفظتها أثناء التدريب."
  },
  "See your results and how often you practise.": {
    "fr": "Consultez vos résultats et votre fréquence de pratique.",
    "ar": "تابع نتائجك ونشاطك في التدريب."
  },
  "Dashboard pages": {
    "fr": "Pages du tableau de bord",
    "ar": "صفحات لوحة التحكم"
  },
  "Skip to content": {
    "fr": "Aller au contenu",
    "ar": "انتقل إلى المحتوى"
  },
  "ZDeutsch home": {
    "fr": "Accueil ZDeutsch",
    "ar": "الصفحة الرئيسية لـ ZDeutsch"
  },
  "Free account": {
    "fr": "Compte gratuit",
    "ar": "حساب مجاني"
  },
  "Log out": {
    "fr": "Se déconnecter",
    "ar": "تسجيل الخروج"
  },
  "Profile & security": {
    "fr": "Profil et sécurité",
    "ar": "الملف والأمان"
  },
  "Membership": {
    "fr": "Abonnement",
    "ar": "الاشتراك"
  },
  "Edit profile": {
    "fr": "Modifier le profil",
    "ar": "تعديل الملف"
  },
  "Continue learning": {
    "fr": "Continuer à apprendre",
    "ar": "تابع التعلّم"
  },
  "Start practising": {
    "fr": "Commencer les exercices",
    "ar": "ابدأ التدريب"
  },
  "Continue practising": {
    "fr": "Continuer les exercices",
    "ar": "تابع التدريب"
  },
  "All exercises": {
    "fr": "Tous les exercices",
    "ar": "كل التمارين"
  },
  "Your most recent practice": {
    "fr": "Votre dernier exercice",
    "ar": "آخر مهارة تدرّبت عليها"
  },
  "Choose Lesen, Hören, Schreiben or Sprechen to get started.": {
    "fr": "Choisissez la lecture, l’écoute, l’écriture ou l’expression orale pour commencer.",
    "ar": "ابدأ بتمارين القراءة أو الاستماع أو الكتابة أو المحادثة."
  },
  "Ready for an exam?": {
    "fr": "Prêt pour un examen ?",
    "ar": "مستعد لامتحان؟"
  },
  "Choose your exam parts and practise with a timer and a full correction.": {
    "fr": "Choisissez les parties et entraînez-vous avec un chronomètre et une correction complète.",
    "ar": "اختر أجزاء الامتحان وتدرّب مع مؤقت وتصحيح كامل."
  },
  "Start an exam": {
    "fr": "Commencer un examen",
    "ar": "ابدأ امتحاناً"
  },
  "All exams": {
    "fr": "Tous les examens",
    "ar": "كل الامتحانات"
  },
  "On your own": {
    "fr": "Seul",
    "ar": "تدرّب وحدك"
  },
  "Focus on your own exam, at your own pace.": {
    "fr": "Concentrez-vous sur votre examen, à votre rythme.",
    "ar": "ركّز على امتحانك وتدرّب بالوتيرة التي تناسبك."
  },
  "With a group": {
    "fr": "En groupe",
    "ar": "تدرّب مع مجموعة"
  },
  "Practise together and talk with your study group.": {
    "fr": "Entraînez-vous et discutez avec votre groupe d’étude.",
    "ar": "تدرّب وتحدّث مع مجموعتك أثناء الامتحان."
  },
  "Create or join a room": {
    "fr": "Créer ou rejoindre une salle",
    "ar": "أنشئ غرفة أو انضم إليها"
  },
  "Your exam history": {
    "fr": "Historique de vos examens",
    "ar": "امتحاناتك السابقة"
  },
  "Recent exams": {
    "fr": "Examens récents",
    "ar": "آخر الامتحانات"
  },
  "Practice attempts": {
    "fr": "Tentatives d’entraînement",
    "ar": "محاولات التدريب"
  },
  "Average score": {
    "fr": "Score moyen",
    "ar": "متوسط النتائج"
  },
  "Saved words": {
    "fr": "Mots enregistrés",
    "ar": "الكلمات المحفوظة"
  },
  "Exam date": {
    "fr": "Date de l’examen",
    "ar": "موعد الامتحان"
  },
  "Set your date to see how much time you have left.": {
    "fr": "Indiquez la date pour connaître le temps restant.",
    "ar": "حدّد الموعد لمعرفة الوقت المتبقي."
  },
  "Save date": {
    "fr": "Enregistrer la date",
    "ar": "حفظ الموعد"
  },
  "days left": {
    "fr": "jours restants",
    "ar": "يوماً متبقياً"
  },
  "Flashcards": {
    "fr": "Cartes de vocabulaire",
    "ar": "بطاقات التعلّم"
  },
  "Recall a word, then check its meaning.": {
    "fr": "Retrouvez un mot de mémoire, puis vérifiez son sens.",
    "ar": "تذكّر الكلمة ثم تحقّق من معناها."
  },
  "Matching game": {
    "fr": "Jeu d’association",
    "ar": "لعبة المطابقة"
  },
  "Match German words with their meanings.": {
    "fr": "Associez les mots allemands à leur définition.",
    "ar": "اربط الكلمات الألمانية بمعانيها."
  },
  "No saved words yet.": {
    "fr": "Aucun mot enregistré pour le moment.",
    "ar": "لم تحفظ كلمات بعد."
  },
  "Double-click a word in an exercise to add it to your flashcards.": {
    "fr": "Double-cliquez sur un mot dans un exercice pour l’ajouter à vos cartes.",
    "ar": "انقر مرتين على كلمة في أحد التمارين لإضافتها إلى بطاقاتك."
  },
  "Loading your progress…": {
    "fr": "Chargement de votre progression…",
    "ar": "جارٍ تحميل تقدّمك…"
  },
  "We could not load your progress.": {
    "fr": "Impossible de charger votre progression.",
    "ar": "تعذّر تحميل تقدّمك."
  },
  "We could not load your saved words.": {
    "fr": "Impossible de charger vos mots enregistrés.",
    "ar": "تعذّر تحميل كلماتك المحفوظة."
  },
  "Score": {
    "fr": "Score",
    "ar": "النتيجة"
  },
  "Learning activity": {
    "fr": "Activité d’apprentissage",
    "ar": "نشاط التعلّم"
  },
  "Exam date saved.": {
    "fr": "Date de l’examen enregistrée.",
    "ar": "تم حفظ موعد الامتحان."
  },
  "en": {
    "fr": "fr",
    "ar": "ar"
  },
  "Add a German text. Read it, learn new words, and test your understanding.": {
    "fr": "Ajoutez un texte allemand. Lisez-le, apprenez de nouveaux mots et testez votre compréhension.",
    "ar": "أضف نصًا ألمانيًا، واقرأه وتعلّم كلمات جديدة واختبر فهمك."
  },
  "Add a text": {
    "fr": "Ajouter un texte",
    "ar": "أضف نصًا"
  },
  "Search your texts": {
    "fr": "Rechercher dans vos textes",
    "ar": "ابحث في نصوصك"
  },
  "Your texts belong here.": {
    "fr": "Vos textes apparaîtront ici.",
    "ar": "ابدأ بإضافة نصك الأول."
  },
  "Paste an article, a story, or any German text you want to practise with.": {
    "fr": "Collez un article, une histoire ou un texte allemand pour vous entraîner.",
    "ar": "الصق مقالًا أو قصة أو أي نص ألماني تريد التدرّب عليه."
  },
  "No texts found.": {
    "fr": "Aucun texte trouvé.",
    "ar": "لم نعثر على نصوص."
  },
  "Try another search.": {
    "fr": "Essayez une autre recherche.",
    "ar": "جرّب البحث بكلمات أخرى."
  },
  "Read": {
    "fr": "Lecture",
    "ar": "القراءة"
  },
  "Quiz": {
    "fr": "Quiz",
    "ar": "الاختبار"
  },
  "All texts": {
    "fr": "Tous les textes",
    "ar": "كل النصوص"
  },
  "Edit": {
    "fr": "Modifier",
    "ar": "تعديل"
  },
  "Delete": {
    "fr": "Supprimer",
    "ar": "حذف"
  },
  "Delete this text and its quiz?": {
    "fr": "Supprimer ce texte et son quiz ?",
    "ar": "هل تريد حذف هذا النص واختباره؟"
  },
  "Cancel": {
    "fr": "Annuler",
    "ar": "إلغاء"
  },
  "Save and read": {
    "fr": "Enregistrer et lire",
    "ar": "احفظ وابدأ القراءة"
  },
  "Formatting your text…": {
    "fr": "Mise en forme de votre texte…",
    "ar": "جارٍ تنسيق نصك…"
  },
  "Format with AI before saving": {
    "fr": "Mettre en forme avec l’IA avant d’enregistrer",
    "ar": "نسّق النص بالذكاء الاصطناعي قبل الحفظ"
  },
  "Organizes paragraphs and spacing. Keeps your words unchanged.": {
    "fr": "Organise les paragraphes et les espaces sans modifier vos mots.",
    "ar": "يرتّب الفقرات والمسافات دون تغيير كلماتك."
  },
  "We could not format your text. Your original is still here. Try again, or turn off AI formatting to save it as it is.": {
    "fr": "Impossible de mettre en forme le texte. L’original est toujours ici. Réessayez ou désactivez la mise en forme IA pour l’enregistrer tel quel.",
    "ar": "تعذّر تنسيق النص. ما زال نصك الأصلي هنا. أعد المحاولة، أو أوقف التنسيق واحفظه كما هو."
  },
  "Edit your text": {
    "fr": "Modifier votre texte",
    "ar": "عدّل نصك"
  },
  "Title": {
    "fr": "Titre",
    "ar": "العنوان"
  },
  "optional": {
    "fr": "facultatif",
    "ar": "اختياري"
  },
  "Give your text a title": {
    "fr": "Donnez un titre à votre texte",
    "ar": "اختر عنوانًا لنصك"
  },
  "German text": {
    "fr": "Texte allemand",
    "ar": "النص الألماني"
  },
  "Paste or write your German text here…": {
    "fr": "Collez ou écrivez votre texte allemand ici…",
    "ar": "الصق نصك الألماني أو اكتبه هنا…"
  },
  "characters": {
    "fr": "caractères",
    "ar": "حرفًا"
  },
  "words": {
    "fr": "mots",
    "ar": "كلمة"
  },
  "Saved": {
    "fr": "Enregistré",
    "ar": "تم الحفظ"
  },
  "Double-click a word for its meaning and save it to your words. On mobile, select a word.": {
    "fr": "Double-cliquez sur un mot pour connaître son sens et l’enregistrer. Sur mobile, sélectionnez un mot.",
    "ar": "انقر مرتين على كلمة لمعرفة معناها وحفظها في كلماتك. على الهاتف، حدّد الكلمة."
  },
  "Loading your texts…": {
    "fr": "Chargement de vos textes…",
    "ar": "جارٍ تحميل نصوصك…"
  },
  "We could not load this. Please try again.": {
    "fr": "Impossible de charger le contenu. Veuillez réessayer.",
    "ar": "تعذّر التحميل. حاول مرة أخرى."
  },
  "This text changed in another window. Reload it before continuing.": {
    "fr": "Ce texte a été modifié dans une autre fenêtre. Rechargez-le avant de continuer.",
    "ar": "تم تغيير هذا النص في نافذة أخرى. أعد تحميله قبل المتابعة."
  },
  "Text not found.": {
    "fr": "Texte introuvable.",
    "ar": "لم نعثر على هذا النص."
  },
  "Sign in": {
    "fr": "Se connecter",
    "ar": "تسجيل الدخول"
  },
  "Sign in again to access your texts.": {
    "fr": "Reconnectez-vous pour accéder à vos textes.",
    "ar": "سجّل الدخول مجددًا للوصول إلى نصوصك."
  },
  "Add a text between 20 and 12,000 characters and a title of up to 160 characters.": {
    "fr": "Ajoutez un texte de 20 à 12 000 caractères et un titre de 160 caractères maximum.",
    "ar": "أضف نصًا من 20 إلى 12,000 حرف، وعنوانًا لا يتجاوز 160 حرفًا."
  },
  "A quiz needs at least 40 words and no more than 12,000 characters.": {
    "fr": "Le quiz nécessite au moins 40 mots et 12 000 caractères maximum.",
    "ar": "يحتاج الاختبار إلى نص من 40 كلمة على الأقل، ولا يتجاوز 12,000 حرف."
  },
  "Check how well you understood this text.": {
    "fr": "Vérifiez votre compréhension de ce texte.",
    "ar": "اختبر فهمك لهذا النص."
  },
  "5 multiple-choice questions, 3 short answers, and a short summary.": {
    "fr": "5 questions à choix multiples, 3 réponses courtes et un résumé.",
    "ar": "5 أسئلة اختيار من متعدد، و3 إجابات قصيرة، وملخّص قصير."
  },
  "Create my quiz": {
    "fr": "Créer mon quiz",
    "ar": "أنشئ اختباري"
  },
  "Preparing your quiz…": {
    "fr": "Préparation de votre quiz…",
    "ar": "جارٍ إعداد اختبارك…"
  },
  "Your questions will appear when they are ready. You can leave this page and come back.": {
    "fr": "Les questions apparaîtront dès qu’elles seront prêtes. Vous pouvez quitter cette page et revenir plus tard.",
    "ar": "ستظهر الأسئلة عند اكتمال إعدادها. يمكنك العودة إلى هذه الصفحة لاحقًا."
  },
  "We could not prepare the quiz. Please try again.": {
    "fr": "Impossible de préparer le quiz. Veuillez réessayer.",
    "ar": "تعذّر إعداد الاختبار. حاول مرة أخرى."
  },
  "1. Choose the answer": {
    "fr": "1. Choisissez la réponse",
    "ar": "1. اختر الإجابة"
  },
  "2. Write a short answer": {
    "fr": "2. Rédigez une réponse courte",
    "ar": "2. اكتب إجابة قصيرة"
  },
  "3. Write a summary": {
    "fr": "3. Rédigez un résumé",
    "ar": "3. اكتب ملخّصًا"
  },
  "Check answers": {
    "fr": "Vérifier les réponses",
    "ar": "تحقّق من الإجابات"
  },
  "Check my answer": {
    "fr": "Vérifier ma réponse",
    "ar": "صحّح إجابتي"
  },
  "Checking…": {
    "fr": "Vérification…",
    "ar": "جارٍ التصحيح…"
  },
  "Correct": {
    "fr": "Correct",
    "ar": "إجابة صحيحة"
  },
  "Correct answer": {
    "fr": "Bonne réponse",
    "ar": "الإجابة الصحيحة"
  },
  "What you did well": {
    "fr": "Vos points forts",
    "ar": "نقاط القوة"
  },
  "What to improve": {
    "fr": "Points à améliorer",
    "ar": "ما يمكنك تحسينه"
  },
  "Your answer": {
    "fr": "Votre réponse",
    "ar": "إجابتك"
  },
  "Your summary": {
    "fr": "Votre résumé",
    "ar": "ملخّصك"
  },
  "Use your own words to describe the main ideas.": {
    "fr": "Décrivez les idées principales avec vos propres mots.",
    "ar": "اكتب الأفكار الأساسية بأسلوبك الخاص."
  },
  "Try the quiz again": {
    "fr": "Recommencer le quiz",
    "ar": "أعد الاختبار"
  },
  "Question": {
    "fr": "Question",
    "ar": "السؤال"
  },
  "Subscribe to use this feature": {
    "fr": "Abonnez-vous pour utiliser cette fonctionnalité",
    "ar": "اشترك لاستخدام هذه الميزة"
  },
  "An active plan includes image import, AI formatting, quizzes, and feedback.": {
    "fr": "Une formule active comprend l’importation d’images, la mise en forme IA, les quiz et les retours.",
    "ar": "يتيح الاشتراك استخراج النصوص من الصور وتنسيقها، وإعداد الاختبارات وتصحيح الإجابات بالذكاء الاصطناعي."
  },
  "View subscription plans": {
    "fr": "Voir les formules d’abonnement",
    "ar": "عرض الاشتراكات"
  },
  "Page": {
    "fr": "Page",
    "ar": "الصفحة"
  },
  "of": {
    "fr": "sur",
    "ar": "من"
  },
  "Loading reading tools…": {
    "fr": "Chargement des outils de lecture…",
    "ar": "جارٍ تحميل أدوات القراءة…"
  },
  "Reading tools could not load. Try again.": {
    "fr": "Impossible de charger les outils de lecture. Réessayez.",
    "ar": "تعذّر تحميل أدوات القراءة. حاول مرة أخرى."
  },
  "Quiz answers are kept while this browser session is open.": {
    "fr": "Les réponses au quiz sont conservées pendant cette session du navigateur.",
    "ar": "تُحفظ إجاباتك أثناء جلسة المتصفح الحالية."
  },
  "Take photos": {
    "fr": "Prendre des photos",
    "ar": "التقط صورًا"
  },
  "Import images": {
    "fr": "Importer des images",
    "ar": "استورد صورًا"
  },
  "Choose from files": {
    "fr": "Choisir des fichiers",
    "ar": "اختر من الملفات"
  },
  "Paste from clipboard": {
    "fr": "Coller depuis le presse-papiers",
    "ar": "الصق من الحافظة"
  },
  "Add up to 10 images, then extract their text. You can also paste images here with Ctrl / ⌘ + V.": {
    "fr": "Ajoutez jusqu’à 10 images, puis extrayez leur texte. Vous pouvez aussi les coller ici avec Ctrl / ⌘ + V.",
    "ar": "أضف حتى 10 صور، ثم استخرج نصها. يمكنك أيضًا لصق الصور هنا باستخدام Ctrl / ⌘ + V."
  },
  "Images to read": {
    "fr": "Images à lire",
    "ar": "الصور المضافة"
  },
  "Image": {
    "fr": "Image",
    "ar": "الصورة"
  },
  "Remove image": {
    "fr": "Retirer l’image",
    "ar": "احذف الصورة"
  },
  "Move earlier": {
    "fr": "Déplacer avant",
    "ar": "انقل إلى الأمام"
  },
  "Move later": {
    "fr": "Déplacer après",
    "ar": "انقل إلى الخلف"
  },
  "Clear images": {
    "fr": "Effacer les images",
    "ar": "احذف الصور"
  },
  "Extract text": {
    "fr": "Extraire le texte",
    "ar": "استخرج النص"
  },
  "Reading your images…": {
    "fr": "Lecture de vos images…",
    "ar": "جارٍ قراءة الصور…"
  },
  "Preparing images…": {
    "fr": "Préparation des images…",
    "ar": "جارٍ تجهيز الصور…"
  },
  "Text is read in this order.": {
    "fr": "Le texte est lu dans cet ordre.",
    "ar": "سيُقرأ النص بهذا الترتيب."
  },
  "Add after existing text": {
    "fr": "Ajouter après le texte existant",
    "ar": "أضف بعد النص الحالي"
  },
  "Replace form text": {
    "fr": "Remplacer le texte du formulaire",
    "ar": "استبدل النص في النموذج"
  },
  "Where to add the text": {
    "fr": "Où ajouter le texte",
    "ar": "مكان إضافة النص"
  },
  "Text added. Review it below before saving.": {
    "fr": "Texte ajouté. Vérifiez-le ci-dessous avant d’enregistrer.",
    "ar": "تمت إضافة النص. راجعه في النموذج قبل حفظه."
  },
  "We could not read these images:": {
    "fr": "Impossible de lire ces images :",
    "ar": "تعذّر قراءة هذه الصور:"
  },
  "Try clearer photos.": {
    "fr": "Essayez des photos plus nettes.",
    "ar": "جرّب صورًا أوضح."
  },
  "Add up to 10 images at a time.": {
    "fr": "Ajoutez jusqu’à 10 images à la fois.",
    "ar": "أضف حتى 10 صور في كل مرة."
  },
  "These images are too large. Add fewer images or smaller files.": {
    "fr": "Ces images sont trop volumineuses. Ajoutez-en moins ou utilisez des fichiers plus petits.",
    "ar": "حجم الصور كبير جدًا. أضف صورًا أقل أو ملفات أصغر."
  },
  "We could not open this image. Try a JPG, PNG or WebP file.": {
    "fr": "Impossible d’ouvrir cette image. Essayez un fichier JPG, PNG ou WebP.",
    "ar": "تعذّر فتح الصورة. جرّب ملفًا بصيغة JPG أو PNG أو WebP."
  },
  "No image found in your clipboard. Copy an image first, or choose a file.": {
    "fr": "Aucune image dans le presse-papiers. Copiez une image ou choisissez un fichier.",
    "ar": "لا توجد صورة في الحافظة. انسخ صورة أولًا، أو اختر ملفًا."
  },
  "Clipboard access is unavailable. Use Ctrl / ⌘ + V to paste an image, or choose a file.": {
    "fr": "Le presse-papiers est inaccessible. Utilisez Ctrl / ⌘ + V ou choisissez un fichier.",
    "ar": "تعذّر الوصول إلى الحافظة. استخدم Ctrl / ⌘ + V للصق صورة، أو اختر ملفًا."
  },
  "No readable text was found. Try clearer photos.": {
    "fr": "Aucun texte lisible trouvé. Essayez des photos plus nettes.",
    "ar": "لم نعثر على نص مقروء. جرّب صورًا أوضح."
  },
  "We could not read your images. They are still here. Please try again.": {
    "fr": "Impossible de lire vos images. Elles sont toujours ici. Veuillez réessayer.",
    "ar": "تعذّر قراءة الصور. ما زالت هنا، ويمكنك المحاولة مجددًا."
  },
  "The text exceeds 12,000 characters. Import fewer pages, or choose to replace the form text.": {
    "fr": "Le texte dépasse 12 000 caractères. Importez moins de pages ou remplacez le texte du formulaire.",
    "ar": "يتجاوز النص 12,000 حرف. استورد صفحات أقل، أو اختر استبدال النص في النموذج."
  },
  "Take photos of your text": {
    "fr": "Photographiez votre texte",
    "ar": "التقط صورًا لنصك"
  },
  "Keep the page flat, well lit and in focus. You can take several photos.": {
    "fr": "Gardez la page à plat, bien éclairée et nette. Vous pouvez prendre plusieurs photos.",
    "ar": "ضع الصفحة بشكل مستوٍ، مع إضاءة جيدة وصورة واضحة. يمكنك التقاط عدة صور."
  },
  "Opening your camera…": {
    "fr": "Ouverture de la caméra…",
    "ar": "جارٍ فتح الكاميرا…"
  },
  "We could not open the camera. Allow camera access, or import photos from your files.": {
    "fr": "Impossible d’ouvrir la caméra. Autorisez son accès ou importez des photos depuis vos fichiers.",
    "ar": "تعذّر فتح الكاميرا. اسمح بالوصول إليها، أو استورد الصور من ملفاتك."
  },
  "Take photo": {
    "fr": "Prendre une photo",
    "ar": "التقط صورة"
  },
  "Done": {
    "fr": "Terminé",
    "ar": "تم"
  },
  "Use camera app": {
    "fr": "Utiliser l’application appareil photo",
    "ar": "استخدم تطبيق الكاميرا"
  },
  "photos added": {
    "fr": "photos ajoutées",
    "ar": "صور مضافة"
  },
  "Close": {
    "fr": "Fermer",
    "ar": "إغلاق"
  },
  "Please wait until the images are ready.": {
    "fr": "Attendez que les images soient prêtes.",
    "ar": "انتظر حتى يكتمل تجهيز الصور."
  },
  "ltr": {
    "fr": "ltr",
    "ar": "rtl"
  },
  "Free preview": {
    "fr": "Aperçu gratuit",
    "ar": "معاينة مجانية"
  },
  "Log in": {
    "fr": "Se connecter",
    "ar": "تسجيل الدخول"
  },
  "Create a free account": {
    "fr": "Créer un compte gratuit",
    "ar": "أنشئ حساباً مجانياً"
  },
  "Close dialog": {
    "fr": "Fermer la fenêtre",
    "ar": "إغلاق النافذة"
  },
  "More exercises": {
    "fr": "Plus d’exercices",
    "ar": "تمارين إضافية"
  },
  "AI feature": {
    "fr": "Fonctionnalité IA",
    "ar": "ميزة بالذكاء الاصطناعي"
  },
  "Activate your access": {
    "fr": "Activez votre accès",
    "ar": "فعّل اشتراكك للمتابعة"
  },
  "Create an account and start for free": {
    "fr": "Créez un compte et commencez gratuitement",
    "ar": "أنشئ حساباً وابدأ مجاناً"
  },
  "This exercise is part of the full library. Choose a plan or activate your subscription to open it.": {
    "fr": "Cet exercice fait partie de la bibliothèque complète. Choisissez une formule ou activez votre abonnement pour l’ouvrir.",
    "ar": "هذا التمرين ضمن المكتبة الكاملة. اختر خطة أو فعّل اشتراكك لفتحه."
  },
  "You can try the first four exercises without signing in. Create a free account to use translations, explanations, audio, and AI feedback.": {
    "fr": "Vous pouvez essayer les quatre premiers exercices sans vous connecter. Créez un compte gratuit pour utiliser les traductions, les explications, l’audio et les retours IA.",
    "ar": "يمكنك تجربة أول أربعة تمارين من دون تسجيل. تحتاج إلى حساب مجاني لاستخدام الترجمة والشروحات والصوت وملاحظات الذكاء الاصطناعي."
  },
  "View plans": {
    "fr": "Voir les formules",
    "ar": "عرض الخطط"
  },
  "Start for free": {
    "fr": "Commencer gratuitement",
    "ar": "ابدأ مجاناً"
  },
  "I have an account": {
    "fr": "J’ai un compte",
    "ar": "لديّ حساب"
  },
  "Welcome back": {
    "fr": "Bienvenue",
    "ar": "مرحباً بعودتك"
  },
  "Create your account": {
    "fr": "Créez votre compte",
    "ar": "أنشئ حسابك"
  },
  "Log in to continue your practice.": {
    "fr": "Connectez-vous pour continuer vos exercices.",
    "ar": "سجّل الدخول لمتابعة تدريبك."
  },
  "Start preparing for telc B1 and B2.": {
    "fr": "Commencez à préparer les examens telc B1 et B2.",
    "ar": "ابدأ التحضير لامتحان telc B1 وB2."
  },
  "Continue with Google": {
    "fr": "Continuer avec Google",
    "ar": "المتابعة باستخدام Google"
  },
  "or use your email": {
    "fr": "ou utiliser votre e-mail",
    "ar": "أو استخدم بريدك الإلكتروني"
  },
  "Full name": {
    "fr": "Nom complet",
    "ar": "الاسم الكامل"
  },
  "Email address": {
    "fr": "Adresse e-mail",
    "ar": "البريد الإلكتروني"
  },
  "Password": {
    "fr": "Mot de passe",
    "ar": "كلمة المرور"
  },
  "At least 6 characters.": {
    "fr": "Au moins 6 caractères.",
    "ar": "6 أحرف على الأقل."
  },
  "Your language": {
    "fr": "Votre langue",
    "ar": "لغتك"
  },
  "For translations and word explanations.": {
    "fr": "Pour les traductions et les explications des mots.",
    "ar": "لترجمة النصوص وشرح الكلمات."
  },
  "Create account": {
    "fr": "Créer un compte",
    "ar": "إنشاء حساب"
  },
  "Already have an account?": {
    "fr": "Vous avez déjà un compte ?",
    "ar": "لديك حساب؟"
  },
  "New to ZDeutsch?": {
    "fr": "Nouveau sur ZDeutsch ?",
    "ar": "ليس لديك حساب؟"
  },
  "Create an account": {
    "fr": "Créer un compte",
    "ar": "أنشئ حساباً"
  },
  "Forgot password?": {
    "fr": "Mot de passe oublié ?",
    "ar": "نسيت كلمة المرور؟"
  },
  "Show password": {
    "fr": "Afficher le mot de passe",
    "ar": "إظهار كلمة المرور"
  },
  "Hide password": {
    "fr": "Masquer le mot de passe",
    "ar": "إخفاء كلمة المرور"
  },
  "Please wait…": {
    "fr": "Veuillez patienter…",
    "ar": "يرجى الانتظار…"
  },
  "Forgot your password?": {
    "fr": "Vous avez oublié votre mot de passe ?",
    "ar": "نسيت كلمة المرور؟"
  },
  "Enter your account email to receive a reset code.": {
    "fr": "Saisissez l’e-mail de votre compte pour recevoir un code de réinitialisation.",
    "ar": "أدخل بريد حسابك لتلقي رمز إعادة التعيين."
  },
  "Send reset code": {
    "fr": "Envoyer le code",
    "ar": "إرسال الرمز"
  },
  "Set a new password": {
    "fr": "Définir un nouveau mot de passe",
    "ar": "اختر كلمة مرور جديدة"
  },
  "Enter the code from your email and choose a new password.": {
    "fr": "Saisissez le code reçu par e-mail et choisissez un nouveau mot de passe.",
    "ar": "أدخل الرمز الذي وصلك بالبريد، ثم اختر كلمة مرور جديدة."
  },
  "6-digit code": {
    "fr": "Code à 6 chiffres",
    "ar": "الرمز المكوّن من 6 أرقام"
  },
  "Save new password": {
    "fr": "Enregistrer le nouveau mot de passe",
    "ar": "حفظ كلمة المرور"
  },
  "Back to login": {
    "fr": "Retour à la connexion",
    "ar": "العودة لتسجيل الدخول"
  },
  "Use a different email": {
    "fr": "Utiliser un autre e-mail",
    "ar": "استخدام بريد آخر"
  },
  "Resend code": {
    "fr": "Renvoyer le code",
    "ar": "إعادة إرسال الرمز"
  },
  "No code? Check your spam folder or resend it.": {
    "fr": "Pas de code ? Vérifiez vos courriers indésirables ou renvoyez-le.",
    "ar": "لم يصلك الرمز؟ تحقق من البريد غير المرغوب فيه أو أعد إرساله."
  },
  "The passwords do not match.": {
    "fr": "Les mots de passe ne correspondent pas.",
    "ar": "كلمتا المرور غير متطابقتين."
  },
  "The code is valid for {minutes} minutes.": {
    "fr": "Le code est valable pendant {minutes} minutes.",
    "ar": "الرمز صالح لمدة {minutes} دقيقة."
  },
  "Could not sign in with Google. Please try again.": {
    "fr": "Connexion avec Google impossible. Veuillez réessayer.",
    "ar": "تعذّر تسجيل الدخول باستخدام Google. حاول مرة أخرى."
  },
  "raw points": {
    "fr": "points bruts",
    "ar": "نقاط أولية"
  },
  "points": {
    "fr": "points",
    "ar": "نقطة"
  },
  "Close assessment rules": {
    "fr": "Fermer les règles d’évaluation",
    "ar": "إغلاق قواعد التقييم"
  },
  "This assessment": {
    "fr": "Cette évaluation",
    "ar": "هذا التقييم"
  },
  "Grade bands": {
    "fr": "Niveaux de notation",
    "ar": "درجات التقييم"
  },
  "Assessment rules": {
    "fr": "Règles d’évaluation",
    "ar": "قواعد التصحيح"
  },
  "Open the official TELC model test ↗": {
    "fr": "Ouvrir le modèle officiel TELC ↗",
    "ar": "فتح نموذج امتحان TELC الرسمي ↗"
  },
  "This view explains the TELC rubric used for practice. The official exam is assessed by licensed TELC examiners.": {
    "fr": "Cette vue explique les critères TELC utilisés pour l’entraînement. L’examen officiel est évalué par des examinateurs agréés TELC.",
    "ar": "يشرح هذا العرض معايير TELC المستخدمة في المحاكاة التدريبية. أما الامتحان الرسمي فيقيّمه مصححون معتمدون من TELC."
  },
  "Show TELC assessment rules": {
    "fr": "Afficher les règles d’évaluation TELC",
    "ar": "عرض قواعد تقييم TELC"
  },
  "Writing correction": {
    "fr": "Correction de l’expression écrite",
    "ar": "تصحيح الكتابة"
  },
  "Close correction": {
    "fr": "Fermer la correction",
    "ar": "إغلاق التصحيح"
  },
  "TELC writing practice": {
    "fr": "Entraînement TELC à l’expression écrite",
    "ar": "تدريب TELC على الكتابة"
  },
  "Your correction": {
    "fr": "Votre correction",
    "ar": "تصحيح إجابتك"
  },
  "Preparing your assessment": {
    "fr": "Préparation de votre évaluation",
    "ar": "جارٍ إعداد تقييمك"
  },
  "No previous answers yet": {
    "fr": "Aucune réponse précédente",
    "ar": "لا توجد إجابات سابقة"
  },
  "Once you have an answer corrected, it will appear here with its result.": {
    "fr": "Votre première réponse corrigée apparaîtra ici avec son résultat.",
    "ar": "بعد تصحيح أول إجابة لك، ستظهر هنا مع النتيجة."
  },
  "Practice simulation": {
    "fr": "Simulation d’entraînement",
    "ar": "محاكاة تدريبية"
  },
  "AI correction": {
    "fr": "Correction IA",
    "ar": "تصحيح بالذكاء الاصطناعي"
  },
  "Saved to your account": {
    "fr": "Enregistré dans votre compte",
    "ar": "محفوظ في حسابك"
  },
  "Show the TELC {level} score explanation": {
    "fr": "Afficher l’explication du score TELC {level}",
    "ar": "عرض شرح طريقة احتساب نتيجة TELC {level}"
  },
  "How the score was calculated": {
    "fr": "Calcul du score",
    "ar": "طريقة احتساب النتيجة"
  },
  "Show TELC {level} calculation rules": {
    "fr": "Afficher les règles de calcul TELC {level}",
    "ar": "عرض قواعد احتساب نتيجة TELC {level}"
  },
  "A = 5 · B = 3 · C = 1 · D = 0 raw points": {
    "fr": "A = 5 · B = 3 · C = 1 · D = 0 points bruts",
    "ar": "A = 5 · B = 3 · C = 1 · D = 0 نقاط أولية"
  },
  "Writing contributes 45 of the exam's 300 points (15%). The writing result alone does not determine whether the complete exam is passed.": {
    "fr": "L’expression écrite vaut 45 des 300 points de l’examen (15 %). Son résultat seul ne détermine pas la réussite de l’examen complet.",
    "ar": "يمثل قسم الكتابة 45 نقطة من أصل 300 نقطة في الامتحان (15٪). ولا تحدد نتيجة الكتابة وحدها النجاح في الامتحان كاملاً."
  },
  "AI practice simulation — not an official TELC assessment.": {
    "fr": "Simulation d’entraînement avec l’IA — évaluation TELC non officielle.",
    "ar": "محاكاة تدريبية بالذكاء الاصطناعي وليست تقييماً رسمياً من TELC."
  },
  "Your previous answers": {
    "fr": "Vos réponses précédentes",
    "ar": "إجاباتك السابقة"
  },
  "1 answer": {
    "fr": "1 réponse",
    "ar": "إجابة واحدة"
  },
  "{count} answers": {
    "fr": "{count} réponses",
    "ar": "{count} إجابات"
  },
  "Latest answer": {
    "fr": "Dernière réponse",
    "ar": "أحدث إجابة"
  },
  "Answer {number}": {
    "fr": "Réponse {number}",
    "ar": "الإجابة {number}"
  },
  "Your submitted answer": {
    "fr": "Votre réponse envoyée",
    "ar": "إجابتك المرسلة"
  },
  "Show rules for {criterion}": {
    "fr": "Afficher les règles de {criterion}",
    "ar": "عرض قواعد {criterion}"
  },
  "Task points": {
    "fr": "Points de la consigne",
    "ar": "النقاط المطلوبة"
  },
  "Task point": {
    "fr": "Point de la consigne",
    "ar": "نقطة مطلوبة"
  },
  "Show task-point rules for TELC {level}": {
    "fr": "Afficher les règles des points de la consigne TELC {level}",
    "ar": "عرض قواعد النقاط المطلوبة في TELC {level}"
  },
  "Strengths": {
    "fr": "Points forts",
    "ar": "نقاط القوة"
  },
  "Next steps": {
    "fr": "Prochaines étapes",
    "ar": "الخطوات التالية"
  },
  "Corrected text": {
    "fr": "Texte corrigé",
    "ar": "النص المصحح"
  },
  "Important corrections ({count})": {
    "fr": "Corrections importantes ({count})",
    "ar": "تصحيحات مهمة ({count})"
  },
  "Task completion": {
    "fr": "Réalisation de la tâche",
    "ar": "إنجاز المهمة"
  },
  "Communicative design": {
    "fr": "Organisation communicative",
    "ar": "الصياغة التواصلية"
  },
  "Formal accuracy": {
    "fr": "Correction linguistique",
    "ar": "الصحة اللغوية"
  },
  "Loading your previous answers…": {
    "fr": "Chargement de vos réponses précédentes…",
    "ar": "جارٍ تحميل إجاباتك السابقة…"
  },
  "Your text is being assessed at {level} according to the TELC criteria…": {
    "fr": "Votre texte est évalué au niveau {level} selon les critères TELC…",
    "ar": "يُقيَّم نصك في المستوى {level} وفق معايير TELC…"
  },
  "Please write your text first.": {
    "fr": "Écrivez d’abord votre texte.",
    "ar": "اكتب نصك أولاً."
  },
  "Please write at least five words.": {
    "fr": "Écrivez au moins cinq mots.",
    "ar": "اكتب خمس كلمات على الأقل."
  },
  "Assessing…": {
    "fr": "Évaluation…",
    "ar": "جارٍ التقييم…"
  },
  "Correction unavailable": {
    "fr": "Correction indisponible",
    "ar": "تعذر إجراء التصحيح"
  },
  "The AI correction could not be completed.": {
    "fr": "La correction IA n’a pas pu être effectuée.",
    "ar": "تعذر إتمام التصحيح بالذكاء الاصطناعي."
  },
  "Try the correction again": {
    "fr": "Réessayer la correction",
    "ar": "حاول التصحيح مرة أخرى"
  },
  "Top up balance": {
    "fr": "Recharger le solde",
    "ar": "شحن الرصيد"
  },
  "Create an account and subscribe": {
    "fr": "Créez un compte et abonnez-vous",
    "ar": "أنشئ حساباً واشترك لتصحيح نصك"
  },
  "AI writing correction is available with a ZDeutsch subscription. Create an account, then choose a subscription to use this feature.": {
    "fr": "La correction IA des textes est disponible avec un abonnement ZDeutsch. Créez un compte, puis choisissez un abonnement pour l’utiliser.",
    "ar": "التصحيح بالذكاء الاصطناعي متاح مع اشتراك ZDeutsch. أنشئ حساباً، ثم اختر اشتراكاً لاستخدام هذه الميزة."
  },
  "Subscribe to use AI writing correction": {
    "fr": "Abonnez-vous pour utiliser la correction IA",
    "ar": "اشترك لاستخدام التصحيح بالذكاء الاصطناعي"
  },
  "An active subscription is required for this feature. Choose a plan to get your text corrected and receive feedback.": {
    "fr": "Cette fonctionnalité nécessite un abonnement actif. Choisissez une formule pour obtenir une correction et des conseils sur votre texte.",
    "ar": "تحتاج إلى اشتراك فعّال لاستخدام هذه الميزة. اختر خطة للحصول على تصحيح نصك وملاحظات تساعدك على تحسينه."
  },
  "You do not have enough AI credit for this correction. Choose a subscription with AI credit to continue correcting your texts.": {
    "fr": "Votre crédit IA est insuffisant pour cette correction. Choisissez un abonnement avec du crédit IA pour continuer à corriger vos textes.",
    "ar": "لا يوجد رصيد كافٍ للتصحيح بالذكاء الاصطناعي. اختر اشتراكاً يتضمن رصيداً لمتابعة تصحيح نصوصك."
  },
  "Already have an account? Log in": {
    "fr": "Vous avez déjà un compte ? Connectez-vous",
    "ar": "لديّ حساب — تسجيل الدخول"
  },
  "View subscriptions": {
    "fr": "Voir les abonnements",
    "ar": "عرض الاشتراكات"
  },
  "Correct again": {
    "fr": "Corriger à nouveau",
    "ar": "إعادة التصحيح"
  },
  "Previous answers": {
    "fr": "Réponses précédentes",
    "ar": "الإجابات السابقة"
  },
  "How the TELC B1 writing score is calculated": {
    "fr": "Calcul du score d’expression écrite TELC B1",
    "ar": "طريقة احتساب نتيجة الكتابة في TELC B1"
  },
  "The three criteria are graded independently as A, B, C, or D. A = 5, B = 3, C = 1, and D = 0 raw points. Their sum is multiplied by 3, for a maximum of 45 points.": {
    "fr": "Les trois critères sont notés séparément A, B, C ou D. A = 5, B = 3, C = 1 et D = 0 points bruts. Leur somme est multipliée par 3, pour un maximum de 45 points.",
    "ar": "تُقيَّم المعايير الثلاثة بصورة مستقلة بدرجات A أو B أو C أو D. تمنح A خمس نقاط أولية، وB ثلاث نقاط، وC نقطة واحدة، وD صفراً. يُضرب المجموع في 3، والحد الأقصى هو 45 نقطة."
  },
  "Writing contributes 45 of the exam's 300 points (15%).": {
    "fr": "L’expression écrite vaut 45 des 300 points de l’examen (15 %).",
    "ar": "يمثل قسم الكتابة 45 نقطة من أصل 300 نقطة في الامتحان (15٪)."
  },
  "The writing result alone does not determine whether the complete exam is passed.": {
    "fr": "Le résultat d’expression écrite seul ne détermine pas la réussite de l’examen complet.",
    "ar": "لا تحدد نتيجة الكتابة وحدها النجاح أو الرسوب في الامتحان كاملاً."
  },
  "Only when the text has no or almost no connection to the writing prompt is it considered off-topic and all three criteria receive D.": {
    "fr": "Un texte est considéré hors sujet uniquement s’il n’a aucun ou presque aucun rapport avec la consigne. Les trois critères reçoivent alors D.",
    "ar": "إذا لم يرتبط النص بموضوع الكتابة، أو كان ارتباطه ضعيفاً جداً، فيُعد خارج الموضوع وتحصل المعايير الثلاثة على D."
  },
  "If only the situation or role is wrong, criterion I receives D while criteria II and III are still assessed.": {
    "fr": "Si seule la situation ou le rôle est incorrect, le critère I reçoit D, tandis que les critères II et III restent évalués.",
    "ar": "إذا كان الخطأ في الموقف أو الدور فقط، يحصل المعيار الأول على D بينما يستمر تقييم المعيارين الثاني والثالث."
  },
  "Since TELC's 2019 revision, B1 no longer awards bonus points.": {
    "fr": "Depuis la révision TELC de 2019, aucun point supplémentaire n’est attribué en B1.",
    "ar": "منذ تحديث TELC لعام 2019 لم تعد هناك نقاط إضافية في مستوى B1."
  },
  "I · Task completion (B1)": {
    "fr": "I · Réalisation de la tâche (B1)",
    "ar": "I · إنجاز المهمة (B1)"
  },
  "This measures how many of the four content points were addressed appropriately, relevantly, and intelligibly.": {
    "fr": "Évalue le nombre de points de la consigne traités de manière appropriée, pertinente et compréhensible parmi les quatre proposés.",
    "ar": "يُقيَّم عدد النقاط الأربع التي عولجت بمحتوى مناسب ومرتبط بالمهمة ويمكن فهمه."
  },
  "All four content points were addressed appropriately.": {
    "fr": "Les quatre points sont traités de manière appropriée.",
    "ar": "عولجت النقاط الأربع كلها بصورة مناسبة."
  },
  "Three content points were addressed appropriately.": {
    "fr": "Trois points sont traités de manière appropriée.",
    "ar": "عولجت ثلاث نقاط بصورة مناسبة."
  },
  "Two content points were addressed appropriately.": {
    "fr": "Deux points sont traités de manière appropriée.",
    "ar": "عولجت نقطتان بصورة مناسبة."
  },
  "Only one or no content point was addressed appropriately.": {
    "fr": "Un seul point ou aucun point n’est traité de manière appropriée.",
    "ar": "عولجت نقطة واحدة فقط أو لم تُعالج أي نقطة."
  },
  "At B1, a short, clear, and relevant sentence can be enough to fulfil one point.": {
    "fr": "Au niveau B1, une phrase courte, claire et pertinente peut suffire pour traiter un point.",
    "ar": "قد تكفي في B1 جملة قصيرة ومفهومة ومناسبة لمعالجة نقطة واحدة."
  },
  "Two content points may be covered in one sentence.": {
    "fr": "Deux points peuvent être traités dans une seule phrase.",
    "ar": "يمكن معالجة نقطتين في جملة واحدة."
  },
  "For a two-part or plural content point, a suitable partial answer may still count as addressing it.": {
    "fr": "Pour un point composé de deux éléments ou formulé au pluriel, une réponse partielle pertinente peut être considérée comme un traitement du point.",
    "ar": "إذا كانت النقطة تتكون من جزأين أو جاءت بصيغة الجمع، فقد تُحتسب إجابة جزئية مناسبة بوصفها معالجة للنقطة."
  },
  "Grammar errors are not deducted again here as long as the meaning remains understandable.": {
    "fr": "Les erreurs grammaticales ne sont pas déduites à nouveau ici si le sens reste compréhensible.",
    "ar": "لا تُخصم الأخطاء النحوية مرة أخرى هنا ما دامت الفكرة مفهومة."
  },
  "II · Communicative design (B1)": {
    "fr": "II · Organisation communicative (B1)",
    "ar": "II · الصياغة التواصلية (B1)"
  },
  "This assesses register, audience awareness, email conventions, vocabulary, text logic, linking, and clear linear organisation.": {
    "fr": "Évalue le registre, l’adaptation au destinataire, les conventions de l’e-mail, le vocabulaire, la logique, les liens et l’organisation linéaire du texte.",
    "ar": "يُقيَّم الأسلوب الملائم للمخاطَب، وخصائص البريد الإلكتروني، والمفردات، وتسلسل النص، والروابط، والتنظيم الواضح."
  },
  "B1 achieved well: performance is in the upper range of the target level.": {
    "fr": "B1 bien maîtrisé : performance dans la tranche supérieure du niveau visé.",
    "ar": "استوفى B1 جيداً: الأداء في الجزء الأعلى من المستوى المستهدف."
  },
  "B1 achieved: performance is at the target level.": {
    "fr": "B1 atteint : performance correspondant au niveau visé.",
    "ar": "استوفى B1: الأداء ضمن المستوى المستهدف."
  },
  "The design corresponds mainly to A2.": {
    "fr": "L’organisation correspond principalement au niveau A2.",
    "ar": "الصياغة توافق غالباً مستوى A2."
  },
  "The design corresponds to A1 or below.": {
    "fr": "L’organisation correspond au niveau A1 ou inférieur.",
    "ar": "الصياغة توافق مستوى A1 أو أقل."
  },
  "A is not possible when email features are missing, register is wrong or inconsistent, content points remain disconnected, or most sentences begin with ‘I/We’.": {
    "fr": "La note A est exclue si les éléments de l’e-mail manquent, si le registre est inadapté ou incohérent, si les points restent sans lien ou si la plupart des phrases commencent par « Je/Nous ».",
    "ar": "لا يمكن منح A إذا غابت خصائص البريد الإلكتروني، أو كان أسلوب المخاطبة خاطئاً أو متقلباً، أو بقيت النقاط بلا ترابط، أو بدأت معظم الجمل بـ «أنا/نحن»."
  },
  "For this email task, sender, recipient, date, and subject line are not mandatory letter fields.": {
    "fr": "Pour cet e-mail, l’expéditeur, le destinataire, la date et l’objet ne sont pas des champs obligatoires.",
    "ar": "في مهمة البريد هذه لا تُعد بيانات المرسل والمتلقي والتاريخ وسطر الموضوع حقولاً إلزامية."
  },
  "C or D is appropriate for serious register/audience problems or completely missing or illogical links.": {
    "fr": "La note C ou D convient en cas de graves problèmes de registre ou d’adaptation au destinataire, ou de liens absents ou illogiques.",
    "ar": "تناسب C أو D المشكلات الكبيرة في أسلوب المخاطبة أو غياب الروابط كلياً أو استخدامها بصورة غير منطقية."
  },
  "III · Formal accuracy (B1)": {
    "fr": "III · Correction linguistique (B1)",
    "ar": "III · الصحة اللغوية (B1)"
  },
  "This assesses control of grammar, spelling, and punctuation, and how readily the text can be understood.": {
    "fr": "Évalue la maîtrise de la grammaire, de l’orthographe et de la ponctuation, ainsi que la facilité de compréhension du texte.",
    "ar": "يُقيَّم مدى سلامة القواعد والإملاء وعلامات الترقيم، ومدى سهولة فهم النص."
  },
  "B1 achieved well: generally good control; isolated systematic errors are possible.": {
    "fr": "B1 bien maîtrisé : bonne maîtrise générale ; des erreurs systématiques isolées sont possibles.",
    "ar": "استوفى B1 جيداً: تحكم جيد عموماً مع احتمال وجود أخطاء منهجية محدودة."
  },
  "B1 achieved: systematic errors occur, but the message remains mostly clear.": {
    "fr": "B1 atteint : des erreurs systématiques apparaissent, mais le message reste généralement clair.",
    "ar": "استوفى B1: توجد أخطاء متكررة لكن المعنى يبقى واضحاً في معظمه."
  },
  "A2: many basic errors, though the intended message is generally still recognisable.": {
    "fr": "A2 : nombreuses erreurs de base, mais le message visé reste généralement reconnaissable.",
    "ar": "مستوى A2: أخطاء أساسية كثيرة، مع بقاء المعنى المقصود قابلاً للفهم غالباً."
  },
  "A1 or below: very limited control; the text is only partly understandable.": {
    "fr": "A1 ou inférieur : maîtrise très limitée ; le texte n’est compréhensible qu’en partie.",
    "ar": "مستوى A1 أو أقل: تحكم محدود جداً والنص لا يُفهم إلا جزئياً."
  },
  "Intelligibility comes first. Ending and gender errors usually carry less weight than agreement errors.": {
    "fr": "La compréhension est prioritaire. Les erreurs de terminaison et de genre pèsent généralement moins que les erreurs d’accord.",
    "ar": "وضوح المعنى هو الأهم. غالباً ما تكون أخطاء النهايات والجنس أقل تأثيراً من أخطاء المطابقة."
  },
  "There is no fixed deduction per error. The error type, pattern, density, and effect determine the grade.": {
    "fr": "Il n’existe pas de déduction fixe par erreur. Le type, la répétition, la densité et l’effet des erreurs déterminent la note.",
    "ar": "لا يوجد خصم ثابت لكل خطأ؛ فنوع الأخطاء ونمطها وكثافتها وتأثيرها هي التي تحدد الدرجة."
  },
  "A D in this criterion does not force a D in the other two criteria.": {
    "fr": "Un D pour ce critère n’impose pas un D pour les deux autres.",
    "ar": "الحصول على D في هذا المعيار لا يفرض D في المعيارين الآخرين."
  },
  "Understanding the content points (B1)": {
    "fr": "Comprendre les points de la consigne (B1)",
    "ar": "فهم النقاط المطلوبة بصورة صحيحة (B1)"
  },
  "The checkmarks are a diagnostic aid. The official score comes from the holistic grade for criterion I.": {
    "fr": "Les coches sont une aide au diagnostic. Le score officiel repose sur l’évaluation globale du critère I.",
    "ar": "علامات الإنجاز وسيلة مساعدة للتشخيص. أما النتيجة الرسمية فتنشأ من التقييم الشامل للمعيار الأول."
  },
  "A checkmark means the point was addressed relevantly, meaningfully, and intelligibly.": {
    "fr": "Une coche signifie que le point est traité de façon pertinente, significative et compréhensible.",
    "ar": "تعني علامة الإنجاز أن النقطة عولجت بصورة مناسبة ومفيدة ومفهومة."
  },
  "A missing checkmark is not an additional deduction outside criterion I.": {
    "fr": "Une coche manquante n’ajoute pas de pénalité en dehors du critère I.",
    "ar": "غياب العلامة لا يؤدي إلى خصم إضافي خارج المعيار الأول."
  },
  "At B1, a short sentence may be enough; completeness and clarity matter more than unusually complex language.": {
    "fr": "Au niveau B1, une phrase courte peut suffire. L’exhaustivité et la clarté comptent davantage qu’un langage exceptionnellement complexe.",
    "ar": "قد تكفي في B1 جملة قصيرة؛ فاكتمال الإجابة ووضوحها أهم من استخدام لغة معقدة جداً."
  },
  "How the TELC B2 writing score is calculated": {
    "fr": "Calcul du score d’expression écrite TELC B2",
    "ar": "طريقة احتساب نتيجة الكتابة في TELC B2"
  },
  "I · Task completion (B2)": {
    "fr": "I · Réalisation de la tâche (B2)",
    "ar": "I · إنجاز المهمة (B2)"
  },
  "This assesses appropriately developed B2-level points: three given points, or two given points plus one relevant original aspect.": {
    "fr": "Évalue le développement approprié des points au niveau B2 : trois points proposés, ou deux points proposés et un aspect personnel pertinent.",
    "ar": "يُقيَّم تطوير النقاط بمستوى B2: ثلاث نقاط معطاة، أو نقطتان معطاتان مع جانب إضافي مناسب للموقف."
  },
  "Three points, or two plus one relevant original aspect, are appropriately developed at B2.": {
    "fr": "Trois points, ou deux points et un aspect personnel pertinent, sont développés de manière appropriée au niveau B2.",
    "ar": "طُوّرت ثلاث نقاط، أو نقطتان مع جانب إضافي مناسب، بصورة ملائمة لمستوى B2."
  },
  "Two points, or one plus one relevant original aspect, are appropriately developed at B2.": {
    "fr": "Deux points, ou un point et un aspect personnel pertinent, sont développés de manière appropriée au niveau B2.",
    "ar": "طُوّرت نقطتان، أو نقطة مع جانب إضافي مناسب، بصورة ملائمة لمستوى B2."
  },
  "One point or one relevant original aspect is appropriately developed at B2.": {
    "fr": "Un point ou un aspect personnel pertinent est développé de manière appropriée au niveau B2.",
    "ar": "طُوّرت نقطة واحدة أو جانب إضافي مناسب بصورة ملائمة لمستوى B2."
  },
  "No point or relevant original aspect is appropriately developed at B2.": {
    "fr": "Aucun point ni aspect personnel pertinent n’est développé de manière appropriée au niveau B2.",
    "ar": "لم تُطوّر أي نقطة أو جانب إضافي مناسب بمستوى B2."
  },
  "A passing mention is not enough: a properly addressed point needs development beyond a single sentence structure.": {
    "fr": "Une simple mention ne suffit pas : le traitement d’un point doit dépasser une seule structure de phrase.",
    "ar": "لا تكفي الإشارة العابرة؛ فالنقطة المعالجة جيداً تحتاج إلى تطوير يتجاوز تركيب جملة واحداً."
  },
  "The writer's position should be differentiated and appropriate for the audience.": {
    "fr": "La position de l’auteur doit être nuancée et adaptée au destinataire.",
    "ar": "ينبغي عرض الرأي الشخصي بصورة متوازنة ومناسبة للمخاطَب."
  },
  "Insufficient conceptual or linguistic complexity leads to a lower grade even when the point is mentioned.": {
    "fr": "Une complexité conceptuelle ou linguistique insuffisante réduit la note, même si le point est mentionné.",
    "ar": "يؤدي ضعف العمق الفكري أو التعقيد اللغوي إلى تقييم أقل حتى لو ذُكرت النقطة."
  },
  "The model task asks for at least 150 words, but there is no published fixed deduction per missing word. The depth and language range actually demonstrated are assessed.": {
    "fr": "La consigne du modèle demande au moins 150 mots, mais aucune déduction fixe par mot manquant n’est publiée. La profondeur et la variété linguistique démontrées sont évaluées.",
    "ar": "تطلب المهمة النموذجية 150 كلمة على الأقل، لكن لا يوجد خصم ثابت منشور لكل كلمة ناقصة؛ إذ يُقيَّم العمق والتنوع اللغوي الظاهران فعلياً."
  },
  "II · Communicative design (B2)": {
    "fr": "II · Organisation communicative (B2)",
    "ar": "II · الصياغة التواصلية (B2)"
  },
  "This assesses register, audience awareness, text type, text logic, cohesion, coherence, connectors, and vocabulary range.": {
    "fr": "Évalue le registre, l’adaptation au destinataire, le type de texte, la logique, la cohésion, la cohérence, les connecteurs et la richesse du vocabulaire.",
    "ar": "يُقيَّم أسلوب المخاطبة، ومراعاة المتلقي، ونوع النص، وتسلسل الأفكار، والتماسك، وأدوات الربط، وتنوع المفردات."
  },
  "B2 achieved well: convincing, clear, varied, and in the upper range of the target level.": {
    "fr": "B2 bien maîtrisé : texte convaincant, clair et varié dans la tranche supérieure du niveau visé.",
    "ar": "استوفى B2 جيداً: مقنع وواضح ومتنوع وفي الجزء الأعلى من المستوى المستهدف."
  },
  "B2 achieved: clear, appropriate to the situation, and coherent at the target level.": {
    "fr": "B2 atteint : texte clair, adapté à la situation et cohérent au niveau visé.",
    "ar": "استوفى B2: واضح ومناسب للموقف ومترابط ضمن المستوى المستهدف."
  },
  "The design corresponds mainly to B1.": {
    "fr": "L’organisation correspond principalement au niveau B1.",
    "ar": "الصياغة توافق غالباً مستوى B1."
  },
  "The design corresponds to A2 or below.": {
    "fr": "L’organisation correspond au niveau A2 ou inférieur.",
    "ar": "الصياغة توافق مستوى A2 أو أقل."
  },
  "B is not possible if register is wrong or inconsistent, vocabulary is not appropriate for B2, or content points are listed without a logical connection.": {
    "fr": "La note B est exclue si le registre est incorrect ou incohérent, si le vocabulaire ne correspond pas au B2 ou si les points sont énumérés sans lien logique.",
    "ar": "لا يمكن منح B إذا كان أسلوب المخاطبة خاطئاً أو متقلباً، أو كانت المفردات دون مستوى B2، أو سُردت النقاط بلا ترابط منطقي."
  },
  "A subject, salutation, and closing belong in a formal or semi-formal email; postal fields such as sender, recipient, and date are unnecessary.": {
    "fr": "Un e-mail formel ou semi-formel comporte un objet, une formule d’appel et une formule de clôture. Les champs postaux comme l’expéditeur, le destinataire et la date sont inutiles.",
    "ar": "ينتمي الموضوع والتحية وصيغة الختام إلى البريد الرسمي أو شبه الرسمي، بينما لا تلزم الحقول البريدية مثل المرسل والمتلقي والتاريخ."
  },
  "Individual connectors do not earn marks by themselves; what matters is whether they express relationships between ideas clearly and meaningfully.": {
    "fr": "Les connecteurs n’apportent pas de points à eux seuls. Ils doivent exprimer clairement et utilement les relations entre les idées.",
    "ar": "لا يُقيَّم مجرد وجود أدوات الربط، بل مدى تعبيرها عن العلاقات بين الأفكار بوضوح ومنطق."
  },
  "III · Formal accuracy (B2)": {
    "fr": "III · Correction linguistique (B2)",
    "ar": "III · الصحة اللغوية (B2)"
  },
  "This assesses grammatical control, sentence structure, spelling, and punctuation at B2 level.": {
    "fr": "Évalue la maîtrise de la grammaire, de la structure des phrases, de l’orthographe et de la ponctuation au niveau B2.",
    "ar": "يُقيَّم التحكم في القواعد، وبناء الجملة، والإملاء، وعلامات الترقيم بمستوى B2."
  },
  "B2 achieved well: good control with no systematic errors; occasional slips are possible.": {
    "fr": "B2 bien maîtrisé : bonne maîtrise sans erreurs systématiques ; des lapsus occasionnels sont possibles.",
    "ar": "استوفى B2 جيداً: تحكم جيد بلا أخطاء منهجية، مع احتمال وجود هفوات فردية."
  },
  "B2 achieved: fairly good control; a few systematic errors do not endanger understanding.": {
    "fr": "B2 atteint : assez bonne maîtrise ; quelques erreurs systématiques ne compromettent pas la compréhension.",
    "ar": "استوفى B2: تحكم جيد إلى حد كبير، والأخطاء المنهجية القليلة لا تعيق الفهم."
  },
  "B1: several systematic errors, but the message remains mostly clear.": {
    "fr": "B1 : plusieurs erreurs systématiques, mais le message reste généralement clair.",
    "ar": "مستوى B1: عدة أخطاء منهجية مع بقاء المعنى واضحاً في معظمه."
  },
  "A2 or below: many basic systematic errors.": {
    "fr": "A2 ou inférieur : nombreuses erreurs systématiques de base.",
    "ar": "مستوى A2 أو أقل: أخطاء أساسية منهجية كثيرة."
  },
  "There is no fixed deduction per error. Pattern, frequency, intelligibility, and linguistic control are decisive.": {
    "fr": "Il n’existe pas de déduction fixe par erreur. La répétition, la fréquence, la compréhension et la maîtrise linguistique sont déterminantes.",
    "ar": "لا يوجد خصم ثابت لكل خطأ؛ فالنمط والتكرار والوضوح والتحكم اللغوي هي العوامل الحاسمة."
  },
  "Standard varieties of German are accepted; capitalisation is part of the assessment.": {
    "fr": "Les variantes standard de l’allemand sont acceptées. L’usage des majuscules fait partie de l’évaluation.",
    "ar": "تُقبل الأنواع القياسية للغة الألمانية، وتدخل الكتابة بحروف كبيرة وصغيرة ضمن التقييم."
  },
  "A D here does not force a D in the other criteria. An A does not require native-speaker or C1 performance.": {
    "fr": "Un D ici n’impose pas un D pour les autres critères. Un A ne nécessite pas une performance de locuteur natif ou de niveau C1.",
    "ar": "الحصول على D هنا لا يفرض D في المعيارين الآخرين، كما لا تتطلب A أداءً بمستوى متحدث أصلي أو C1."
  },
  "Understanding the content points (B2)": {
    "fr": "Comprendre les points de la consigne (B2)",
    "ar": "فهم النقاط المطلوبة بصورة صحيحة (B2)"
  },
  "The checkmarks show which content was recognised. Criterion I also considers whether each point was developed deeply enough and at B2 level.": {
    "fr": "Les coches montrent les contenus reconnus. Le critère I considère aussi si chaque point est assez développé et au niveau B2.",
    "ar": "توضح علامات الإنجاز المحتوى الذي تم التعرف إليه. ويأخذ المعيار الأول أيضاً في الحسبان كفاية التفصيل وتطويره لغوياً بمستوى B2."
  },
  "Three checkmarks do not automatically produce an A.": {
    "fr": "Trois coches ne donnent pas automatiquement un A.",
    "ar": "ثلاث علامات إنجاز لا تعني الحصول على A تلقائياً."
  },
  "A point needs more than a brief mention and must fit the situation.": {
    "fr": "Un point demande plus qu’une brève mention et doit correspondre à la situation.",
    "ar": "تحتاج النقطة إلى أكثر من إشارة قصيرة ويجب أن تناسب الموقف."
  },
  "An original aspect can replace a given point when it clearly fits the situation and is developed appropriately.": {
    "fr": "Un aspect personnel peut remplacer un point proposé s’il correspond clairement à la situation et s’il est développé de manière appropriée.",
    "ar": "يمكن لجانب شخصي جديد أن يحل محل نقطة معطاة إذا كان مرتبطاً بوضوح بالموقف وطُوّر بصورة مناسبة."
  },
  "telc B1 & B2 German Exam Preparation Online | ZDeutsch": {
    "fr": "Préparation en ligne aux examens d’allemand telc B1 et B2 | ZDeutsch",
    "ar": "التحضير لامتحان telc B1 وB2 | ZDeutsch"
  },
  "Prepare for telc Deutsch B1 and B2 online. Practice reading, listening, writing, and speaking with vocabulary help and AI feedback on ZDeutsch.": {
    "fr": "Préparez les examens telc Deutsch B1 et B2 en ligne. Entraînez-vous à la lecture, à l’écoute, à l’écriture et à l’oral avec une aide au vocabulaire et des retours IA sur ZDeutsch.",
    "ar": "استعد لامتحان telc Deutsch B1 وB2: تمارين القراءة والاستماع والكتابة والمحادثة، مع شرح الكلمات وملاحظات الذكاء الاصطناعي على ZDeutsch."
  },
  "Main navigation": {
    "fr": "Navigation principale",
    "ar": "روابط الصفحة"
  },
  "Page language": {
    "fr": "Langue de la page",
    "ar": "لغة الصفحة"
  },
  "How it works": {
    "fr": "Comment ça marche",
    "ar": "كيف تبدأ"
  },
  "Questions": {
    "fr": "Questions",
    "ar": "أسئلة شائعة"
  },
  "telc Deutsch · B1 / B2": {
    "fr": "telc Deutsch · B1 / B2",
    "ar": "telc Deutsch · B1 / B2"
  },
  "Prepare for your telc exam.": {
    "fr": "Préparez votre examen telc.",
    "ar": "استعد لامتحان telc."
  },
  "Practise at your level.": {
    "fr": "Entraînez-vous à votre niveau.",
    "ar": "تدرّب حسب مستواك."
  },
  "Reading, listening, writing and speaking exercises for B1 and B2.": {
    "fr": "Exercices de lecture, d’écoute, d’écriture et d’expression orale pour B1 et B2.",
    "ar": "تمارين القراءة والاستماع والكتابة والمحادثة للمستويين B1 وB2."
  },
  "Continue practicing": {
    "fr": "Continuer les exercices",
    "ar": "متابعة التدريب"
  },
  "Explore the practice": {
    "fr": "Découvrir les exercices",
    "ar": "تصفّح التمارين"
  },
  "Free account · Exercises with an active plan.": {
    "fr": "Compte gratuit · Exercices avec une formule active.",
    "ar": "إنشاء الحساب مجاني. التمارين تحتاج إلى اشتراك."
  },
  "Reading · Listening · Writing · Speaking": {
    "fr": "Lecture · Écoute · Écriture · Expression orale",
    "ar": "قراءة · استماع · كتابة · محادثة"
  },
  "VIDEO TUTORIAL": {
    "fr": "TUTORIEL VIDÉO",
    "ar": "شرح بالفيديو"
  },
  "See how ZDeutsch works": {
    "fr": "Découvrez le fonctionnement de ZDeutsch",
    "ar": "تعرّف على ZDeutsch"
  },
  "Learn how to use the exercises and learning tools.": {
    "fr": "Apprenez à utiliser les exercices et les outils d’apprentissage.",
    "ar": "شاهد طريقة استخدام التمارين وأدوات المساعدة."
  },
  "8 min 50 sec": {
    "fr": "8 min 50 s",
    "ar": "8 دقائق و50 ثانية"
  },
  "Watch the tutorial": {
    "fr": "Regarder le tutoriel",
    "ar": "شاهد الشرح"
  },
  "Open the tutorial video": {
    "fr": "Ouvrir la vidéo du tutoriel",
    "ar": "افتح الفيديو"
  },
  "START HERE": {
    "fr": "COMMENCEZ ICI",
    "ar": "ابدأ من هنا"
  },
  "Choose your level": {
    "fr": "Choisissez votre niveau",
    "ar": "اختر مستواك"
  },
  "Choose B1 or B2, then a skill.": {
    "fr": "Choisissez B1 ou B2, puis une compétence.",
    "ar": "اختر B1 أو B2، ثم القسم الذي تريد التدرب عليه."
  },
  "Build confidence with everyday German.": {
    "fr": "Gagnez en confiance avec l’allemand du quotidien.",
    "ar": "تدرّب على الألمانية في المواقف اليومية."
  },
  "Work on more detailed texts and arguments.": {
    "fr": "Travaillez sur des textes et des arguments plus détaillés.",
    "ar": "طوّر فهم النصوص والتعبير عن الآراء بتفصيل."
  },
  "Choose": {
    "fr": "Choisir",
    "ar": "اختر"
  },
  "Selected": {
    "fr": "Sélectionné",
    "ar": "المستوى المختار"
  },
  "Choose your exam level": {
    "fr": "Choisissez votre niveau d’examen",
    "ar": "اختر مستوى امتحانك"
  },
  "Open practice": {
    "fr": "Ouvrir les exercices",
    "ar": "افتح التمارين"
  },
  "Sign in to access exercises. New here? Create your account first.": {
    "fr": "Connectez-vous pour accéder aux exercices. Nouveau ici ? Créez d’abord votre compte.",
    "ar": "سجّل الدخول لفتح التمارين، أو أنشئ حساباً جديداً."
  },
  "PRACTICE": {
    "fr": "EXERCICES",
    "ar": "أقسام التدريب"
  },
  "What would you like to practise?": {
    "fr": "Que souhaitez-vous pratiquer ?",
    "ar": "على ماذا تريد أن تتدرّب؟"
  },
  "Choose reading, listening, writing or speaking.": {
    "fr": "Choisissez la lecture, l’écoute, l’écriture ou l’expression orale.",
    "ar": "اختر القراءة أو الاستماع أو الكتابة أو المحادثة."
  },
  "Lesen": {
    "fr": "Lesen",
    "ar": "Lesen"
  },
  "Reading": {
    "fr": "Lecture",
    "ar": "القراءة"
  },
  "Read texts and answer questions. Use word explanations when you need them.": {
    "fr": "Lisez des textes et répondez aux questions. Utilisez les explications des mots si nécessaire.",
    "ar": "اقرأ النصوص وأجب عن الأسئلة. استخدم شرح الكلمات عند الحاجة."
  },
  "Practise reading": {
    "fr": "Pratiquer la lecture",
    "ar": "تدرّب على القراءة"
  },
  "Hören": {
    "fr": "Hören",
    "ar": "Hören"
  },
  "Listening": {
    "fr": "Écoute",
    "ar": "الاستماع"
  },
  "Listen to recordings, answer the questions and review your answers.": {
    "fr": "Écoutez les enregistrements, répondez aux questions et vérifiez vos réponses.",
    "ar": "استمع إلى التسجيلات، أجب عن الأسئلة، وراجع إجاباتك."
  },
  "Practise listening": {
    "fr": "Pratiquer l’écoute",
    "ar": "تدرّب على الاستماع"
  },
  "Schreiben": {
    "fr": "Schreiben",
    "ar": "Schreiben"
  },
  "Writing": {
    "fr": "Écriture",
    "ar": "الكتابة"
  },
  "Write your text and get corrections and feedback to improve it.": {
    "fr": "Rédigez votre texte et obtenez des corrections et des conseils pour l’améliorer.",
    "ar": "اكتب نصّك، واحصل على تصحيح وملاحظات لتحسينه."
  },
  "Practise writing": {
    "fr": "Pratiquer l’écriture",
    "ar": "تدرّب على الكتابة"
  },
  "Sprechen": {
    "fr": "Sprechen",
    "ar": "Sprechen"
  },
  "Speaking": {
    "fr": "Expression orale",
    "ar": "المحادثة"
  },
  "Practise speaking and expressing your ideas clearly.": {
    "fr": "Entraînez-vous à parler et à exprimer clairement vos idées.",
    "ar": "تدرّب على التحدث والتعبير عن أفكارك بوضوح."
  },
  "Practise speaking": {
    "fr": "Pratiquer l’expression orale",
    "ar": "تدرّب على المحادثة"
  },
  "A SIMPLE ROUTINE": {
    "fr": "UNE ROUTINE SIMPLE",
    "ar": "كيف تبدأ"
  },
  "Get started in three steps": {
    "fr": "Commencez en trois étapes",
    "ar": "ابدأ بثلاث خطوات"
  },
  "Choose your focus": {
    "fr": "Choisissez votre objectif",
    "ar": "اختر مستواك"
  },
  "Pick B1 or B2 and one skill. Start with the section you find most difficult.": {
    "fr": "Choisissez B1 ou B2 et une compétence. Commencez par la partie qui vous semble la plus difficile.",
    "ar": "اختر B1 أو B2، ثم مهارة تريد تحسينها."
  },
  "Work through a task": {
    "fr": "Réalisez une tâche",
    "ar": "حلّ التمرين"
  },
  "Read the instructions, try the exercise, and use vocabulary help when you need it.": {
    "fr": "Lisez les consignes, essayez l’exercice et utilisez l’aide au vocabulaire si nécessaire.",
    "ar": "اقرأ التعليمات وأجب. استخدم أدوات المساعدة عند الحاجة."
  },
  "Review and repeat": {
    "fr": "Révisez et recommencez",
    "ar": "راجع إجاباتك"
  },
  "Look at your answers or feedback. Revisit unfamiliar words before moving to the next task.": {
    "fr": "Consultez vos réponses ou les retours. Révisez les mots inconnus avant de passer à la tâche suivante.",
    "ar": "تعلّم من أخطائك، ثم جرّب تمريناً آخر."
  },
  "Choose your subscription": {
    "fr": "Choisissez votre abonnement",
    "ar": "اختر اشتراكك"
  },
  "Create a free account, then choose a subscription to unlock the exercises. Prices and learning-tool allowances are shown in your account.": {
    "fr": "Créez un compte gratuit, puis choisissez un abonnement pour débloquer les exercices. Les tarifs et les crédits des outils sont affichés dans votre compte.",
    "ar": "أنشئ حساباً مجانياً، ثم اختر اشتراكاً لفتح التمارين. ستجد الأسعار ورصيد أدوات المساعدة داخل حسابك."
  },
  "View plans in my account": {
    "fr": "Voir les formules dans mon compte",
    "ar": "عرض الاشتراكات"
  },
  "BEFORE YOU BEGIN": {
    "fr": "AVANT DE COMMENCER",
    "ar": "قبل أن تبدأ"
  },
  "Common questions": {
    "fr": "Questions fréquentes",
    "ar": "أسئلة شائعة"
  },
  "What can I practice for telc B1 and B2?": {
    "fr": "Que puis-je pratiquer pour telc B1 et B2 ?",
    "ar": "ما التمارين المتاحة؟"
  },
  "ZDeutsch offers reading (Lesen), listening (Hören), writing (Schreiben), and speaking (Sprechen / Mündlich) practice for B1 and B2. Choose your level to open the relevant practice.": {
    "fr": "ZDeutsch propose des exercices de lecture (Lesen), d’écoute (Hören), d’écriture (Schreiben) et d’oral (Sprechen / Mündlich) pour B1 et B2. Choisissez votre niveau pour ouvrir les exercices adaptés.",
    "ar": "تمارين القراءة والاستماع والكتابة والمحادثة للمستويين B1 وB2."
  },
  "Is ZDeutsch free?": {
    "fr": "ZDeutsch est-il gratuit ?",
    "ar": "هل الاستخدام مجاني؟"
  },
  "Creating an account and taking an exam simulation are free. Topic exercises require a subscription or an eligible trial. Check prices and trial conditions in your account.": {
    "fr": "La création d’un compte et la simulation d’examen sont gratuites. Les exercices par thème nécessitent un abonnement ou un essai éligible. Consultez les tarifs et les conditions d’essai dans votre compte.",
    "ar": "إنشاء الحساب ومحاكاة الامتحان مجانيان. تمارين المواضيع تحتاج إلى اشتراك أو فترة تجريبية متاحة لحسابك. اطّلع على الأسعار وشروط التجربة داخل حسابك."
  },
  "How should I prepare for a telc German exam?": {
    "fr": "Comment préparer un examen d’allemand telc ?",
    "ar": "كيف أستعد للامتحان؟"
  },
  "Begin with the official exam format for your level. Practice individual skills regularly, review mistakes, and use official telc mock examinations to become familiar with the complete exam. ZDeutsch can support your daily practice.": {
    "fr": "Commencez par le format officiel de votre niveau. Pratiquez régulièrement chaque compétence, révisez vos erreurs et utilisez les examens blancs officiels telc pour vous familiariser avec l’examen complet. ZDeutsch peut accompagner vos exercices quotidiens.",
    "ar": "تعرّف على شكل الامتحان، وتدرّب على كل مهارة، وراجع أخطاءك. استخدم النماذج الرسمية من telc أيضاً."
  },
  "Can I use ZDeutsch on my phone?": {
    "fr": "Puis-je utiliser ZDeutsch sur mon téléphone ?",
    "ar": "هل يمكنني استخدام الهاتف؟"
  },
  "Yes. You can open ZDeutsch in a browser on your phone, tablet, or computer. Choose a quiet place for speaking practice and use headphones when helpful.": {
    "fr": "Oui. Ouvrez ZDeutsch dans le navigateur de votre téléphone, tablette ou ordinateur. Choisissez un lieu calme pour pratiquer l’oral et utilisez un casque si nécessaire.",
    "ar": "نعم، يمكنك التدريب من الهاتف أو الجهاز اللوحي أو الحاسوب."
  },
  "Is ZDeutsch an official telc provider?": {
    "fr": "ZDeutsch est-il un organisme officiel telc ?",
    "ar": "هل ZDeutsch تابع لـ telc؟"
  },
  "ZDeutsch is an independent practice platform and is not affiliated with or endorsed by telc gGmbH. It does not issue telc certificates or book exams. Check telc and your examination centre for official exam details.": {
    "fr": "ZDeutsch est une plateforme indépendante, sans affiliation ni approbation de telc gGmbH. Elle ne délivre pas de certificats telc et ne réserve pas d’examens. Consultez telc et votre centre d’examen pour les informations officielles.",
    "ar": "ZDeutsch منصة تدريب مستقلة. لا تحجز الامتحانات ولا تصدر شهادات telc الرسمية."
  },
  "Does practice or AI feedback guarantee that I will pass?": {
    "fr": "Les exercices ou les retours IA garantissent-ils la réussite ?",
    "ar": "هل التدريب يضمن النجاح؟"
  },
  "No. AI feedback is a learning aid and may contain errors; it is not an official telc assessment. Your result depends on your language skills and performance in the exam.": {
    "fr": "Non. Les retours IA sont une aide à l’apprentissage et peuvent contenir des erreurs. Ce ne sont pas des évaluations officielles telc. Votre résultat dépend de vos compétences et de votre performance à l’examen.",
    "ar": "لا. يساعدك التدريب والتصحيح على التحسّن، لكن النتيجة تعتمد على مستواك وأدائك في الامتحان."
  },
  "Official exam information and mock examinations": {
    "fr": "Informations officielles et examens blancs",
    "ar": "معلومات الامتحان والنماذج الرسمية"
  },
  "telc Deutsch B1": {
    "fr": "telc Deutsch B1",
    "ar": "telc Deutsch B1"
  },
  "telc Deutsch B2": {
    "fr": "telc Deutsch B2",
    "ar": "telc Deutsch B2"
  },
  "Start practising today": {
    "fr": "Commencez à pratiquer aujourd’hui",
    "ar": "ابدأ التدريب اليوم"
  },
  "Choose your level and try your first exercise.": {
    "fr": "Choisissez votre niveau et essayez votre premier exercice.",
    "ar": "اختر مستواك وابدأ بأول تمرين."
  },
  "German exam practice, with a clear next step.": {
    "fr": "Préparez l’examen d’allemand avec une prochaine étape claire.",
    "ar": "تدرّب على الألمانية للمستويين B1 وB2."
  },
  "Independent learning platform. Not affiliated with telc gGmbH.": {
    "fr": "Plateforme indépendante. Sans affiliation avec telc gGmbH.",
    "ar": "منصّة تعلّم مستقلة وغير تابعة لـ telc gGmbH."
  },
  "NEW · INTERACTIVE ORIENTATION": {
    "fr": "NOUVEAU · GUIDE INTERACTIF",
    "ar": "جديد · درس تفاعلي قصير"
  },
  "First understand TELC. Then practise with confidence.": {
    "fr": "Comprenez d’abord TELC. Entraînez-vous ensuite avec confiance.",
    "ar": "افهم TELC أولاً، ثم تدرّب بثقة."
  },
  "A guided, narrated course explains the complete exam structure, the real grading rules and every ZDeutsch workspace through short interactive actions.": {
    "fr": "Un guide accompagné d’une narration explique la structure complète de l’examen, les règles de notation et chaque espace ZDeutsch grâce à de courtes activités interactives.",
    "ar": "تعرّف على أقسام الامتحان وتوزيع الدرجات، وجرّب التمارين خطوة بخطوة."
  },
  "See all exam Teile and points": {
    "fr": "Découvrez toutes les parties et les points de l’examen",
    "ar": "تعرّف على الأقسام والدرجات"
  },
  "Change scores on an interactive Zertifikat": {
    "fr": "Modifiez les scores sur un certificat interactif",
    "ar": "جرّب حساب درجتك"
  },
  "Try the real Lesen, Hören, Schreiben and Sprechen screens": {
    "fr": "Essayez les espaces de lecture, d’écoute, d’écriture et d’oral",
    "ar": "جرّب تمارين القراءة والاستماع والكتابة والمحادثة"
  },
  "Learn what to focus on—and what to avoid": {
    "fr": "Découvrez les priorités et les erreurs à éviter",
    "ar": "اعرف أين تركّز وماذا تتجنّب"
  },
  "Start the TELC guide": {
    "fr": "Commencer le guide TELC",
    "ar": "ابدأ دليل TELC"
  },
  "About 12 minutes · Arabic, French or English · You can skip any step": {
    "fr": "Environ 12 minutes · Arabe, français ou anglais · Vous pouvez passer chaque étape",
    "ar": "حوالي 12 دقيقة · بالعربية أو الفرنسية أو الإنجليزية · يمكنك تجاوز أي خطوة"
  },
  "Understand the points": {
    "fr": "Comprendre les points",
    "ar": "افهم النقاط"
  },
  "AI voice": {
    "fr": "Voix IA",
    "ar": "شرح صوتي"
  },
  "Try it": {
    "fr": "Essayer",
    "ar": "جرّب بنفسك"
  },
  "A moderator is listening": {
    "fr": "Un modérateur écoute",
    "ar": "مشرف يستمع إلى المجموعة"
  },
  "Listen-only. You can mute your microphone at any time.": {
    "fr": "Écoute uniquement. Vous pouvez couper votre microphone à tout moment.",
    "ar": "الاستماع فقط. يمكنك إيقاف الميكروفون في أي وقت."
  },
  "Select at least one exam part.": {
    "fr": "Sélectionnez au moins une partie d’examen.",
    "ar": "اختر جزءًا واحدًا على الأقل."
  },
  "Which parts do you want to practice?": {
    "fr": "Quelles parties souhaitez-vous pratiquer ?",
    "ar": "ما الأجزاء التي تريد التدريب عليها؟"
  },
  "All written parts are selected. Uncheck any you want to leave out.": {
    "fr": "Toutes les parties écrites sont sélectionnées. Décochez celles que vous souhaitez exclure.",
    "ar": "جميع الأجزاء الكتابية محددة. يمكنك إلغاء تحديد أي جزء."
  },
  "Random theme": {
    "fr": "Thème aléatoire",
    "ar": "موضوع عشوائي"
  },
  "Subscribe to choose the themes yourself.": {
    "fr": "Abonnez-vous pour choisir vous-même les thèmes.",
    "ar": "اشترك لتختار المواضيع بنفسك."
  },
  "All parts": {
    "fr": "Toutes les parties",
    "ar": "جميع الأجزاء"
  },
  "One new exam per day is free. You can resume it anytime.": {
    "fr": "Un nouvel examen par jour est gratuit. Vous pouvez le reprendre à tout moment.",
    "ar": "يمكنك إنشاء امتحان واحد مجانًا كل يوم، ومتابعته في أي وقت."
  },
  "You have already created your free exam today. Subscribe to create more exams.": {
    "fr": "Vous avez déjà créé votre examen gratuit aujourd’hui. Abonnez-vous pour en créer d’autres.",
    "ar": "لقد أنشأت امتحانك المجاني لهذا اليوم. اشترك لإنشاء امتحانات أخرى."
  },
  "Available again": {
    "fr": "De nouveau disponible",
    "ar": "متاح مجددًا"
  },
  "Selected parts": {
    "fr": "Parties sélectionnées",
    "ar": "الأجزاء المحددة"
  },
  "Practice target reached": {
    "fr": "Objectif d’entraînement atteint",
    "ar": "حققت هدف التدريب"
  },
  "Keep practicing": {
    "fr": "Continuez à pratiquer",
    "ar": "واصل التدريب"
  },
  "Practice target: 60% of the selected points.": {
    "fr": "Objectif : 60 % des points sélectionnés.",
    "ar": "هدف التدريب: 60٪ من درجات الأجزاء المحددة."
  },
  "Your browser does not support fullscreen.": {
    "fr": "Votre navigateur ne prend pas en charge le plein écran.",
    "ar": "هذا المتصفح لا يدعم وضع ملء الشاشة."
  },
  "Participants": {
    "fr": "Participants",
    "ar": "المشاركون"
  },
  "Practice together": {
    "fr": "Pratiquer ensemble",
    "ar": "تدرّبوا معًا"
  },
  "Invite friends with the link. Up to 6 people.": {
    "fr": "Invitez des amis avec le lien. Jusqu’à 6 personnes.",
    "ar": "ادعُ أصدقاءك عبر الرابط. حتى 6 أشخاص."
  },
  "Turn on your microphone to talk to the group.": {
    "fr": "Activez votre microphone pour parler avec le groupe.",
    "ar": "فعّل الميكروفون للتحدث مع المجموعة."
  },
  "Quit exam": {
    "fr": "Quitter l’examen",
    "ar": "إلغاء الامتحان"
  },
  "Cancel this exam?": {
    "fr": "Annuler cet examen ?",
    "ar": "هل تريد إلغاء هذا الامتحان؟"
  },
  "This attempt will be canceled, without a score or certificate. Other group members can continue practicing.": {
    "fr": "Cette tentative sera annulée, sans score ni certificat. Les autres membres du groupe pourront continuer.",
    "ar": "ستُلغى هذه المحاولة دون نتيجة أو شهادة. يمكن لبقية أفراد المجموعة مواصلة التدريب."
  },
  "Exam canceled": {
    "fr": "Examen annulé",
    "ar": "تم إلغاء الامتحان"
  },
  "How would you like to practise?": {
    "fr": "Comment souhaitez-vous pratiquer ?",
    "ar": "كيف تريد التدريب؟"
  },
  "On my own": {
    "fr": "Seul",
    "ar": "بمفردي"
  },
  "Your own exam and results.": {
    "fr": "Votre propre examen et vos résultats.",
    "ar": "امتحانك ونتيجتك الخاصة."
  },
  "One exam, up to 6 people, voice chat.": {
    "fr": "Un examen, jusqu’à 6 personnes et une discussion vocale.",
    "ar": "امتحان واحد، حتى 6 أشخاص، ومحادثة صوتية."
  },
  "Group settings": {
    "fr": "Paramètres du groupe",
    "ar": "تدرّبوا معًا"
  },
  "Hören playback": {
    "fr": "Lecture audio d’écoute",
    "ar": "تشغيل تسجيلات الاستماع"
  },
  "Each person controls their audio": {
    "fr": "Chacun contrôle son audio",
    "ar": "كل شخص يتحكم في تسجيله"
  },
  "The owner controls audio for everyone": {
    "fr": "L’organisateur contrôle l’audio pour tous",
    "ar": "صاحب المجموعة يتحكم في التسجيل للجميع"
  },
  "Allow live answer sharing": {
    "fr": "Autoriser le partage des réponses en direct",
    "ar": "السماح بمشاركة الإجابات مباشرة"
  },
  "Each person chooses whether to share their answers.": {
    "fr": "Chacun choisit de partager ou non ses réponses.",
    "ar": "يختار كل شخص ما إذا كان يريد مشاركة إجاباته."
  },
  "Timer and audio pause are free.": {
    "fr": "La pause du chronomètre et de l’audio est gratuite.",
    "ar": "إيقاف المؤقت والتسجيل مؤقتًا متاح مجانًا."
  },
  "Have a room code?": {
    "fr": "Vous avez un code de salle ?",
    "ar": "هل لديك رمز مجموعة؟"
  },
  "Join group": {
    "fr": "Rejoindre le groupe",
    "ar": "انضم إلى المجموعة"
  },
  "Practise together": {
    "fr": "Pratiquer ensemble",
    "ar": "تدرّب مع الآخرين"
  },
  "Group": {
    "fr": "Groupe",
    "ar": "المجموعة"
  },
  "Copy invitation": {
    "fr": "Copier l’invitation",
    "ar": "نسخ الدعوة"
  },
  "Invitation copied": {
    "fr": "Invitation copiée",
    "ar": "تم نسخ الدعوة"
  },
  "I’m ready": {
    "fr": "Je suis prêt",
    "ar": "أنا جاهز"
  },
  "Not ready": {
    "fr": "Pas prêt",
    "ar": "غير جاهز بعد"
  },
  "Start together": {
    "fr": "Commencer ensemble",
    "ar": "ابدأ للجميع"
  },
  "Waiting for everyone to be ready.": {
    "fr": "En attente que tout le monde soit prêt.",
    "ar": "انتظر حتى يكون الجميع جاهزين."
  },
  "Owner": {
    "fr": "Organisateur",
    "ar": "صاحب المجموعة"
  },
  "You": {
    "fr": "Vous",
    "ar": "أنت"
  },
  "Connected": {
    "fr": "Connecté",
    "ar": "متصل"
  },
  "Reconnecting": {
    "fr": "Reconnexion",
    "ar": "جارٍ إعادة الاتصال"
  },
  "Microphone on": {
    "fr": "Microphone activé",
    "ar": "الميكروفون يعمل"
  },
  "Microphone off": {
    "fr": "Microphone désactivé",
    "ar": "الميكروفون مغلق"
  },
  "Enable voice chat": {
    "fr": "Activer la discussion vocale",
    "ar": "تفعيل المحادثة الصوتية"
  },
  "The microphone could not be enabled. Check your browser permissions.": {
    "fr": "Impossible d’activer le microphone. Vérifiez les autorisations de votre navigateur.",
    "ar": "تعذّر تشغيل الميكروفون. تحقق من إذن الميكروفون في المتصفح."
  },
  "Tap to hear the group": {
    "fr": "Touchez pour entendre le groupe",
    "ar": "اضغط للاستماع إلى المجموعة"
  },
  "Share my answers live": {
    "fr": "Partager mes réponses en direct",
    "ar": "مشاركة إجاباتي مباشرة"
  },
  "Follow the owner": {
    "fr": "Suivre l’organisateur",
    "ar": "متابعة صاحب المجموعة"
  },
  "Mute my microphone during Hören": {
    "fr": "Couper mon microphone pendant l’écoute",
    "ar": "كتم الميكروفون أثناء الاستماع"
  },
  "Make owner": {
    "fr": "Nommer organisateur",
    "ar": "نقل إدارة المجموعة"
  },
  "Leave group": {
    "fr": "Quitter le groupe",
    "ar": "مغادرة المجموعة"
  },
  "Answers for this part": {
    "fr": "Réponses pour cette partie",
    "ar": "إجابات هذا الجزء"
  },
  "Answers are private": {
    "fr": "Les réponses sont privées",
    "ar": "الإجابات خاصة"
  },
  "answered": {
    "fr": "répondu",
    "ar": "إجابة"
  },
  "Review together": {
    "fr": "Réviser ensemble",
    "ar": "راجعوا الإجابات معًا"
  },
  "The owner controls this setting.": {
    "fr": "L’organisateur contrôle ce paramètre.",
    "ar": "صاحب المجموعة يتحكم في هذا الإعداد."
  },
  "The owner paused the timer.": {
    "fr": "L’organisateur a mis le chronomètre en pause.",
    "ar": "أوقف صاحب المجموعة المؤقت مؤقتًا."
  },
  "Pause / resume group timer": {
    "fr": "Mettre en pause / reprendre le chronomètre du groupe",
    "ar": "إيقاف مؤقت المجموعة أو استئنافه"
  },
  "Request a timer pause": {
    "fr": "Demander une pause du chronomètre",
    "ar": "طلب إيقاف المؤقت مؤقتًا"
  },
  "A participant requested a pause.": {
    "fr": "Un participant a demandé une pause.",
    "ar": "طلب أحد المشاركين إيقاف المؤقت مؤقتًا."
  },
  "The exam is starting.": {
    "fr": "L’examen commence.",
    "ar": "سيبدأ الامتحان الآن."
  },
  "Tap to enable shared audio": {
    "fr": "Touchez pour activer l’audio partagé",
    "ar": "اضغط لتفعيل التسجيل المشترك"
  },
  "The owner controls playback. Your volume remains personal.": {
    "fr": "L’organisateur contrôle la lecture. Votre volume reste personnel.",
    "ar": "صاحب المجموعة يتحكم في التشغيل. يمكنك ضبط مستوى الصوت بنفسك."
  },
  "Reconnecting to your group…": {
    "fr": "Reconnexion à votre groupe…",
    "ar": "جارٍ إعادة الاتصال بالمجموعة…"
  },
  "This group is open in another tab. Reload here to reconnect.": {
    "fr": "Ce groupe est ouvert dans un autre onglet. Rechargez cette page pour vous reconnecter.",
    "ar": "المجموعة مفتوحة في علامة تبويب أخرى. أعد تحميل الصفحة للاتصال هنا."
  },
  "Hören exercises": {
    "fr": "Exercices d’écoute",
    "ar": "تمارين الاستماع"
  },
  "With audio": {
    "fr": "Avec audio",
    "ar": "مع التسجيل الصوتي"
  },
  "Codes": {
    "fr": "Codes",
    "ar": "الأكواد"
  },
  "Listening exercises with recordings. Selected by default.": {
    "fr": "Exercices d’écoute avec enregistrements. Sélectionnés par défaut.",
    "ar": "تمارين مع تسجيل صوتي. الخيار الافتراضي."
  },
  "Exercises from the Codes collection, without audio. Practice mode.": {
    "fr": "Exercices de la collection Codes, sans audio. Mode entraînement.",
    "ar": "تمارين من مجموعة الأكواد، دون تسجيل صوتي. وضع التدريب."
  },
  "parts": {
    "fr": "parties",
    "ar": "أجزاء"
  },
  "The texts in this recording are read once.": {
    "fr": "Les textes de cet enregistrement sont lus une fois.",
    "ar": "تستمع إلى هذا التسجيل مرة واحدة."
  },
  "The texts in this recording are read twice.": {
    "fr": "Les textes de cet enregistrement sont lus deux fois.",
    "ar": "تستمع إلى هذا التسجيل مرتين."
  },
  "Exam simulation": {
    "fr": "Simulation d’examen",
    "ar": "محاكاة الامتحان"
  },
  "ZDeutsch · German B1 & B2": {
    "fr": "ZDeutsch · Allemand B1 et B2",
    "ar": "ZDeutsch · B1 / B2"
  },
  "Ready for your exam?": {
    "fr": "Prêt pour votre examen ?",
    "ar": "جرّب امتحاناً كاملاً"
  },
  "Register to take the exam simulation. Practise a full written test with randomly mixed themes.": {
    "fr": "Inscrivez-vous pour accéder à la simulation. Pratiquez un examen écrit complet avec des thèmes mélangés au hasard.",
    "ar": "أنشئ حساباً مجانياً أو سجّل الدخول لبدء المحاكاة. تدرّب على القراءة والقواعد والاستماع والكتابة."
  },
  "Register for free": {
    "fr": "S’inscrire gratuitement",
    "ar": "أنشئ حساباً مجانياً"
  },
  "I already have an account": {
    "fr": "J’ai déjà un compte",
    "ar": "لديّ حساب بالفعل"
  },
  "Library": {
    "fr": "Bibliothèque",
    "ar": "المكتبة"
  },
  "Home": {
    "fr": "Accueil",
    "ar": "الرئيسية"
  },
  "Here is how your simulation works.": {
    "fr": "Voici le fonctionnement de votre simulation.",
    "ar": "كيف تجري المحاكاة؟"
  },
  "Nine exam parts. New themes every time. Complete the tasks in the order you prefer.": {
    "fr": "Neuf parties. De nouveaux thèmes à chaque fois. Réalisez les tâches dans l’ordre de votre choix.",
    "ar": "تسعة أجزاء بمواضيع مختلفة في كل امتحان. يمكنك التنقّل بينها بحرية."
  },
  "Get ready": {
    "fr": "Préparez-vous",
    "ar": "اختر مستواك"
  },
  "Read the instructions, choose B1 or B2, and check your headphones.": {
    "fr": "Lisez les consignes, choisissez B1 ou B2 et vérifiez votre casque.",
    "ar": "اختر B1 أو B2، واقرأ التعليمات، وتأكد من عمل السماعات."
  },
  "Take the exam": {
    "fr": "Passer l’examen",
    "ar": "أجب عن الأسئلة"
  },
  "Reading, language elements, listening and writing. Next takes you across sections too. Your answers are saved.": {
    "fr": "Lecture, éléments linguistiques, écoute et écriture. Le bouton Suivant permet aussi de changer de section. Vos réponses sont enregistrées.",
    "ar": "انتقل بين الأجزاء باستخدام «التالي» و«السابق». تُحفظ إجاباتك تلقائياً."
  },
  "Get your result": {
    "fr": "Obtenir votre résultat",
    "ar": "راجع نتيجتك"
  },
  "Objective tasks are scored automatically. Writing is assessed with AI. Download your ZDeutsch practice certificate as a PDF.": {
    "fr": "Les tâches objectives sont notées automatiquement. L’écriture est évaluée par l’IA. Téléchargez votre certificat d’entraînement ZDeutsch en PDF.",
    "ar": "تُصحَّح الإجابات والكتابة، ثم يمكنك مراجعة أخطائك وتنزيل شهادة التدريب."
  },
  "Configure your exam": {
    "fr": "Configurer votre examen",
    "ar": "إعداد الامتحان"
  },
  "Video explanation": {
    "fr": "Explication vidéo",
    "ar": "شرح بالفيديو"
  },
  "The video explains the exercises and learning tools on ZDeutsch.": {
    "fr": "La vidéo explique les exercices et les outils d’apprentissage de ZDeutsch.",
    "ar": "شرح خطوات التحضير والتنقّل ومراجعة النتيجة."
  },
  "Written practice exam · speaking excluded": {
    "fr": "Examen écrit d’entraînement · sans l’épreuve orale",
    "ar": "امتحان تدريبي كتابي · لا يشمل المحادثة"
  },
  "ZDeutsch practice simulation. Not an official telc certificate.": {
    "fr": "Simulation ZDeutsch. Certificat telc non officiel.",
    "ar": "شهادة تدريب من ZDeutsch، وليست شهادة telc رسمية."
  },
  "Timing & listening": {
    "fr": "Durée et écoute",
    "ar": "الوقت والاستماع"
  },
  "Reading + language elements": {
    "fr": "Lecture et éléments linguistiques",
    "ar": "القراءة والقواعد"
  },
  "min": {
    "fr": "min",
    "ar": "دقيقة"
  },
  "B1: part 1 once; parts 2 and 3 twice.": {
    "fr": "B1 : partie 1 une fois ; parties 2 et 3 deux fois.",
    "ar": "B1: الجزء الأول مرة واحدة، والجزآن الثاني والثالث مرتين."
  },
  "B2: each part once.": {
    "fr": "B2 : chaque partie une fois.",
    "ar": "B2: كل جزء مرة واحدة."
  },
  "Complete recordings already include instructions, pauses and repetitions. The entire file is played once.": {
    "fr": "Les enregistrements complets comprennent déjà les consignes, les pauses et les répétitions. Le fichier entier est lu une seule fois.",
    "ar": "تتضمن التسجيلات الكاملة التعليمات والتوقفات والتكرار. يُشغَّل الملف الكامل مرة واحدة."
  },
  "You can move freely between all parts in this simulation. The real exam uses fixed time blocks.": {
    "fr": "Vous pouvez passer librement d’une partie à l’autre dans cette simulation. L’examen réel utilise des plages horaires fixes.",
    "ar": "يمكنك التنقّل بين الأجزاء بحرية هنا. في الامتحان الرسمي، لكل قسم وقت محدد."
  },
  "Official practice test": {
    "fr": "Examen blanc officiel",
    "ar": "النموذج الرسمي"
  },
  "Set up your exam": {
    "fr": "Configurez votre examen",
    "ar": "جهّز امتحانك"
  },
  "Choose your level and practise alone or with friends. Timer and audio pause are free.": {
    "fr": "Choisissez votre niveau et entraînez-vous seul ou avec des amis. Les pauses du chronomètre et de l’audio sont gratuites.",
    "ar": "اختر مستواك وتدرّب بمفردك أو مع أصدقائك. إيقاف المؤقت والتسجيل مؤقتًا متاح مجانًا."
  },
  "Exam level": {
    "fr": "Niveau d’examen",
    "ar": "اختر المستوى"
  },
  "Practice options": {
    "fr": "Options d’entraînement",
    "ar": "خيارات التدريب"
  },
  "With subscription": {
    "fr": "Avec abonnement",
    "ar": "للمشتركين"
  },
  "Replay, translation and other learning tools require a subscription.": {
    "fr": "La répétition audio, la traduction et les autres outils d’apprentissage nécessitent un abonnement.",
    "ar": "إعادة التسجيل والترجمة وأدوات المساعدة الأخرى تتطلب اشتراكًا."
  },
  "Use a time limit": {
    "fr": "Utiliser une limite de temps",
    "ar": "استخدام المؤقّت"
  },
  "Allow timer pauses": {
    "fr": "Autoriser les pauses du chronomètre",
    "ar": "إيقاف المؤقّت مؤقتاً"
  },
  "Allow audio replay": {
    "fr": "Autoriser la répétition audio",
    "ar": "إعادة تشغيل التسجيل"
  },
  "Allow audio pauses": {
    "fr": "Autoriser les pauses audio",
    "ar": "إيقاف التسجيل مؤقتاً"
  },
  "Allow translations": {
    "fr": "Autoriser les traductions",
    "ar": "ترجمة النصوص"
  },
  "Allow read-aloud audio": {
    "fr": "Autoriser la lecture à voix haute",
    "ar": "قراءة النصوص بصوت مسموع"
  },
  "Allow word explanations": {
    "fr": "Autoriser les explications des mots",
    "ar": "شرح الكلمات"
  },
  "Start exam": {
    "fr": "Commencer l’examen",
    "ar": "ابدأ الامتحان"
  },
  "Your recent simulations": {
    "fr": "Vos simulations récentes",
    "ar": "امتحاناتك الأخيرة"
  },
  "Resume": {
    "fr": "Reprendre",
    "ar": "متابعة"
  },
  "Result": {
    "fr": "Résultat",
    "ar": "النتيجة"
  },
  "Preparing your exam.": {
    "fr": "Préparation de votre examen.",
    "ar": "جارٍ إعداد امتحانك"
  },
  "We are mixing complete exercises from different themes.": {
    "fr": "Nous mélangeons des exercices complets issus de différents thèmes.",
    "ar": "نختار تمارين من مواضيع مختلفة."
  },
  "You are ready.": {
    "fr": "Tout est prêt.",
    "ar": "امتحانك جاهز"
  },
  "Starting in": {
    "fr": "Début dans",
    "ar": "يبدأ خلال"
  },
  "Check your audio": {
    "fr": "Vérifiez votre audio",
    "ar": "اختبر السماعات"
  },
  "Play test tone": {
    "fr": "Jouer un son de test",
    "ar": "اختبار الصوت"
  },
  "Check your volume and headphones before starting.": {
    "fr": "Vérifiez le volume et votre casque avant de commencer.",
    "ar": "تأكد من وضوح الصوت قبل البدء."
  },
  "Recording is playing": {
    "fr": "Enregistrement en cours de lecture",
    "ar": "جارٍ تشغيل التسجيل"
  },
  "Saving …": {
    "fr": "Enregistrement…",
    "ar": "جارٍ الحفظ…"
  },
  "Could not save. Your answers are backed up locally. Please retry.": {
    "fr": "Impossible d’enregistrer. Vos réponses sont sauvegardées localement. Réessayez.",
    "ar": "تعذّر حفظ الإجابات على الخادم. حُفظت على جهازك. حاول مرة أخرى."
  },
  "Retry": {
    "fr": "Réessayer",
    "ar": "حاول مرة أخرى"
  },
  "Back": {
    "fr": "Retour",
    "ar": "السابق"
  },
  "Next": {
    "fr": "Suivant",
    "ar": "التالي"
  },
  "Submit exam": {
    "fr": "Envoyer l’examen",
    "ar": "تسليم الامتحان"
  },
  "Submit your exam now?": {
    "fr": "Envoyer votre examen maintenant ?",
    "ar": "هل تريد تسليم الامتحان؟"
  },
  "You cannot change your answers after submitting.": {
    "fr": "Vous ne pourrez plus modifier vos réponses après l’envoi.",
    "ar": "لن تتمكن من تغيير إجاباتك بعد التسليم."
  },
  "Keep working": {
    "fr": "Continuer à travailler",
    "ar": "متابعة الامتحان"
  },
  "unanswered": {
    "fr": "sans réponse",
    "ar": "دون إجابة"
  },
  "Time remaining": {
    "fr": "Temps restant",
    "ar": "الوقت المتبقي"
  },
  "No time limit": {
    "fr": "Sans limite de temps",
    "ar": "دون مؤقّت"
  },
  "Exam paused": {
    "fr": "Examen en pause",
    "ar": "الامتحان متوقف مؤقتاً"
  },
  "Pause": {
    "fr": "Pause",
    "ar": "إيقاف مؤقت"
  },
  "Start recording": {
    "fr": "Démarrer l’enregistrement",
    "ar": "تشغيل التسجيل"
  },
  "Replay": {
    "fr": "Réécouter",
    "ar": "إعادة التشغيل"
  },
  "Recording finished": {
    "fr": "Enregistrement terminé",
    "ar": "انتهى التسجيل"
  },
  "Audio could not load. Your answers are saved. Please retry to resume playback.": {
    "fr": "Impossible de charger l’audio. Vos réponses sont enregistrées. Réessayez pour reprendre la lecture.",
    "ar": "تعذّر تحميل التسجيل. إجاباتك محفوظة. حاول مرة أخرى لمتابعة الاستماع."
  },
  "Replay and pause are disabled in standard mode.": {
    "fr": "La répétition et la pause sont désactivées en mode standard.",
    "ar": "لا يمكن إعادة التسجيل أو إيقافه مؤقتاً في الوضع العادي."
  },
  "Playback": {
    "fr": "Lecture audio",
    "ar": "الاستماع"
  },
  "The current recording continues while you navigate to another part.": {
    "fr": "L’enregistrement en cours continue quand vous passez à une autre partie.",
    "ar": "يستمر التسجيل عند الانتقال إلى جزء آخر."
  },
  "Choose an answer": {
    "fr": "Choisissez une réponse",
    "ar": "اختر الإجابة"
  },
  "Gap": {
    "fr": "Trou",
    "ar": "فراغ"
  },
  "Headings": {
    "fr": "Titres",
    "ar": "العناوين"
  },
  "Situations": {
    "fr": "Situations",
    "ar": "المواقف"
  },
  "Advertisements": {
    "fr": "Annonces",
    "ar": "الإعلانات"
  },
  "Source text": {
    "fr": "Texte source",
    "ar": "النص الأصلي"
  },
  "Content points": {
    "fr": "Points de la consigne",
    "ar": "النقاط المطلوبة"
  },
  "Your text": {
    "fr": "Votre texte",
    "ar": "نصّك"
  },
  "Translate": {
    "fr": "Traduire",
    "ar": "ترجمة"
  },
  "Explain selection": {
    "fr": "Expliquer la sélection",
    "ar": "شرح النص المحدد"
  },
  "Read aloud": {
    "fr": "Lire à voix haute",
    "ar": "قراءة النص"
  },
  "This learning tool is temporarily unavailable. Please retry.": {
    "fr": "Cet outil d’apprentissage est temporairement indisponible. Réessayez.",
    "ar": "هذه الأداة غير متاحة حالياً. حاول مرة أخرى."
  },
  "Select a word or short sentence in this text first.": {
    "fr": "Sélectionnez d’abord un mot ou une courte phrase dans ce texte.",
    "ar": "حدّد كلمة أو جملة قصيرة من النص أولاً."
  },
  "Your exam results": {
    "fr": "Vos résultats d’examen",
    "ar": "نتيجة امتحانك"
  },
  "Correcting your exam.": {
    "fr": "Correction de votre examen.",
    "ar": "جارٍ تصحيح الامتحان"
  },
  "Your answers are saved. Your AI assessment and PDF are being prepared.": {
    "fr": "Vos réponses sont enregistrées. Votre évaluation IA et votre PDF sont en préparation.",
    "ar": "إجاباتك محفوظة. نُعدّ تقييم الكتابة وشهادة التدريب."
  },
  "Written practice exam passed": {
    "fr": "Examen écrit d’entraînement réussi",
    "ar": "اجتزت الامتحان الكتابي التدريبي"
  },
  "Written practice exam not passed": {
    "fr": "Examen écrit d’entraînement non réussi",
    "ar": "لم تصل إلى درجة النجاح"
  },
  "Practice mode": {
    "fr": "Mode entraînement",
    "ar": "وضع التدريب"
  },
  "Standard mode": {
    "fr": "Mode standard",
    "ar": "الوضع العادي"
  },
  "Download PDF certificate": {
    "fr": "Télécharger le certificat PDF",
    "ar": "تنزيل الشهادة PDF"
  },
  "Review answers": {
    "fr": "Vérifier les réponses",
    "ar": "مراجعة الإجابات"
  },
  "New simulation": {
    "fr": "Nouvelle simulation",
    "ar": "امتحان جديد"
  },
  "AI writing assessment": {
    "fr": "Évaluation IA de l’expression écrite",
    "ar": "تقييم الكتابة"
  },
  "Verify certificate": {
    "fr": "Vérifier le certificat",
    "ar": "التحقق من الشهادة"
  },
  "Valid ZDeutsch practice certificate": {
    "fr": "Certificat d’entraînement ZDeutsch valide",
    "ar": "شهادة تدريب ZDeutsch صالحة"
  },
  "Certificate not found": {
    "fr": "Certificat introuvable",
    "ar": "لم نعثر على الشهادة"
  },
  "Issued on": {
    "fr": "Délivré le",
    "ar": "تاريخ الإصدار"
  },
  "Participant": {
    "fr": "Participant",
    "ar": "المشارك"
  },
  "The written passing threshold is 135 out of 225 points (60%).": {
    "fr": "Le seuil de réussite de l’écrit est de 135 points sur 225 (60 %).",
    "ar": "درجة النجاح: 135 من 225 نقطة (60%)."
  },
  "Time is up. Your saved answers were submitted.": {
    "fr": "Le temps est écoulé. Vos réponses enregistrées ont été envoyées.",
    "ar": "انتهى الوقت. تم تسليم إجاباتك المحفوظة."
  },
  "Your exam changed in another window. Please reload this page.": {
    "fr": "Votre examen a été modifié dans une autre fenêtre. Rechargez cette page.",
    "ar": "تغيّر الامتحان في نافذة أخرى. أعد تحميل الصفحة."
  },
  "Review your scores and answers, then download your practice certificate.": {
    "fr": "Vérifiez vos scores et vos réponses, puis téléchargez votre certificat d’entraînement.",
    "ar": "راجع درجاتك وإجاباتك، ثم نزّل شهادة التدريب."
  },
  "Time": {
    "fr": "Temps",
    "ar": "الوقت"
  },
  "Learning tools": {
    "fr": "Outils d’apprentissage",
    "ar": "أدوات المساعدة"
  },
  "Scores by section": {
    "fr": "Scores par section",
    "ar": "درجاتك حسب القسم"
  },
  "telc Deutsch B1 & B2 Exam Simulation Online | ZDeutsch": {
    "fr": "Simulation en ligne des examens telc Deutsch B1 et B2 | ZDeutsch",
    "ar": "محاكاة امتحان telc Deutsch B1 وB2 عبر الإنترنت | ZDeutsch"
  },
  "Practise the written telc Deutsch B1 or B2 exam online: reading, language elements, listening and writing. Choose your parts, practise alone or in a group, and review your results.": {
    "fr": "Pratiquez l’examen écrit telc Deutsch B1 ou B2 en ligne : lecture, éléments linguistiques, écoute et écriture. Choisissez vos parties, entraînez-vous seul ou en groupe et consultez vos résultats.",
    "ar": "تدرّب على الجزء الكتابي من امتحان telc Deutsch B1 أو B2: القراءة، القواعد، الاستماع والكتابة. اختر الأقسام، تدرّب وحدك أو مع مجموعة، وراجع نتيجتك."
  },
  "Start simulation": {
    "fr": "Commencer la simulation",
    "ar": "ابدأ المحاكاة"
  },
  "Language": {
    "fr": "Langue",
    "ar": "اللغة"
  },
  "telc Deutsch exam practice": {
    "fr": "Entraînement à l’examen telc Deutsch",
    "ar": "محاكاة امتحان telc Deutsch"
  },
  "telc Deutsch B1 & B2.": {
    "fr": "telc Deutsch B1 et B2.",
    "ar": "محاكاة امتحان telc."
  },
  "Practise the written exam.": {
    "fr": "Pratiquez l’examen écrit.",
    "ar": "تدرّب على B1 وB2."
  },
  "Practise the written part of telc Deutsch B1 and B2 in one place. Answer questions, listen to recordings, and write your response before reviewing your results.": {
    "fr": "Pratiquez les épreuves écrites telc Deutsch B1 et B2 au même endroit. Répondez aux questions, écoutez les enregistrements et rédigez votre réponse avant de consulter vos résultats.",
    "ar": "محاكاة للجزء الكتابي من امتحان telc Deutsch B1 وB2، في مكان واحد. أجب عن الأسئلة، استمع إلى التسجيلات، واكتب نصك ثم راجع النتيجة."
  },
  "Create a free account to start. Without a subscription, you can create one new simulation per day.": {
    "fr": "Créez un compte gratuit pour commencer. Sans abonnement, vous pouvez créer une nouvelle simulation par jour.",
    "ar": "أنشئ حسابًا مجانيًا للبدء. يمكنك إنشاء محاكاة واحدة يوميًا دون اشتراك."
  },
  "You will choose the parts and settings before starting.": {
    "fr": "Vous choisirez les parties et les paramètres avant de commencer.",
    "ar": "ستختار الأقسام والإعدادات قبل بدء الامتحان."
  },
  "minutes for all written parts": {
    "fr": "minutes pour toutes les parties écrites",
    "ar": "دقيقة للجزء الكتابي الكامل"
  },
  "What can you practise?": {
    "fr": "Que pouvez-vous pratiquer ?",
    "ar": "ما الذي ستتدرّب عليه؟"
  },
  "Topics are selected randomly from available exercises. Take all written parts or choose the ones you want to practise.": {
    "fr": "Les thèmes sont sélectionnés au hasard parmi les exercices disponibles. Pratiquez toutes les parties écrites ou seulement celles de votre choix.",
    "ar": "تُختار المواضيع عشوائيًا من التمارين المتاحة. يمكنك إجراء جميع الأقسام أو اختيار ما تريد التدرّب عليه."
  },
  "Parts 1, 2 and 3: match headings, understand texts and connect situations with advertisements.": {
    "fr": "Parties 1, 2 et 3 : associez les titres, comprenez les textes et reliez les situations aux annonces.",
    "ar": "الأجزاء 1 و2 و3: مطابقة العناوين، فهم النصوص وربط المواقف بالإعلانات."
  },
  "book": {
    "fr": "book",
    "ar": "book"
  },
  "Sprachbausteine": {
    "fr": "Sprachbausteine",
    "ar": "Sprachbausteine"
  },
  "Language elements": {
    "fr": "Éléments linguistiques",
    "ar": "القواعد والمفردات"
  },
  "Parts 1 and 2: choose the right words to complete the gaps.": {
    "fr": "Parties 1 et 2 : choisissez les mots pour compléter les trous.",
    "ar": "الجزآن 1 و2: اختر الكلمات المناسبة لإكمال الفراغات."
  },
  "layers": {
    "fr": "layers",
    "ar": "layers"
  },
  "Parts 1, 2 and 3: answer questions with audio recordings, or choose code exercises.": {
    "fr": "Parties 1, 2 et 3 : répondez aux questions avec des enregistrements audio, ou choisissez les exercices de codes.",
    "ar": "الأجزاء 1 و2 و3: أجب عن الأسئلة مع تسجيلات صوتية، أو اختر تمارين الأكواد."
  },
  "headphones": {
    "fr": "headphones",
    "ar": "headphones"
  },
  "Write your response and receive corrections and feedback to help improve your text.": {
    "fr": "Rédigez votre réponse et obtenez des corrections et des conseils pour améliorer votre texte.",
    "ar": "اكتب إجابتك واحصل على تصحيح وملاحظات تساعدك على تحسين نصك."
  },
  "pen": {
    "fr": "pen",
    "ar": "pen"
  },
  "Start in three steps": {
    "fr": "Commencez en trois étapes",
    "ar": "ثلاث خطوات للبدء"
  },
  "Choose your settings": {
    "fr": "Choisissez vos paramètres",
    "ar": "اختر الإعدادات"
  },
  "Select B1 or B2 and the parts you want to take. All written parts are selected by default.": {
    "fr": "Sélectionnez B1 ou B2 et les parties souhaitées. Toutes les parties écrites sont sélectionnées par défaut.",
    "ar": "اختر B1 أو B2، وحدّد الأقسام التي تريدها. جميع الأقسام الكتابية محدّدة افتراضيًا."
  },
  "Practise at your pace": {
    "fr": "Entraînez-vous à votre rythme",
    "ar": "ابدأ التدريب"
  },
  "Move freely between parts. Use the timer, pause it when needed, and pause listening audio too.": {
    "fr": "Passez librement d’une partie à l’autre. Utilisez le chronomètre, mettez-le en pause si nécessaire et mettez aussi l’audio en pause.",
    "ar": "تنقّل بين الأقسام بحرية. استخدم المؤقّت، أو أوقفه مؤقتًا عند الحاجة، وأوقف الصوت مؤقتًا أيضًا."
  },
  "Review your results": {
    "fr": "Consultez vos résultats",
    "ar": "راجع النتيجة"
  },
  "Once all corrections, including writing, are ready, review your scores and download a PDF practice record with a QR code.": {
    "fr": "Une fois toutes les corrections terminées, y compris l’écriture, consultez vos scores et téléchargez un relevé d’entraînement PDF avec un code QR.",
    "ar": "بعد اكتمال التصحيح، بما فيه الكتابة، راجع درجاتك وحمّل سجلّ النتيجة بصيغة PDF مع رمز QR."
  },
  "Practise with friends": {
    "fr": "Pratiquez avec des amis",
    "ar": "تدرّب مع أصدقائك"
  },
  "Create a room and share its link with up to 6 people. Talk together while each person answers in their own exam.": {
    "fr": "Créez une salle et partagez son lien avec jusqu’à 6 personnes. Discutez ensemble pendant que chacun répond à son propre examen.",
    "ar": "أنشئ غرفة وشارك رابطها مع مجموعة تصل إلى 6 أشخاص. تحدثوا معًا، وليجب كل شخص في نسخته الخاصة."
  },
  "Audio plays individually by default. The room owner can choose to control playback for the group.": {
    "fr": "Par défaut, l’audio est individuel. L’organisateur peut contrôler la lecture pour le groupe.",
    "ar": "الصوت يعمل لكل شخص على حدة افتراضيًا؛ يمكن لصاحب الغرفة التحكم في تشغيله للمجموعة."
  },
  "Live answer sharing is optional and requires participants’ consent.": {
    "fr": "Le partage des réponses en direct est facultatif et nécessite le consentement des participants.",
    "ar": "مشاركة الإجابات المباشرة اختيارية، وبموافقة المشاركين."
  },
  "Start free. Choose what suits you.": {
    "fr": "Commencez gratuitement. Choisissez ce qui vous convient.",
    "ar": "ابدأ مجانًا. واختر ما يناسبك."
  },
  "Without a subscription": {
    "fr": "Sans abonnement",
    "ar": "دون اشتراك"
  },
  "With a subscription": {
    "fr": "Avec un abonnement",
    "ar": "مع اشتراك"
  },
  "One new simulation per day, your choice of parts, timer and audio pausing, and group practice.": {
    "fr": "Une nouvelle simulation par jour, les parties de votre choix, les pauses du chronomètre et de l’audio, et l’entraînement en groupe.",
    "ar": "محاكاة جديدة واحدة يوميًا، مع اختيار الأقسام، إيقاف المؤقّت والصوت مؤقتًا، والتدريب الجماعي."
  },
  "Create more simulations, choose topics for each part, and use translation, word explanations and audio replay.": {
    "fr": "Créez davantage de simulations, choisissez les thèmes de chaque partie et utilisez la traduction, les explications des mots et la répétition audio.",
    "ar": "أنشئ المزيد من المحاكاة، واختر المواضيع لكل قسم، واستخدم أدوات الترجمة وشرح الكلمات وإعادة تشغيل الصوت."
  },
  "Questions about the simulation": {
    "fr": "Questions sur la simulation",
    "ar": "أسئلة عن المحاكاة"
  },
  "Does the simulation include the speaking exam?": {
    "fr": "La simulation comprend-elle l’épreuve orale ?",
    "ar": "هل تشمل المحاكاة الجزء الشفهي؟"
  },
  "No. It covers reading, language elements, listening and writing. You can practise speaking in the Sprechen section of ZDeutsch.": {
    "fr": "Non. Elle couvre la lecture, les éléments linguistiques, l’écoute et l’écriture. Vous pouvez pratiquer l’oral dans la section Sprechen de ZDeutsch.",
    "ar": "لا. تشمل القراءة، القواعد والمفردات، الاستماع والكتابة. يمكنك التدرّب على المحادثة في قسم Sprechen بالموقع."
  },
  "Can I take only some parts?": {
    "fr": "Puis-je passer seulement certaines parties ?",
    "ar": "هل يمكنني اختيار بعض الأقسام فقط؟"
  },
  "Yes, including without a subscription. All parts are selected by default, and you can change them before starting. Subscribers can also choose topics instead of random selection.": {
    "fr": "Oui, même sans abonnement. Toutes les parties sont sélectionnées par défaut et vous pouvez les modifier avant de commencer. Les abonnés peuvent aussi choisir les thèmes.",
    "ar": "نعم، حتى دون اشتراك. تُحدّد جميع الأقسام افتراضيًا، ويمكنك تغييرها قبل البدء. يمكن للمشتركين أيضًا اختيار المواضيع بدل الاختيار العشوائي."
  },
  "How long is the simulation?": {
    "fr": "Quelle est la durée de la simulation ?",
    "ar": "كم تستغرق المحاكاة؟"
  },
  "The timer for all written parts is 150 minutes at B1 and 140 minutes at B2. The time changes when you choose fewer parts. You can pause the timer.": {
    "fr": "Le chronomètre de toutes les épreuves écrites dure 150 minutes en B1 et 140 minutes en B2. La durée change si vous choisissez moins de parties. Vous pouvez le mettre en pause.",
    "ar": "المؤقّت للجزء الكتابي الكامل هو 150 دقيقة في B1 و140 دقيقة في B2. يتغيّر الوقت عند اختيار بعض الأقسام. يمكنك إيقاف المؤقّت مؤقتًا."
  },
  "Do I need an account or a subscription?": {
    "fr": "Ai-je besoin d’un compte ou d’un abonnement ?",
    "ar": "هل أحتاج إلى حساب أو اشتراك؟"
  },
  "You need a free account to save your answers and results. Without a subscription, you can create one new simulation per day. The limit resets at midnight in Morocco.": {
    "fr": "Un compte gratuit est nécessaire pour enregistrer vos réponses et vos résultats. Sans abonnement, vous pouvez créer une nouvelle simulation par jour. La limite est réinitialisée à minuit au Maroc.",
    "ar": "تحتاج إلى حساب مجاني لحفظ إجاباتك ونتيجتك. دون اشتراك، يمكنك إنشاء محاكاة جديدة واحدة في اليوم. يُجدّد الحد عند منتصف الليل بتوقيت المغرب."
  },
  "How is writing corrected?": {
    "fr": "Comment l’écriture est-elle corrigée ?",
    "ar": "كيف يُصحّح قسم الكتابة؟"
  },
  "It uses the same correction method as the writing exercises on ZDeutsch, including AI feedback. The final result appears once every correction is ready.": {
    "fr": "La méthode est la même que pour les exercices d’écriture ZDeutsch, avec des retours IA. Le résultat final apparaît quand toutes les corrections sont prêtes.",
    "ar": "يستخدم التصحيح الطريقة نفسها المستخدمة في تمارين الكتابة على ZDeutsch، مع ملاحظات من الذكاء الاصطناعي. لا تظهر النتيجة النهائية قبل اكتمال التصحيح."
  },
  "Is the PDF an official telc certificate?": {
    "fr": "Le PDF est-il un certificat telc officiel ?",
    "ar": "هل ملف PDF شهادة telc رسمية؟"
  },
  "No. It is a ZDeutsch practice record with your result and a verification QR code. It is not an official language certificate or a replacement for the telc exam.": {
    "fr": "Non. C’est un relevé d’entraînement ZDeutsch avec votre résultat et un code QR de vérification. Il ne remplace ni un certificat officiel de langue ni l’examen telc.",
    "ar": "لا. هو سجلّ تدريب من ZDeutsch مع النتيجة ورمز QR للتحقّق. لا يُعدّ شهادة لغة رسمية أو بديلًا عن امتحان telc."
  },
  "Ready to practise?": {
    "fr": "Prêt à pratiquer ?",
    "ar": "جاهز للتدريب؟"
  },
  "Choose your level, then set up your simulation.": {
    "fr": "Choisissez votre niveau, puis configurez votre simulation.",
    "ar": "اختر مستواك ثم اضبط المحاكاة كما تريد."
  },
  "ZDeutsch is an independent practice platform. This simulation is not an official telc exam and does not award an official telc certificate.": {
    "fr": "ZDeutsch est une plateforme indépendante. Cette simulation n’est pas un examen officiel telc et ne délivre aucun certificat officiel telc.",
    "ar": "ZDeutsch منصة تدريب مستقلة. هذه المحاكاة ليست امتحان telc رسميًا ولا تمنح شهادة telc رسمية."
  },
  "ZDEUTSCH BOOKS": {
    "fr": "LIVRES ZDEUTSCH",
    "ar": "كتب ZDeutsch"
  },
  "Prefer studying with books?": {
    "fr": "Vous préférez étudier avec des livres ?",
    "ar": "تفضّل التحضير بالكتب؟"
  },
  "Order our B1 and B2 books, updated for the latest telc changes. We’ll deliver them to you in Morocco.": {
    "fr": "Commandez nos livres B1 et B2, mis à jour selon les dernières évolutions telc. Livraison au Maroc.",
    "ar": "اطلب كتبنا للمستويين B1 وB2، مع أحدث تعديلات telc. نرسلها إليك داخل المغرب."
  },
  "Order on WhatsApp": {
    "fr": "Commander sur WhatsApp",
    "ar": "اطلب عبر واتساب"
  },
  "Preview the books": {
    "fr": "Découvrir les livres",
    "ar": "تصفّح الكتب"
  },
  "12 sample pages, including the front and back covers.": {
    "fr": "12 pages d’exemple, couvertures avant et arrière comprises.",
    "ar": "12 صفحة للمعاينة، تشمل الغلافين الأمامي والخلفي."
  },
  "Level": {
    "fr": "Niveau",
    "ar": "المستوى"
  },
  "Book": {
    "fr": "Livre",
    "ar": "الكتاب"
  },
  "Previous page": {
    "fr": "Page précédente",
    "ar": "الصفحة السابقة"
  },
  "Next page": {
    "fr": "Page suivante",
    "ar": "الصفحة التالية"
  },
  "Zoom": {
    "fr": "Zoom",
    "ar": "تكبير"
  },
  "Full screen": {
    "fr": "Plein écran",
    "ar": "ملء الشاشة"
  },
  "Opening your book…": {
    "fr": "Ouverture de votre livre…",
    "ar": "جارٍ فتح المعاينة…"
  },
  "The next book preview is on its way.": {
    "fr": "L’aperçu du prochain livre arrive bientôt.",
    "ar": "ستتوفر المعاينة قريباً."
  },
  "The preview could not load. Please try again.": {
    "fr": "Impossible de charger l’aperçu. Veuillez réessayer.",
    "ar": "تعذّر تحميل المعاينة. حاول مرة أخرى."
  },
  "Back to ZDeutsch": {
    "fr": "Retour à ZDeutsch",
    "ar": "العودة إلى ZDeutsch"
  },
  "Delivery in Morocco only.": {
    "fr": "Livraison au Maroc uniquement.",
    "ar": "التوصيل داخل المغرب فقط."
  },
  "Access to ZDeutsch exercises for the plan duration.": {
    "fr": "Accès aux exercices ZDeutsch pendant la durée de la formule."
  },
  "Payment was not confirmed": {
    "fr": "Paiement non confirmé"
  },
  "Subscription expired": {
    "fr": "Abonnement expiré"
  },
  "Join me on ZDeutsch for practical TELC exam training": {
    "fr": "Rejoignez-moi sur ZDeutsch pour préparer l’examen TELC"
  },
  "Your plan-change request was sent to the admin for review.": {
    "fr": "Votre demande de changement de formule a été envoyée à l’administrateur."
  },
  "1 day + 6 days": {
    "fr": "1 jour + 6 jours"
  },
  "days": {
    "fr": "jours"
  },
  "Free": {
    "fr": "Gratuit"
  },
  "Hello, I selected the {0} plan for {1} and would like the bank transfer details.": {
    "fr": "Bonjour, j’ai choisi la formule {0} pour {1} et je souhaite obtenir les coordonnées bancaires."
  },
  "Choose a plan before continuing to payment.": {
    "fr": "Choisissez une formule avant de passer au paiement."
  },
  "Open dashboard": {
    "fr": "Ouvrir le tableau de bord"
  },
  "How bank transfer works": {
    "fr": "Fonctionnement du virement bancaire"
  },
  "Your request was sent to the admin for review.": {
    "fr": "Votre demande a été envoyée à l’administrateur."
  },
  "Back to dashboard": {
    "fr": "Retour au tableau de bord"
  },
  "Request a level change": {
    "fr": "Demander un changement de niveau"
  },
  "An admin reviews this change so your plan and statistics remain accurate.": {
    "fr": "Un administrateur vérifie ce changement pour préserver l’exactitude de votre formule et de vos statistiques."
  },
  "Send request": {
    "fr": "Envoyer la demande"
  },
  "No active plan": {
    "fr": "Aucune formule active"
  },
  "We could not load your recent exams.": {
    "fr": "Impossible de charger vos examens récents."
  },
  "Preparing": {
    "fr": "En préparation"
  },
  "Ready": {
    "fr": "Prêt"
  },
  "In progress": {
    "fr": "En cours"
  },
  "Paused": {
    "en": "Paused",
    "fr": "En pause",
    "ar": "موقوف"
  },
  "Being assessed": {
    "fr": "En cours d’évaluation"
  },
  "Completed": {
    "fr": "Terminé"
  },
  "Canceled": {
    "fr": "Annulé"
  },
  "Preparation failed": {
    "fr": "Échec de la préparation"
  },
  "Your five most recent saved attempts.": {
    "fr": "Vos cinq dernières tentatives enregistrées."
  },
  "Loading your exams…": {
    "fr": "Chargement de vos examens…"
  },
  "No recorded exams yet. Your attempts will appear here.": {
    "fr": "Aucun examen enregistré. Vos tentatives apparaîtront ici."
  },
  "Recent exam attempts": {
    "fr": "Tentatives d’examen récentes"
  },
  "Date": {
    "fr": "Date"
  },
  "Status": {
    "fr": "Statut"
  },
  "Exam": {
    "fr": "Examen"
  },
  "New exam": {
    "fr": "Nouvel examen"
  },
  "Results": {
    "fr": "Résultats",
    "ar": "النتائج"
  },
  "Download exam certificate": {
    "fr": "Télécharger le certificat d’examen"
  },
  "Hello, {0}": {
    "fr": "Bonjour, {0}"
  },
  "Your telc guide": {
    "fr": "Votre guide telc"
  },
  "Get to know the exam before you start practising.": {
    "fr": "Découvrez l’examen avant de commencer vos exercices."
  },
  "Open the guide": {
    "fr": "Ouvrir le guide"
  },
  "Loading your words…": {
    "fr": "Chargement de vos mots…"
  },
  "Results by skill": {
    "fr": "Résultats par compétence"
  },
  "Your activity this year": {
    "fr": "Votre activité cette année"
  },
  "Year": {
    "fr": "Année"
  },
  "activities": {
    "fr": "activités"
  },
  ", exam day": {
    "fr": ", jour d’examen"
  },
  "Less": {
    "fr": "Moins"
  },
  "More": {
    "fr": "Plus"
  },
  "Exam day": {
    "fr": "Jour d’examen"
  },
  "Choose a valid date range.": {
    "fr": "Choisissez une période valide."
  },
  "Due cards": {
    "fr": "Cartes à réviser"
  },
  "Date range": {
    "fr": "Période"
  },
  "All saved words": {
    "fr": "Tous les mots enregistrés"
  },
  "Vocabulary practice": {
    "fr": "Entraînement au vocabulaire"
  },
  "Match every German word with its definition. Click, tap, or drag and drop.": {
    "fr": "Associez chaque mot allemand à sa définition. Cliquez, touchez ou glissez-déposez."
  },
  "Mistakes": {
    "fr": "Erreurs"
  },
  "Matches": {
    "fr": "Associations"
  },
  "Pairs": {
    "fr": "Paires"
  },
  "Cards": {
    "fr": "Cartes"
  },
  "Due for review": {
    "fr": "À réviser"
  },
  "Saved in date range": {
    "fr": "Enregistrés pendant la période"
  },
  "From": {
    "fr": "Du"
  },
  "New game": {
    "fr": "Nouvelle partie"
  },
  "Preparing your game…": {
    "fr": "Préparation de votre partie…"
  },
  "Best": {
    "fr": "Meilleur résultat"
  },
  "Perfect streak": {
    "fr": "Série sans erreur"
  },
  "Wörter": {
    "fr": "Mots",
    "en": "Words"
  },
  "I don't know": {
    "fr": "Je ne sais pas"
  },
  "Bedeutungen": {
    "fr": "Définitions",
    "en": "Definitions"
  },
  "Show translation": {
    "fr": "Afficher la traduction"
  },
  "Not enough saved words": {
    "fr": "Pas assez de mots enregistrés"
  },
  "Save words while reading, then return here to start a game.": {
    "fr": "Enregistrez des mots pendant la lecture, puis revenez pour commencer une partie."
  },
  "Round complete": {
    "fr": "Manche terminée"
  },
  "Perfect round!": {
    "fr": "Manche parfaite !"
  },
  "Well done!": {
    "fr": "Bravo !"
  },
  "Play again": {
    "fr": "Rejouer"
  },
  "Read texts and answer questions.": {
    "fr": "Lisez les textes et répondez aux questions."
  },
  "Practise with recordings or statements.": {
    "fr": "Pratiquez avec des enregistrements ou des affirmations."
  },
  "Practise writing and get feedback.": {
    "fr": "Pratiquez l’écriture et obtenez des conseils."
  },
  "Practise speaking with others.": {
    "fr": "Pratiquez l’oral avec d’autres personnes."
  },
  "Mehrere Versionen": {
    "fr": "Plusieurs versions",
    "en": "Multiple versions"
  },
  "Wählen Sie die Version, die Sie jetzt bearbeiten möchten.": {
    "fr": "Choisissez la version sur laquelle vous souhaitez travailler.",
    "en": "Choose the version you want to practise."
  },
  "Dialog schließen": {
    "fr": "Fermer la fenêtre",
    "en": "Close dialog"
  },
  "Letzte Note": {
    "fr": "Dernier score",
    "en": "Latest score"
  },
  "Noch nicht begonnen": {
    "fr": "Pas encore commencé",
    "en": "Not started yet"
  },
  "Prüfungssimulation": {
    "fr": "Simulation d’examen",
    "en": "Exam simulation"
  },
  "Bereit für eine komplette Prüfung?": {
    "fr": "Prêt pour un examen complet ?",
    "en": "Ready for a complete exam?"
  },
  "Trainieren Sie mit gemischten Aufgaben, Schreibfeedback und Ihrem ZDeutsch-Übungszertifikat.": {
    "fr": "Entraînez-vous avec des exercices variés, des retours sur l’écriture et votre certificat d’entraînement ZDeutsch.",
    "en": "Practise with mixed exercises, writing feedback and your ZDeutsch practice certificate."
  },
  "9 Teile": {
    "fr": "9 parties",
    "en": "9 parts"
  },
  "Minuten": {
    "fr": "minutes",
    "en": "minutes"
  },
  "Simulation starten": {
    "fr": "Commencer la simulation",
    "en": "Start simulation"
  },
  "Practice library": {
    "fr": "Bibliothèque d’exercices"
  },
  "Was möchten Sie heute trainieren?": {
    "fr": "Que souhaitez-vous pratiquer aujourd’hui ?",
    "en": "What would you like to practise today?"
  },
  "Wählen Sie einen Prüfungsbereich und trainieren Sie auf Ihrem Niveau.": {
    "fr": "Choisissez une compétence et entraînez-vous à votre niveau.",
    "en": "Choose a skill and practise at your level."
  },
  "Prüfungsbereiche": {
    "fr": "compétences",
    "en": "skills"
  },
  "Settings": {
    "fr": "Paramètres",
    "ar": "الإعدادات"
  },
  "Auch:": {
    "en": "Also:",
    "fr": "Aussi :",
    "ar": "أيضاً:"
  },
  "Mit einem aktiven Zugang verfügbar": {
    "en": "Available with active access",
    "fr": "Disponible avec un accès actif",
    "ar": "متاح باشتراك فعّال"
  },
  "Fortschritt": {
    "en": "Progress",
    "fr": "Progression",
    "ar": "التقدّم"
  },
  "Live sprechen ·": {
    "en": "Speak live ·",
    "fr": "Discussion en direct ·",
    "ar": "محادثة مباشرة ·"
  },
  "Sprechräume": {
    "en": "Speaking rooms",
    "fr": "Salles de discussion",
    "ar": "غرف المحادثة"
  },
  "Hören Sie zu, sprechen Sie mit anderen und üben Sie gemeinsam.": {
    "en": "Listen, speak with others and practise together.",
    "fr": "Écoutez, discutez et entraînez-vous ensemble.",
    "ar": "استمع وتحدث مع الآخرين وتدرّب معهم."
  },
  "Öffnen": {
    "en": "Open",
    "fr": "Ouvrir",
    "ar": "فتح"
  },
  "Thema": {
    "en": "Theme",
    "fr": "Thème",
    "ar": "الموضوع"
  },
  "Raumname": {
    "en": "Room name",
    "fr": "Nom de la salle",
    "ar": "اسم الغرفة"
  },
  "Abbrechen": {
    "en": "Cancel",
    "fr": "Annuler",
    "ar": "إلغاء"
  },
  "Neuen Raum erstellen": {
    "en": "Create a new room",
    "fr": "Créer une salle",
    "ar": "إنشاء غرفة"
  },
  "Ein Thema wählen und loslegen": {
    "en": "Choose a theme and get started",
    "fr": "Choisissez un thème et commencez",
    "ar": "اختر موضوعاً وابدأ"
  },
  "Noch keine offenen Räume": {
    "en": "No open rooms yet",
    "fr": "Aucune salle ouverte",
    "ar": "لا توجد غرف مفتوحة بعد"
  },
  "Erstellen Sie den ersten Raum.": {
    "en": "Create the first room.",
    "fr": "Créez la première salle.",
    "ar": "أنشئ أول غرفة."
  },
  "Live": {
    "en": "Live",
    "fr": "En direct",
    "ar": "مباشر"
  },
  "Beitreten →": {
    "en": "Join →",
    "fr": "Rejoindre →",
    "ar": "انضم →"
  },
  "Erneut versuchen": {
    "en": "Try again",
    "fr": "Réessayer",
    "ar": "أعد المحاولة"
  },
  "PDF + QR": {
    "en": "PDF + QR",
    "fr": "PDF + QR",
    "ar": "PDF + QR"
  },
  "TELC Deutsch · B1 & B2": {
    "en": "TELC German · B1 & B2",
    "fr": "TELC allemand · B1 et B2",
    "ar": "TELC الألمانية · B1 وB2"
  },
  "-Übungen ·": {
    "en": " exercises ·",
    "fr": "exercices ·",
    "ar": "تمارين ·"
  },
  "Mit Audio": {
    "en": "With audio",
    "fr": "Avec audio",
    "ar": "مع تسجيل صوتي"
  },
  "Komplette Themen": {
    "en": "Complete themes",
    "fr": "Thèmes complets",
    "ar": "مواضيع كاملة"
  },
  "Richtig oder falsch": {
    "en": "True or false",
    "fr": "Vrai ou faux",
    "ar": "صحيح أو خطأ"
  },
  "Übungen durchsuchen": {
    "en": "Search exercises",
    "fr": "Rechercher des exercices",
    "ar": "ابحث في التمارين"
  },
  "Live-Räume": {
    "en": "Live rooms",
    "fr": "Salles en direct",
    "ar": "غرف مباشرة"
  },
  "TELC Deutschvorbereitung · B1 & B2": {
    "en": "TELC German preparation · B1 & B2",
    "fr": "Préparation à TELC allemand · B1 et B2",
    "ar": "التحضير لـ TELC الألمانية · B1 وB2"
  },
  "Bibliothek": {
    "en": "Library",
    "fr": "Bibliothèque",
    "ar": "المكتبة"
  },
  "Anmelden": {
    "en": "Log in",
    "fr": "Se connecter",
    "ar": "تسجيل الدخول"
  },
  "Registrieren": {
    "en": "Register",
    "fr": "S’inscrire",
    "ar": "إنشاء حساب"
  },
  "Prüfung abgeben": {
    "en": "Submit exam",
    "fr": "Envoyer l’examen",
    "ar": "إرسال الامتحان"
  },
  "Abgeben": {
    "en": "Submit",
    "fr": "Envoyer",
    "ar": "إرسال"
  },
  "Niveau": {
    "en": "Level",
    "fr": "Niveau",
    "ar": "المستوى"
  },
  "Mitgliedschaft": {
    "en": "Membership",
    "fr": "Abonnement",
    "ar": "الاشتراك"
  },
  "Korrekturvorschläge": {
    "en": "Correction suggestions",
    "fr": "Suggestions de correction",
    "ar": "اقتراحات التصحيح"
  },
  "Verbesserungen für die Übungsbibliothek einreichen.": {
    "en": "Submit improvements to the exercise library.",
    "fr": "Proposez des améliorations pour la bibliothèque d’exercices.",
    "ar": "أرسل تحسينات لمكتبة التمارين."
  },
  "Sprechtraining": {
    "en": "Speaking practice",
    "fr": "Entraînement à l’oral",
    "ar": "التدرّب على المحادثة"
  },
  "Zurück": {
    "en": "Back",
    "fr": "Retour",
    "ar": "رجوع"
  },
  "Aufgabe": {
    "en": "Task",
    "fr": "Consigne",
    "ar": "المهمة"
  },
  "Warum ist das richtig?": {
    "en": "Why is this correct?",
    "fr": "Pourquoi est-ce correct ?",
    "ar": "لماذا هذه الإجابة صحيحة؟"
  },
  "Arabic Translation": {
    "en": "Arabic translation",
    "fr": "Traduction arabe",
    "ar": "الترجمة العربية"
  },
  "Arabic": {
    "en": "Arabic",
    "fr": "Arabe",
    "ar": "العربية"
  },
  "No results available.": {
    "en": "No results available.",
    "fr": "Aucun résultat disponible.",
    "ar": "لا توجد نتائج متاحة."
  },
  "Please select a theme first.": {
    "en": "Please select a theme first.",
    "fr": "Choisissez d’abord un thème.",
    "ar": "اختر موضوعاً أولاً."
  },
  "Total points": {
    "en": "Total points",
    "fr": "Total des points",
    "ar": "مجموع النقاط"
  },
  "Percent": {
    "en": "Percent",
    "fr": "Pourcentage",
    "ar": "النسبة"
  },
  "Antworten ansehen": {
    "en": "Review answers",
    "fr": "Vérifier les réponses",
    "ar": "عرض الإجابات"
  },
  "Teil erneut öffnen": {
    "en": "Reopen part",
    "fr": "Rouvrir la partie",
    "ar": "فتح الجزء مجدداً"
  },
  "Überschriften": {
    "en": "Headings",
    "fr": "Titres",
    "ar": "العناوين"
  },
  "Lesetext": {
    "en": "Reading text",
    "fr": "Texte de lecture",
    "ar": "نص القراءة"
  },
  "Aufgaben": {
    "en": "Tasks",
    "fr": "Tâches",
    "ar": "المهام"
  },
  "Wählen Sie die richtige Lösung": {
    "en": "Choose the correct answer",
    "fr": "Choisissez la bonne réponse",
    "ar": "اختر الإجابة الصحيحة"
  },
  "Anzeigen": {
    "en": "Advertisements",
    "fr": "Annonces",
    "ar": "الإعلانات"
  },
  "Situationen": {
    "en": "Situations",
    "fr": "Situations",
    "ar": "المواقف"
  },
  "Wählen Sie ein Wort": {
    "en": "Choose a word",
    "fr": "Choisissez un mot",
    "ar": "اختر كلمة"
  },
  "No words available. Re-extract this exam.": {
    "en": "No words available. Re-extract this exam.",
    "fr": "Aucun mot disponible. Importez à nouveau cet examen.",
    "ar": "لا توجد كلمات متاحة. أعد استخراج هذا الامتحان."
  },
  "Weiter": {
    "en": "Next",
    "fr": "Suivant",
    "ar": "التالي"
  },
  "Aussage verborgen": {
    "en": "Statement hidden",
    "fr": "Affirmation masquée",
    "ar": "العبارة مخفية"
  },
  "Hördatei wird weitergeladen.": {
    "en": "Audio is still loading.",
    "fr": "Le chargement de l’audio continue.",
    "ar": "ما زال التسجيل الصوتي قيد التحميل."
  },
  "Hördatei wird geladen.": {
    "en": "Loading audio.",
    "fr": "Chargement de l’audio.",
    "ar": "جارٍ تحميل التسجيل الصوتي."
  },
  "Bitte alle Aussagen beantworten.": {
    "en": "Please answer every statement.",
    "fr": "Répondez à toutes les affirmations.",
    "ar": "أجب عن جميع العبارات."
  },
  "Antworten prüfen": {
    "en": "Check answers",
    "fr": "Vérifier les réponses",
    "ar": "تحقّق من الإجابات"
  },
  "Teilergebnisse": {
    "en": "Part results",
    "fr": "Résultats par partie",
    "ar": "نتائج الأجزاء"
  },
  "Right answer": {
    "en": "Correct answer",
    "fr": "Bonne réponse",
    "ar": "الإجابة الصحيحة"
  },
  "Die Hördatei konnte nicht abgespielt werden.": {
    "en": "The audio could not be played.",
    "fr": "Impossible de lire l’audio.",
    "ar": "تعذّر تشغيل التسجيل الصوتي."
  },
  "Hördatei ist bereit.": {
    "en": "Audio is ready.",
    "fr": "L’audio est prêt.",
    "ar": "التسجيل الصوتي جاهز."
  },
  "Die Hördatei konnte nicht geladen werden.": {
    "en": "The audio could not load.",
    "fr": "Impossible de charger l’audio.",
    "ar": "تعذّر تحميل التسجيل الصوتي."
  },
  "Raum wird geöffnet …": {
    "en": "Opening the room…",
    "fr": "Ouverture de la salle…",
    "ar": "جارٍ فتح الغرفة…"
  },
  "Raum starten": {
    "en": "Start room",
    "fr": "Ouvrir la salle",
    "ar": "ابدأ الغرفة"
  },
  "Antwort schreiben": {
    "en": "Write an answer",
    "fr": "Rédiger une réponse",
    "ar": "اكتب إجابة"
  },
  "Ihre Antwort": {
    "en": "Your answer",
    "fr": "Votre réponse",
    "ar": "إجابتك"
  },
  "Sonderzeichen:": {
    "en": "Special characters:",
    "fr": "Caractères spéciaux :",
    "ar": "الحروف الخاصة:"
  },
  "Für diese Ebene ist noch keine Schreiben-Aufgabe verfügbar.": {
    "en": "No writing task is available for this level yet.",
    "fr": "Aucune tâche d’écriture disponible pour ce niveau.",
    "ar": "لا توجد مهمة كتابة لهذا المستوى بعد."
  },
  "Noch keine Aufgaben vorhanden.": {
    "en": "No tasks yet.",
    "fr": "Aucune tâche pour le moment.",
    "ar": "لا توجد مهام بعد."
  },
  "Die ausgewählte Schreiben-Aufgabe wurde nicht gefunden.": {
    "en": "The selected writing task was not found.",
    "fr": "La tâche d’écriture sélectionnée est introuvable.",
    "ar": "لم نعثر على مهمة الكتابة المختارة."
  },
  "database/shreiben.json wurde nicht gefunden.": {
    "en": "Writing exercises could not load.",
    "fr": "Impossible de charger les exercices d’écriture.",
    "ar": "تعذّر تحميل تمارين الكتابة."
  },
  "Translating…": {
    "en": "Translating…",
    "fr": "Traduction…",
    "ar": "جارٍ الترجمة…"
  },
  "Translation": {
    "en": "Translation",
    "fr": "Traduction",
    "ar": "الترجمة"
  },
  "Play Audio": {
    "en": "Play audio",
    "fr": "Écouter le texte",
    "ar": "تشغيل الصوت"
  },
  "Preparing…": {
    "en": "Preparing…",
    "fr": "Préparation…",
    "ar": "جارٍ التجهيز…"
  },
  "Save & underline": {
    "en": "Save & underline",
    "fr": "Enregistrer et souligner",
    "ar": "حفظ وإضافة خط"
  },
  "Explaining…": {
    "en": "Explaining…",
    "fr": "Explication…",
    "ar": "جارٍ الشرح…"
  },
  "Try saving again": {
    "en": "Try saving again",
    "fr": "Réessayer l’enregistrement",
    "ar": "أعد محاولة الحفظ"
  },
  "Add to Flashcards": {
    "en": "Add to flashcards",
    "fr": "Ajouter aux cartes",
    "ar": "إضافة إلى البطاقات"
  },
  "Remove from Flashcards": {
    "en": "Remove from flashcards",
    "fr": "Retirer des cartes",
    "ar": "إزالة من البطاقات"
  },
  "Listening…": {
    "en": "Listening…",
    "fr": "Lecture audio…",
    "ar": "جارٍ التشغيل…"
  },
  "Listen": {
    "en": "Listen",
    "fr": "Écouter",
    "ar": "استمع"
  },
  "Regenerating…": {
    "en": "Regenerating…",
    "fr": "Nouvelle explication…",
    "ar": "جارٍ إعادة الشرح…"
  },
  "AI Regenerate": {
    "en": "Regenerate with AI",
    "fr": "Régénérer avec l’IA",
    "ar": "إعادة الشرح بالذكاء الاصطناعي"
  },
  "Removing…": {
    "en": "Removing…",
    "fr": "Suppression…",
    "ar": "جارٍ الإزالة…"
  },
  "Word explanation": {
    "fr": "Explication du mot",
    "ar": "شرح الكلمة"
  },
  "Selected text explanation": {
    "fr": "Explication du texte sélectionné",
    "ar": "شرح النص المحدّد"
  },
  "Close selected text explanation": {
    "fr": "Fermer l’explication",
    "ar": "إغلاق الشرح"
  },
  "Selected text": {
    "fr": "Texte sélectionné",
    "ar": "النص المحدّد"
  },
  "Grammar & structure": {
    "fr": "Grammaire et structure",
    "ar": "القواعد والتركيب"
  },
  "Saved and underlined": {
    "fr": "Enregistré et souligné",
    "ar": "تم الحفظ وإضافة خط"
  },
  "Loading explanation…": {
    "fr": "Chargement de l’explication…",
    "ar": "جارٍ تحميل الشرح…"
  },
  "Meaning": {
    "fr": "Sens",
    "ar": "المعنى"
  },
  "Examples": {
    "fr": "Exemples",
    "ar": "أمثلة"
  },
  "Word": {
    "fr": "Mot",
    "ar": "الكلمة"
  },
  "Base form: {0}": {
    "fr": "Forme de base : {0}",
    "ar": "الصيغة الأساسية: {0}"
  },
  "your language": {
    "fr": "votre langue",
    "ar": "لغتك"
  },
  "Text audio": {
    "fr": "Audio du texte",
    "ar": "صوت النص"
  },
  "Resume Audio": {
    "fr": "Reprendre l’audio",
    "ar": "متابعة الصوت"
  },
  "Playing…": {
    "fr": "Lecture…",
    "ar": "جارٍ التشغيل…"
  },
  "Close translation": {
    "fr": "Fermer la traduction",
    "ar": "إغلاق الترجمة"
  },
  "Could not explain this word.": {
    "fr": "Impossible d’expliquer ce mot.",
    "ar": "تعذّر شرح هذه الكلمة."
  },
  "Could not save this flashcard.": {
    "fr": "Impossible d’enregistrer cette carte.",
    "ar": "تعذّر حفظ هذه البطاقة."
  },
  "Could not translate this text.": {
    "fr": "Impossible de traduire ce texte.",
    "ar": "تعذّر ترجمة هذا النص."
  },
  "Could not play this text.": {
    "fr": "Impossible de lire ce texte à voix haute.",
    "ar": "تعذّر تشغيل صوت هذا النص."
  },
  "Could not explain this selection.": {
    "fr": "Impossible d’expliquer cette sélection.",
    "ar": "تعذّر شرح هذا النص المحدّد."
  },
  "Could not save this explanation.": {
    "fr": "Impossible d’enregistrer cette explication.",
    "ar": "تعذّر حفظ هذا الشرح."
  },
  "Full name is required.": {
    "fr": "Saisissez votre nom complet."
  },
  "Provide a valid email and password (min 6 chars).": {
    "fr": "Saisissez un e-mail valide et un mot de passe d’au moins 6 caractères."
  },
  "Choose a valid mother language.": {
    "fr": "Choisissez votre langue dans la liste."
  },
  "Could not create your account. Please try again.": {
    "fr": "Impossible de créer votre compte. Réessayez."
  },
  "Invalid credentials.": {
    "fr": "E-mail ou mot de passe incorrect."
  },
  "Email and password are required.": {
    "fr": "Saisissez votre e-mail et votre mot de passe."
  },
  "Your account is disabled. Contact admin.": {
    "fr": "Votre compte est désactivé. Contactez l’assistance."
  },
  "Too many attempts. Please wait 15 minutes and try again.": {
    "fr": "Trop de tentatives. Attendez 15 minutes et réessayez."
  },
  "Email already registered.": {
    "fr": "Cet e-mail est déjà enregistré. Connectez-vous ou réinitialisez votre mot de passe."
  },
  "Enter a valid email address.": {
    "fr": "Saisissez une adresse e-mail valide."
  },
  "Email service is not configured yet. Please contact support.": {
    "fr": "Le service e-mail est indisponible. Contactez l’assistance."
  },
  "Could not send reset code. Please try again later.": {
    "fr": "Impossible d’envoyer le code. Réessayez plus tard."
  },
  "If the email exists, a reset code was sent. Enter the code below with your new password.": {
    "fr": "Si cet e-mail correspond à un compte, un code a été envoyé. Saisissez-le ci-dessous avec votre nouveau mot de passe."
  },
  "Enter a valid 6-digit reset code.": {
    "fr": "Saisissez le code valide à 6 chiffres."
  },
  "New password must be at least 6 characters.": {
    "fr": "Le nouveau mot de passe doit contenir au moins 6 caractères."
  },
  "Password confirmation does not match.": {
    "fr": "Les mots de passe ne correspondent pas."
  },
  "Invalid reset request.": {
    "fr": "Code incorrect ou expiré. Demandez un nouveau code."
  },
  "Reset code is invalid.": {
    "fr": "Code incorrect ou expiré. Demandez un nouveau code."
  },
  "This reset code expired. Request a new code.": {
    "fr": "Ce code a expiré. Demandez un nouveau code."
  },
  "Password updated. You can now log in.": {
    "fr": "Mot de passe mis à jour. Vous pouvez vous connecter."
  },
  "Your invitation is ready. Create your account so it counts for your friend.": {
    "fr": "Votre invitation est prête. Créez votre compte pour que votre inscription soit comptabilisée pour votre ami."
  },
  "Niveau wählen": {
    "en": "Choose level",
    "fr": "Choisir le niveau",
    "ar": "اختر المستوى"
  },
  "Target level": {
    "fr": "Niveau visé",
    "ar": "المستوى المستهدف"
  },
  "Übungen filtern": {
    "en": "Filter exercises",
    "fr": "Filtrer les exercices",
    "ar": "تصفية التمارين"
  },
  "Gesamtprüfung": {
    "en": "Full exam",
    "fr": "Examen complet",
    "ar": "الامتحان الكامل"
  },
  "Teil 1": {
    "en": "Part 1",
    "fr": "Partie 1",
    "ar": "الجزء 1"
  },
  "Teil 2": {
    "en": "Part 2",
    "fr": "Partie 2",
    "ar": "الجزء 2"
  },
  "Teil 3": {
    "en": "Part 3",
    "fr": "Partie 3",
    "ar": "الجزء 3"
  },
  "Neu": {
    "en": "New",
    "fr": "Nouveau",
    "ar": "جديد"
  },
  "Thema öffnen": {
    "en": "Open theme",
    "fr": "Ouvrir le thème",
    "ar": "افتح الموضوع"
  },
  "Version wählen": {
    "en": "Choose version",
    "fr": "Choisir la version",
    "ar": "اختر النسخة"
  },
  "Teil öffnen": {
    "en": "Open part",
    "fr": "Ouvrir la partie",
    "ar": "افتح الجزء"
  },
  "Aufgabe öffnen": {
    "en": "Open task",
    "fr": "Ouvrir la tâche",
    "ar": "افتح المهمة"
  },
  "Gezieltes Training für {0}.": {
    "en": "Focused practice for {0}.",
    "fr": "Entraînement ciblé pour {0}.",
    "ar": "تدريب مخصص لـ {0}."
  },
  "Prüfungsteile": {
    "en": "exam parts",
    "fr": "parties d’examen",
    "ar": "أجزاء الامتحان"
  },
  "Versionen": {
    "en": "versions",
    "fr": "versions",
    "ar": "نسخ"
  },
  "GESAMT": {
    "en": "FULL",
    "fr": "COMPLET",
    "ar": "كامل"
  },
  "Default": {
    "en": "Standard",
    "fr": "Standard",
    "ar": "أساسي"
  },
  "Version {0}": {
    "fr": "Version {0}",
    "ar": "نسخة {0}"
  },
  "vorbereitet": {
    "en": "prepared",
    "fr": "préparé",
    "ar": "مجهّز"
  },
  "Geübt": {
    "en": "Practised",
    "fr": "Pratiqué",
    "ar": "تم التدريب"
  },
  "Close menu": {
    "fr": "Fermer le menu",
    "ar": "إغلاق القائمة"
  },
  "Open menu": {
    "fr": "Ouvrir le menu",
    "ar": "فتح القائمة"
  },
  "Open dashboard for {0}": {
    "fr": "Ouvrir le tableau de bord de {0}",
    "ar": "فتح لوحة تحكم {0}"
  },
  "Log out {0}": {
    "fr": "Déconnecter {0}",
    "ar": "تسجيل خروج {0}"
  },
  "Verbleibende Prüfungszeit": {
    "en": "Time remaining",
    "fr": "Temps restant",
    "ar": "وقت الامتحان المتبقي"
  },
  "Vollbild": {
    "en": "Full screen",
    "fr": "Plein écran",
    "ar": "ملء الشاشة"
  },
  "Vollbild verlassen": {
    "en": "Exit full screen",
    "fr": "Quitter le plein écran",
    "ar": "الخروج من ملء الشاشة"
  },
  "Prüfungsbibliothek": {
    "en": "Exercise library",
    "fr": "Bibliothèque d’exercices",
    "ar": "مكتبة التمارين"
  },
  "Wählen Sie oben einen Bereich oder ein Niveau.": {
    "en": "Choose a skill or level above.",
    "fr": "Choisissez une compétence ou un niveau ci-dessus.",
    "ar": "اختر مهارة أو مستوى من الأعلى."
  },
  "Wählen Sie eine Übung aus der Liste.": {
    "en": "Choose an exercise from the list.",
    "fr": "Choisissez un exercice dans la liste.",
    "ar": "اختر تمريناً من القائمة."
  },
  "Wählen oder verwalten Sie Ihren ZDeutsch-Plan.": {
    "en": "Choose or manage your ZDeutsch plan.",
    "fr": "Choisissez ou gérez votre formule ZDeutsch.",
    "ar": "اختر خطتك على ZDeutsch أو أدِرها."
  },
  "Zahlung": {
    "en": "Payment",
    "fr": "Paiement",
    "ar": "الدفع"
  },
  "Wählen Sie Ihre Zahlungsmethode.": {
    "en": "Choose your payment method.",
    "fr": "Choisissez votre mode de paiement.",
    "ar": "اختر طريقة الدفع."
  },
  "Konto": {
    "en": "Account",
    "fr": "Compte",
    "ar": "الحساب"
  },
  "Verwalten Sie Ihren ZDeutsch-Zugang.": {
    "en": "Manage your ZDeutsch access.",
    "fr": "Gérez votre accès ZDeutsch.",
    "ar": "أدِر حسابك على ZDeutsch."
  },
  "Zur Themenbibliothek": {
    "en": "Back to library",
    "fr": "Retour à la bibliothèque",
    "ar": "العودة للمكتبة"
  },
  "Leseeinstellungen öffnen": {
    "en": "Open reading settings",
    "fr": "Ouvrir les paramètres de lecture",
    "ar": "فتح إعدادات القراءة"
  },
  "Leseeinstellungen": {
    "en": "Reading settings",
    "fr": "Paramètres de lecture",
    "ar": "إعدادات القراءة"
  },
  "Aufgaben öffnen": {
    "en": "Open tasks",
    "fr": "Ouvrir les tâches",
    "ar": "فتح المهام"
  },
  "Select a theme": {
    "fr": "Choisissez un thème",
    "ar": "اختر موضوعاً"
  },
  "Your score overview.": {
    "fr": "Aperçu de vos scores.",
    "ar": "نظرة عامة على نتائجك."
  },
  "Zurücksetzen": {
    "en": "Reset",
    "fr": "Réinitialiser",
    "ar": "إعادة الضبط"
  },
  "Ergebnis": {
    "en": "Results",
    "fr": "Résultats",
    "ar": "النتيجة"
  },
  "Timer": {
    "en": "Timer",
    "fr": "Chronomètre",
    "ar": "المؤقت"
  },
  "Font size": {
    "fr": "Taille du texte",
    "ar": "حجم النص"
  },
  "Textgröße": {
    "en": "Text size",
    "fr": "Taille du texte",
    "ar": "حجم النص"
  },
  "Keep practicing.": {
    "fr": "Continuez à pratiquer.",
    "ar": "واصل التدريب."
  },
  "Passed": {
    "fr": "Réussi",
    "ar": "ناجح"
  },
  "Not passed": {
    "fr": "Non réussi",
    "ar": "لم تنجح"
  },
  "To": {
    "fr": "Au",
    "ar": "إلى"
  },
  "Search {0} exercises": {
    "fr": "Rechercher des exercices {0}",
    "ar": "ابحث في تمارين {0}"
  },
  "{0} of {1}": {
    "fr": "{0} sur {1}",
    "ar": "{0} من {1}"
  },
  "Loading…": {
    "fr": "Chargement…",
    "ar": "جارٍ التحميل…"
  },
  "The first {0} exercises are free. Translation, AI feedback, and the remaining exercises require an active subscription.": {
    "fr": "Les {0} premiers exercices sont gratuits. Les traductions, les retours IA et les autres exercices nécessitent un abonnement actif."
  },
  "{0} Prüfungsteile": {
    "en": "{0} exam parts",
    "fr": "{0} parties d’examen",
    "ar": "{0} أجزاء امتحان"
  },
  "{0} Prüfungsteile · {1} Versionen": {
    "en": "{0} exam parts · {1} versions",
    "fr": "{0} parties d’examen · {1} versions",
    "ar": "{0} أجزاء امتحان · {1} نسخ"
  },
  "{0} Prüfungsteile · Mit Audio": {
    "en": "{0} exam parts · With audio",
    "fr": "{0} parties d’examen · Avec audio",
    "ar": "{0} أجزاء امتحان · مع صوت"
  },
  "This correction was saved in another language. Correct your text again to get feedback in your current language.": {
    "fr": "Cette correction a été enregistrée dans une autre langue. Corrigez à nouveau votre texte pour obtenir des retours dans votre langue actuelle.",
    "ar": "حُفظ هذا التصحيح بلغة أخرى. صحّح نصك مجدداً للحصول على ملاحظات بلغتك الحالية."
  },
  "Schriftgröße": {
    "en": "Text size",
    "fr": "Taille du texte",
    "ar": "حجم النص"
  },
  "Einstellungen": {
    "en": "Settings",
    "fr": "Paramètres",
    "ar": "الإعدادات"
  },
  "Exam results": {
    "fr": "Résultats d’examen",
    "ar": "نتائج الامتحان"
  },
  "Detailed scores": {
    "fr": "Scores détaillés",
    "ar": "النتائج المفصّلة"
  },
  "Retry exam": {
    "fr": "Recommencer l’examen",
    "ar": "أعد الامتحان"
  },
  "Back to modules": {
    "fr": "Retour aux compétences",
    "ar": "العودة إلى المهارات"
  },
  "Select a task": {
    "fr": "Choisissez une tâche",
    "ar": "اختر مهمة"
  },
  "Alle Sprechthemen": {
    "en": "All speaking themes",
    "fr": "Tous les thèmes d’oral",
    "ar": "جميع مواضيع المحادثة"
  },
  "Schreibaufgaben": {
    "en": "Writing tasks",
    "fr": "Tâches d’écriture",
    "ar": "مهام الكتابة"
  },
  "Schreiben-Aufgaben": {
    "en": "Writing tasks",
    "fr": "Tâches d’écriture",
    "ar": "مهام الكتابة"
  },
  "Verwaltung": {
    "en": "Administration",
    "fr": "Administration",
    "ar": "الإدارة"
  },
  "Lesen öffnen": {
    "en": "Open reading",
    "fr": "Ouvrir la lecture",
    "ar": "افتح القراءة"
  },
  "مرحبا بك": {
    "en": "Welcome",
    "fr": "Bienvenue"
  },
  "مجتمع تيليجرام": {
    "en": "Telegram community",
    "fr": "Communauté Telegram"
  },
  "مرحبا بك في مجموعة ZDeutsch على تيليجرام. شارك أي ملاحظة أو تصحيح.": {
    "en": "Welcome to the ZDeutsch Telegram community. Share your feedback or corrections.",
    "fr": "Bienvenue dans la communauté Telegram de ZDeutsch. Partagez vos remarques ou corrections."
  },
  "شكرا على المجهود 🙏": {
    "en": "Thanks for your help 🙏",
    "fr": "Merci pour votre aide 🙏"
  },
  "اكتب رسالتك ثم أرسلها إلى مجموعة تيليجرام": {
    "en": "Write your message, then send it to the Telegram group",
    "fr": "Écrivez votre message, puis envoyez-le au groupe Telegram"
  },
  "اكتب الرسالة أولاً.": {
    "en": "Write a message first.",
    "fr": "Écrivez d’abord un message."
  },
  "انضم إلى تيليجرام": {
    "en": "Join Telegram",
    "fr": "Rejoindre Telegram"
  },
  "انتظر {0} ثانية": {
    "en": "Wait {0} seconds",
    "fr": "Attendez {0} secondes"
  },
  "موافق، الدخول إلى الموقع": {
    "en": "Continue to ZDeutsch",
    "fr": "Continuer vers ZDeutsch"
  },
  "يمكنك المتابعة بعد {0} ثانية": {
    "en": "Continue in {0} seconds",
    "fr": "Continuez dans {0} secondes"
  },
  "يمكنك الآن الدخول إلى الموقع.": {
    "en": "You can now continue to ZDeutsch.",
    "fr": "Vous pouvez maintenant continuer vers ZDeutsch."
  },
  "عرض شعار المجتمع": {
    "en": "View the community logo",
    "fr": "Afficher le logo de la communauté"
  },
  "فتح مجموعة تيليجرام": {
    "en": "Open the Telegram group",
    "fr": "Ouvrir le groupe Telegram"
  },
  "إرسال": {
    "en": "Send",
    "fr": "Envoyer"
  },
  "إغلاق": {
    "en": "Close",
    "fr": "Fermer"
  },
  "مجتمع تيليجرام الرسمي": {
    "en": "Official Telegram community",
    "fr": "Communauté Telegram officielle"
  },
  "انضم للمجموعة للتحديثات السريعة، الدعم، وتصحيح الأخطاء.": {
    "en": "Join the group for updates, support and corrections.",
    "fr": "Rejoignez le groupe pour les mises à jour, l’assistance et les corrections."
  },
  "اقترح تعديلا": {
    "en": "Suggest a change",
    "fr": "Proposer une modification"
  },
  "اقتراح تعديل أو موضوع جديد": {
    "en": "Suggest a change or new theme",
    "fr": "Proposer une modification ou un nouveau thème"
  },
  "اكتب اقتراحك بوضوح، ثم انسخه وافتح مجموعة تيليجرام لإرساله.": {
    "en": "Write your suggestion, then copy it and open Telegram to send it.",
    "fr": "Écrivez votre suggestion, puis copiez-la et ouvrez Telegram pour l’envoyer."
  },
  "كل الملاحظات مرحب بها: أخطاء تقنية، تعديلات، أو أفكار جديدة.": {
    "en": "Share technical issues, corrections or new ideas.",
    "fr": "Partagez vos problèmes techniques, corrections ou nouvelles idées."
  },
  "مهم: اشرح المشكلة أو الفكرة باختصار وبشكل مباشر.": {
    "en": "Describe the issue or idea briefly and clearly.",
    "fr": "Décrivez le problème ou l’idée brièvement et clairement."
  },
  "اكتب التفاصيل هنا...": {
    "en": "Write the details here…",
    "fr": "Écrivez les détails ici…"
  },
  "نسخ الاقتراح": {
    "en": "Copy suggestion",
    "fr": "Copier la suggestion"
  },
  "يرجى كتابة التفاصيل أولاً.": {
    "en": "Write the details first.",
    "fr": "Écrivez d’abord les détails."
  },
  "تم النسخ. افتح تيليجرام والصق الاقتراح.": {
    "en": "Copied. Open Telegram and paste your suggestion.",
    "fr": "Copié. Ouvrez Telegram et collez votre suggestion."
  },
  "الصفحة: {0}": {
    "en": "Page: {0}",
    "fr": "Page : {0}"
  },
  "النوع: تعديل أو موضوع جديد": {
    "en": "Type: change or new theme",
    "fr": "Type : modification ou nouveau thème"
  },
  "DH": {
    "fr": "DH",
    "ar": "د.م."
  },
  "PayPal": {
    "fr": "PayPal",
    "ar": "PayPal"
  },
  "B1": {
    "fr": "B1",
    "ar": "B1"
  },
  "B2": {
    "fr": "B2",
    "ar": "B2"
  },
  "Flashcard practice": {
    "fr": "Entraînement avec les cartes",
    "ar": "التدرّب بالبطاقات"
  },
  "Wortschatztraining": {
    "fr": "Entraînement au vocabulaire",
    "en": "Vocabulary practice",
    "ar": "تدريب المفردات"
  },
  "Deutsch schneller abrufen": {
    "fr": "Retrouvez les mots allemands plus rapidement",
    "en": "Recall German words faster",
    "ar": "تذكّر الكلمات الألمانية بسرعة"
  },
  "Antwort zeigen": {
    "fr": "Afficher la réponse",
    "en": "Show answer",
    "ar": "إظهار الإجابة"
  },
  "Noch üben": {
    "fr": "À réviser",
    "en": "Keep practising",
    "ar": "أحتاج إلى التدريب"
  },
  "Gewusst": {
    "fr": "Je savais",
    "en": "I knew it",
    "ar": "عرفتها"
  },
  "Keine gespeicherten Wörter vorhanden.": {
    "fr": "Aucun mot enregistré.",
    "en": "No saved words yet.",
    "ar": "لا توجد كلمات محفوظة بعد."
  },
  "PDF": {
    "fr": "PDF",
    "ar": "PDF"
  },
  "telc ·": {
    "fr": "telc ·",
    "ar": "telc ·"
  },
  "Learning activity heatmap": {
    "fr": "Calendrier de l’activité d’apprentissage",
    "ar": "خريطة نشاط التعلّم"
  },
  "Matching game board": {
    "fr": "Plateau du jeu d’association",
    "ar": "لوحة لعبة المطابقة"
  },
  "Subscription plans": {
    "fr": "Formules d’abonnement",
    "ar": "خطط الاشتراك"
  },
  "Control what users see and what each activated plan includes.": {
    "fr": "Gérez les formules visibles et ce qu’elles comprennent après activation.",
    "ar": "أدِر الخطط الظاهرة وما يتضمنه كل اشتراك بعد تفعيله."
  },
  "Create plan": {
    "fr": "Créer une formule",
    "ar": "إنشاء خطة"
  },
  "Close plan editor": {
    "fr": "Fermer l’éditeur de formule",
    "ar": "إغلاق محرر الخطة"
  },
  "Plan code": {
    "fr": "Code de la formule",
    "ar": "رمز الخطة"
  },
  "zdeutsch_premium": {
    "fr": "zdeutsch_premium",
    "ar": "zdeutsch_premium"
  },
  "Name": {
    "fr": "Nom",
    "ar": "الاسم"
  },
  "ZDeutsch Premium": {
    "fr": "ZDeutsch Premium",
    "ar": "ZDeutsch Premium"
  },
  "Price (MAD)": {
    "fr": "Prix (MAD)",
    "ar": "السعر (د.م.)"
  },
  "Duration (days)": {
    "fr": "Durée (jours)",
    "ar": "المدة (أيام)"
  },
  "Included AI balance (USD)": {
    "fr": "Crédit IA inclus (USD)",
    "ar": "رصيد الذكاء الاصطناعي (دولار)"
  },
  "Referral requirement (trial only)": {
    "fr": "Invitations requises (essai uniquement)",
    "ar": "الدعوات المطلوبة (للتجربة فقط)"
  },
  "Display order": {
    "fr": "Ordre d’affichage",
    "ar": "ترتيب العرض"
  },
  "Visible and available for purchase": {
    "fr": "Visible et disponible à l’achat",
    "ar": "ظاهرة ومتاحة للشراء"
  },
  "Plan information": {
    "fr": "Informations de la formule",
    "ar": "معلومات الخطة"
  },
  "Explain what is included in this plan.": {
    "fr": "Expliquez ce que cette formule comprend.",
    "ar": "وضّح ما تتضمنه هذه الخطة."
  },
  "Loading plans…": {
    "fr": "Chargement des formules…",
    "ar": "جارٍ تحميل الخطط…"
  },
  "Price": {
    "fr": "Prix",
    "ar": "السعر"
  },
  "Duration": {
    "fr": "Durée",
    "ar": "المدة"
  },
  "AI balance": {
    "fr": "Crédit IA",
    "ar": "رصيد الذكاء الاصطناعي"
  },
  "Order": {
    "fr": "Ordre",
    "ar": "الترتيب"
  },
  "Plan & level requests": {
    "fr": "Demandes de formule et de niveau",
    "ar": "طلبات تغيير الخطة والمستوى"
  },
  "Review learner changes before they affect access or progress statistics.": {
    "fr": "Vérifiez les modifications avant qu’elles ne changent l’accès ou les statistiques.",
    "ar": "راجع التغييرات قبل أن تؤثر في الوصول أو إحصاءات التقدّم."
  },
  "Loading requests…": {
    "fr": "Chargement des demandes…",
    "ar": "جارٍ تحميل الطلبات…"
  },
  "Approve": {
    "fr": "Approuver",
    "ar": "قبول"
  },
  "Reject": {
    "fr": "Refuser",
    "ar": "رفض"
  },
  "No pending change requests.": {
    "fr": "Aucune demande de modification en attente.",
    "ar": "لا توجد طلبات تغيير معلّقة."
  },
  "User administration": {
    "fr": "Administration des utilisateurs",
    "ar": "إدارة المستخدمين"
  },
  "User workspace": {
    "fr": "Espace utilisateur",
    "ar": "مساحة المستخدم"
  },
  "Close user workspace": {
    "fr": "Fermer l’espace utilisateur",
    "ar": "إغلاق مساحة المستخدم"
  },
  "User workspace tabs": {
    "fr": "Onglets de l’espace utilisateur",
    "ar": "تبويبات مساحة المستخدم"
  },
  "Overview & access": {
    "fr": "Vue d’ensemble et accès",
    "ar": "نظرة عامة والوصول"
  },
  "Dismiss message": {
    "fr": "Fermer le message",
    "ar": "إغلاق الرسالة"
  },
  "Loading the complete user account…": {
    "fr": "Chargement du compte utilisateur complet…",
    "ar": "جارٍ تحميل حساب المستخدم كاملاً…"
  },
  "The user details could not be loaded.": {
    "fr": "Impossible de charger les informations de l’utilisateur.",
    "ar": "تعذّر تحميل بيانات المستخدم."
  },
  "Account summary": {
    "fr": "Résumé du compte",
    "ar": "ملخص الحساب"
  },
  "Account": {
    "fr": "Compte",
    "ar": "الحساب"
  },
  "Plan": {
    "fr": "Formule",
    "ar": "الخطة"
  },
  "Balance": {
    "fr": "Solde",
    "ar": "الرصيد"
  },
  "Profile": {
    "fr": "Profil",
    "ar": "الملف"
  },
  "User information": {
    "fr": "Informations de l’utilisateur",
    "ar": "بيانات المستخدم"
  },
  "Phone": {
    "fr": "Téléphone",
    "ar": "الهاتف"
  },
  "WhatsApp": {
    "fr": "WhatsApp",
    "ar": "WhatsApp"
  },
  "Account created": {
    "fr": "Compte créé le",
    "ar": "تاريخ إنشاء الحساب"
  },
  "attempts ·": {
    "fr": "tentatives ·",
    "ar": "محاولات ·"
  },
  "% complete": {
    "fr": "% terminé",
    "ar": "% مكتمل"
  },
  "No exercise activity yet.": {
    "fr": "Aucune activité d’exercice pour le moment.",
    "ar": "لا يوجد نشاط في التمارين بعد."
  },
  "Administration": {
    "fr": "Administration",
    "ar": "الإدارة"
  },
  "Plan & account controls": {
    "fr": "Gestion des formules et des comptes",
    "ar": "إدارة الخطط والحسابات"
  },
  "Plan waiting for activation": {
    "fr": "Formule en attente d’activation",
    "ar": "خطة بانتظار التفعيل"
  },
  "Change or activate plan": {
    "fr": "Modifier ou activer la formule",
    "ar": "تغيير الخطة أو تفعيلها"
  },
  "Activation is immediate, including the free trial without a referral.": {
    "fr": "L’activation est immédiate, y compris l’essai gratuit sans invitation.",
    "ar": "التفعيل فوري، بما في ذلك الفترة المجانية دون دعوة."
  },
  "Choose a plan": {
    "fr": "Choisissez une formule",
    "ar": "اختر خطة"
  },
  "DH ·": {
    "fr": "DH ·",
    "ar": "د.م. ·"
  },
  "Custom end date": {
    "fr": "Date de fin personnalisée",
    "ar": "تاريخ نهاية مخصص"
  },
  "Admin note": {
    "fr": "Note de l’administrateur",
    "ar": "ملاحظة الإدارة"
  },
  "Payment reference or reason": {
    "fr": "Référence du paiement ou motif",
    "ar": "مرجع الدفع أو السبب"
  },
  "Change target level": {
    "fr": "Changer le niveau visé",
    "ar": "تغيير المستوى المستهدف"
  },
  "This immediately updates the learner's available exams and dashboard statistics.": {
    "fr": "Met immédiatement à jour les examens disponibles et les statistiques de l’utilisateur.",
    "ar": "يحدّث فوراً الامتحانات المتاحة وإحصاءات المستخدم."
  },
  "Change end date": {
    "fr": "Changer la date de fin",
    "ar": "تغيير تاريخ النهاية"
  },
  "Extend or shorten the current active plan.": {
    "fr": "Prolongez ou raccourcissez la formule active.",
    "ar": "مدّد الخطة الفعالة أو اختصرها."
  },
  "New end date": {
    "fr": "Nouvelle date de fin",
    "ar": "تاريخ النهاية الجديد"
  },
  "Add balance": {
    "fr": "Ajouter du crédit",
    "ar": "إضافة رصيد"
  },
  "Credit an additional USD amount.": {
    "fr": "Créditer un montant supplémentaire en USD.",
    "ar": "أضف مبلغاً بالدولار إلى الرصيد."
  },
  "Amount (USD)": {
    "fr": "Montant (USD)",
    "ar": "المبلغ (دولار)"
  },
  "Use this only when the learner cannot recover their password.": {
    "fr": "Utilisez cette fonction uniquement si l’utilisateur ne peut pas récupérer son mot de passe.",
    "ar": "استخدم هذا الخيار فقط إذا تعذّر على المستخدم استعادة كلمة المرور."
  },
  "Confirm password": {
    "fr": "Confirmer le mot de passe",
    "ar": "تأكيد كلمة المرور"
  },
  "Direct email": {
    "fr": "E-mail direct",
    "ar": "بريد مباشر"
  },
  "Write to": {
    "fr": "Écrire à",
    "ar": "اكتب إلى"
  },
  "Subject": {
    "fr": "Objet",
    "ar": "الموضوع"
  },
  "Email subject": {
    "fr": "Objet de l’e-mail",
    "ar": "موضوع الرسالة"
  },
  "Message": {
    "fr": "Message",
    "ar": "الرسالة"
  },
  "Write your message…": {
    "fr": "Écrivez votre message…",
    "ar": "اكتب رسالتك…"
  },
  "Attach files": {
    "fr": "Joindre des fichiers",
    "ar": "إرفاق ملفات"
  },
  "Up to 5 files, 8 MB each · PDF, images, Office, text or CSV": {
    "fr": "Jusqu’à 5 fichiers de 8 Mo chacun · PDF, images, Office, texte ou CSV",
    "ar": "حتى 5 ملفات، 8 ميغابايت لكل ملف · PDF أو صور أو Office أو نص أو CSV"
  },
  "MB total": {
    "fr": "Mo au total",
    "ar": "ميغابايت إجمالاً"
  },
  "Communication history": {
    "fr": "Historique des communications",
    "ar": "سجل المراسلات"
  },
  "Older emails": {
    "fr": "E-mails précédents",
    "ar": "رسائل أقدم"
  },
  "Refresh email history": {
    "fr": "Actualiser l’historique des e-mails",
    "ar": "تحديث سجل الرسائل"
  },
  "Loading email history…": {
    "fr": "Chargement de l’historique des e-mails…",
    "ar": "جارٍ تحميل سجل الرسائل…"
  },
  "No emails yet": {
    "fr": "Aucun e-mail pour le moment",
    "ar": "لا توجد رسائل بعد"
  },
  "The first message sent here will appear in this history.": {
    "fr": "Le premier message envoyé ici apparaîtra dans cet historique.",
    "ar": "ستظهر هنا أول رسالة تُرسل من هذه المساحة."
  },
  "ZDeutsch admin": {
    "fr": "Administration ZDeutsch",
    "ar": "إدارة ZDeutsch"
  },
  "Manage learner access, plans, and learning books.": {
    "fr": "Gérez les accès, les formules et les livres d’apprentissage.",
    "ar": "أدِر وصول المتعلّمين والخطط وكتب التدريب."
  },
  "users": {
    "fr": "utilisateurs",
    "ar": "مستخدمين"
  },
  "awaiting payment": {
    "fr": "en attente de paiement",
    "ar": "بانتظار الدفع"
  },
  "paused": {
    "fr": "en pause",
    "ar": "موقوف"
  },
  "Admin sections": {
    "fr": "Sections d’administration",
    "ar": "أقسام الإدارة"
  },
  "Users": {
    "fr": "Utilisateurs",
    "ar": "المستخدمون"
  },
  "Plans": {
    "fr": "Formules",
    "ar": "الخطط"
  },
  "Books": {
    "fr": "Livres",
    "ar": "الكتب"
  },
  "Requests": {
    "fr": "Demandes",
    "ar": "الطلبات"
  },
  "Exam rooms": {
    "fr": "Salles d’examen",
    "ar": "غرف الامتحان"
  },
  "Exam database ↗": {
    "fr": "Base de données des examens ↗",
    "ar": "قاعدة بيانات الامتحانات ↗"
  },
  "Search name, email, or plan": {
    "fr": "Rechercher par nom, e-mail ou formule",
    "ar": "ابحث بالاسم أو البريد أو الخطة"
  },
  "Refresh": {
    "fr": "Actualiser",
    "ar": "تحديث"
  },
  "Loading users…": {
    "fr": "Chargement des utilisateurs…",
    "ar": "جارٍ تحميل المستخدمين…"
  },
  "User": {
    "fr": "Utilisateur",
    "ar": "المستخدم"
  },
  "Created": {
    "fr": "Créé le",
    "ar": "تاريخ الإنشاء"
  },
  "Usage": {
    "fr": "Utilisation",
    "ar": "الاستخدام"
  },
  "Actions": {
    "fr": "Actions",
    "ar": "الإجراءات"
  },
  "/ 1 referral": {
    "fr": "/ 1 invitation",
    "ar": "/ دعوة واحدة"
  },
  "Requested:": {
    "fr": "Demandé :",
    "ar": "المطلوب:"
  },
  "USD": {
    "fr": "USD",
    "ar": "USD"
  },
  "available": {
    "fr": "disponible",
    "ar": "متاح"
  },
  "AI requests ·": {
    "fr": "demandes IA ·",
    "ar": "طلبات ذكاء اصطناعي ·"
  },
  "tokens ·": {
    "fr": "jetons ·",
    "ar": "رموز ·"
  },
  "used": {
    "fr": "utilisé",
    "ar": "مستخدم"
  },
  "Activate": {
    "fr": "Activer",
    "ar": "تفعيل"
  },
  "Cancel plan": {
    "fr": "Annuler la formule",
    "ar": "إلغاء الخطة"
  },
  "User table pages": {
    "fr": "Pages du tableau des utilisateurs",
    "ar": "صفحات جدول المستخدمين"
  },
  "Showing": {
    "fr": "Affichage",
    "ar": "عرض"
  },
  "Prüfung abbrechen": {
    "fr": "Annuler l’examen",
    "en": "Cancel exam",
    "ar": "إلغاء الامتحان"
  },
  "Navigation öffnen": {
    "fr": "Ouvrir la navigation",
    "en": "Open navigation",
    "ar": "فتح القائمة"
  },
  "ZDeutsch start": {
    "fr": "Accueil ZDeutsch",
    "en": "ZDeutsch home",
    "ar": "الصفحة الرئيسية لـ ZDeutsch"
  },
  "Navigation schließen": {
    "fr": "Fermer la navigation",
    "en": "Close navigation",
    "ar": "إغلاق القائمة"
  },
  "Timer starten": {
    "fr": "Démarrer le chronomètre",
    "en": "Start timer",
    "ar": "تشغيل المؤقت"
  },
  "Timer zurücksetzen": {
    "fr": "Réinitialiser le chronomètre",
    "en": "Reset timer",
    "ar": "إعادة ضبط المؤقت"
  },
  "Playing audio": {
    "fr": "Lecture audio",
    "ar": "جارٍ تشغيل الصوت"
  },
  "Back 5 seconds": {
    "fr": "Reculer de 5 secondes",
    "ar": "الرجوع 5 ثوانٍ"
  },
  "Back 5s": {
    "fr": "−5 s",
    "ar": "−5 ثوانٍ"
  },
  "Pause audio": {
    "fr": "Mettre l’audio en pause",
    "ar": "إيقاف الصوت مؤقتاً"
  },
  "Forward 5 seconds": {
    "fr": "Avancer de 5 secondes",
    "ar": "التقدّم 5 ثوانٍ"
  },
  "Forward 5s": {
    "fr": "+5 s",
    "ar": "+5 ثوانٍ"
  },
  "Stop audio": {
    "fr": "Arrêter l’audio",
    "ar": "إيقاف الصوت"
  },
  "Stop": {
    "fr": "Arrêter",
    "ar": "إيقاف"
  },
  "Explaining your selection…": {
    "fr": "Explication de votre sélection…",
    "ar": "جارٍ شرح النص المحدّد…"
  },
  "Close word explanation": {
    "fr": "Fermer l’explication du mot",
    "ar": "إغلاق شرح الكلمة"
  },
  "This field is required.": {
    "fr": "Ce champ est obligatoire.",
    "ar": "هذا الحقل مطلوب."
  },
  "We could not complete this request. Please try again.": {
    "fr": "Impossible de terminer cette demande. Veuillez réessayer.",
    "ar": "تعذّر إتمام هذا الطلب. حاول مرة أخرى."
  },
  "Enter a password of at least 6 characters.": {
    "fr": "Saisissez un mot de passe d’au moins 6 caractères.",
    "ar": "أدخل كلمة مرور من 6 أحرف على الأقل."
  },
  "Änderungsanfragen": {
    "en": "Change requests",
    "fr": "Demandes de modification",
    "ar": "طلبات التغيير"
  },
  "Plan- und Niveauänderungen prüfen.": {
    "en": "Review plan and level changes.",
    "fr": "Vérifiez les changements de formule et de niveau.",
    "ar": "راجع تغييرات الخطة والمستوى."
  },
  "Subscription plan": {
    "en": "Subscription plan",
    "fr": "Formule d’abonnement",
    "ar": "خطة الاشتراك"
  },
  "Activate selected plan": {
    "en": "Activate selected plan",
    "fr": "Activer la formule sélectionnée",
    "ar": "تفعيل الخطة المختارة"
  },
  "Active": {
    "en": "Active",
    "fr": "Actif",
    "ar": "فعّال"
  },
  "Save changes": {
    "en": "Save changes",
    "fr": "Enregistrer les modifications",
    "ar": "حفظ التغييرات"
  },
  "Save plan": {
    "en": "Save plan",
    "fr": "Enregistrer la formule",
    "ar": "حفظ الخطة"
  },
  "Benutzer und ZDeutsch-Abonnements verwalten.": {
    "en": "Manage users and ZDeutsch subscriptions.",
    "fr": "Gérez les utilisateurs et les abonnements ZDeutsch.",
    "ar": "أدِر المستخدمين واشتراكات ZDeutsch."
  },
  "Activating…": {
    "fr": "Activation…",
    "ar": "جارٍ التفعيل…"
  },
  "Loading account…": {
    "fr": "Chargement du compte…",
    "ar": "جارٍ تحميل الحساب…"
  },
  "Email sent and saved in the user's email history.": {
    "fr": "E-mail envoyé et enregistré dans l’historique de l’utilisateur.",
    "ar": "تم إرسال الرسالة وحفظها في سجل مراسلات المستخدم."
  },
  "Plan created successfully.": {
    "fr": "Formule créée.",
    "ar": "تم إنشاء الخطة."
  },
  "Plan updated successfully.": {
    "fr": "Formule mise à jour.",
    "ar": "تم تحديث الخطة."
  },
  "Plan deactivated because subscription history uses it.": {
    "fr": "Formule désactivée car elle figure dans l’historique des abonnements.",
    "ar": "أُوقفت الخطة لأنها مرتبطة بسجل الاشتراكات."
  },
  "Plan deleted successfully.": {
    "fr": "Formule supprimée.",
    "ar": "تم حذف الخطة."
  },
  "New plan": {
    "fr": "Nouvelle formule",
    "ar": "خطة جديدة"
  },
  "Edit plan": {
    "fr": "Modifier la formule",
    "ar": "تعديل الخطة"
  },
  "Create a subscription plan": {
    "fr": "Créer une formule d’abonnement",
    "ar": "إنشاء خطة اشتراك"
  },
  "Inactive": {
    "fr": "Inactif",
    "ar": "غير فعّال"
  },
  "No plan information added yet.": {
    "fr": "Aucune information sur la formule.",
    "ar": "لم تُضف معلومات الخطة بعد."
  },
  "Activate this pending plan now? Trial referral and payment checks will be bypassed.": {
    "fr": "Activer cette formule maintenant ? Les vérifications du paiement et des invitations seront ignorées.",
    "ar": "هل تريد تفعيل هذه الخطة الآن؟ سيُتجاوز التحقق من الدفع ودعوات الفترة التجريبية."
  },
  "The pending plan was activated.": {
    "fr": "La formule en attente a été activée.",
    "ar": "تم تفعيل الخطة المعلّقة."
  },
  "The subscription end date was updated.": {
    "fr": "La date de fin de l’abonnement a été mise à jour.",
    "ar": "تم تحديث تاريخ نهاية الاشتراك."
  },
  "Choose B1 or B2.": {
    "fr": "Choisissez B1 ou B2.",
    "ar": "اختر B1 أو B2."
  },
  "Change this user's password? Their previous password will stop working immediately.": {
    "fr": "Changer le mot de passe de cet utilisateur ? L’ancien cessera de fonctionner immédiatement.",
    "ar": "هل تريد تغيير كلمة مرور هذا المستخدم؟ ستتوقف كلمة المرور السابقة عن العمل فوراً."
  },
  "The user's password was changed.": {
    "fr": "Le mot de passe de l’utilisateur a été changé.",
    "ar": "تم تغيير كلمة مرور المستخدم."
  },
  "Learner": {
    "fr": "Apprenant",
    "ar": "متعلّم"
  },
  "No plan": {
    "fr": "Aucune formule",
    "ar": "لا توجد خطة"
  },
  "Not subscribed": {
    "fr": "Sans abonnement",
    "ar": "غير مشترك"
  },
  "Activate now": {
    "fr": "Activer maintenant",
    "ar": "التفعيل الآن"
  },
  "Save target level": {
    "fr": "Enregistrer le niveau visé",
    "ar": "حفظ المستوى المستهدف"
  },
  "Save end date": {
    "fr": "Enregistrer la date de fin",
    "ar": "حفظ تاريخ النهاية"
  },
  "Adding…": {
    "fr": "Ajout…",
    "ar": "جارٍ الإضافة…"
  },
  "Add to balance": {
    "fr": "Ajouter au solde",
    "ar": "إضافة إلى الرصيد"
  },
  "Updating…": {
    "fr": "Mise à jour…",
    "ar": "جارٍ التحديث…"
  },
  "Sending…": {
    "fr": "Envoi…",
    "ar": "جارٍ الإرسال…"
  },
  "Send email": {
    "fr": "Envoyer l’e-mail",
    "ar": "إرسال الرسالة"
  },
  "Activate this subscription now? Payment or referral requirements will be bypassed.": {
    "fr": "Activer cet abonnement maintenant ? Les exigences de paiement ou d’invitation seront ignorées.",
    "ar": "هل تريد تفعيل هذا الاشتراك الآن؟ سيُتجاوز التحقق من الدفع أو الدعوات."
  },
  "Reject this pending payment request?": {
    "fr": "Refuser cette demande de paiement en attente ?",
    "ar": "هل تريد رفض طلب الدفع المعلّق؟"
  },
  "Cancel this subscription now? The user will immediately lose plan access.": {
    "fr": "Annuler cet abonnement maintenant ? L’utilisateur perdra immédiatement son accès.",
    "ar": "هل تريد إلغاء هذا الاشتراك الآن؟ سيفقد المستخدم وصوله إلى الخطة فوراً."
  },
  "Unnamed user": {
    "fr": "Utilisateur sans nom",
    "ar": "مستخدم دون اسم"
  },
  "No plan selected": {
    "fr": "Aucune formule sélectionnée",
    "ar": "لم تُختر خطة"
  },
  "Account active": {
    "fr": "Compte actif",
    "ar": "الحساب فعّال"
  },
  "Account paused": {
    "fr": "Compte en pause",
    "ar": "الحساب موقوف"
  },
  "Save": {
    "fr": "Enregistrer",
    "ar": "حفظ"
  },
  "Clarity URL copied": {
    "fr": "Lien Clarity copié",
    "ar": "تم نسخ رابط Clarity"
  },
  "View in Clarity": {
    "fr": "Voir dans Clarity",
    "ar": "عرض في Clarity"
  },
  "Pause account": {
    "fr": "Suspendre le compte",
    "ar": "إيقاف الحساب"
  },
  "Resume account": {
    "fr": "Réactiver le compte",
    "ar": "إعادة تفعيل الحساب"
  },
  "active": {
    "fr": "actif",
    "ar": "فعّال"
  },
  "pending payment": {
    "fr": "en attente de paiement",
    "ar": "بانتظار الدفع"
  },
  "pending referrals": {
    "fr": "en attente d’invitations",
    "ar": "بانتظار الدعوات"
  },
  "expired": {
    "fr": "expiré",
    "ar": "منتهي"
  },
  "rejected": {
    "fr": "refusé",
    "ar": "مرفوض"
  },
  "canceled": {
    "fr": "annulé",
    "ar": "ملغى"
  },
  "none": {
    "fr": "aucun",
    "ar": "لا يوجد"
  },
  "Loading writing task…": {
    "fr": "Chargement de la tâche d’écriture…",
    "ar": "جارٍ تحميل مهمة الكتابة…",
    "de": "Schreibaufgabe wird geladen…"
  },
  "The writing task could not load.": {
    "fr": "La tâche d’écriture n’a pas pu être chargée.",
    "ar": "تعذّر تحميل مهمة الكتابة.",
    "de": "Die Schreibaufgabe konnte nicht geladen werden."
  },
  "Checking access…": {
    "fr": "Vérification de l’accès…",
    "ar": "جارٍ التحقق من الوصول…",
    "de": "Zugriff wird geprüft…"
  },
  "Loading previous answers": {
    "fr": "Chargement des réponses précédentes",
    "ar": "جارٍ تحميل الإجابات السابقة",
    "de": "Frühere Antworten werden geladen"
  },
  "Previous answers could not load. Please try again.": {
    "fr": "Les réponses précédentes n’ont pas pu être chargées. Réessayez.",
    "ar": "تعذّر تحميل الإجابات السابقة. حاول مرة أخرى.",
    "de": "Frühere Antworten konnten nicht geladen werden. Bitte versuche es erneut."
  },
  "You can close this window and keep writing.": {
    "fr": "Vous pouvez fermer cette fenêtre et continuer à écrire.",
    "ar": "يمكنك إغلاق هذه النافذة ومتابعة الكتابة.",
    "de": "Du kannst dieses Fenster schließen und weiterschreiben."
  },
  "Draft could not be saved on this device.": {
    "fr": "Le brouillon n’a pas pu être enregistré sur cet appareil.",
    "ar": "تعذّر حفظ المسودة على هذا الجهاز.",
    "de": "Der Entwurf konnte auf diesem Gerät nicht gespeichert werden."
  },
  "Not saved yet": {
    "fr": "Pas encore enregistré",
    "ar": "لم يُحفظ بعد",
    "de": "Noch nicht gespeichert"
  },
  "Saved at {0}": {
    "fr": "Enregistré à {0}",
    "ar": "محفوظ في {0}",
    "de": "Gespeichert um {0}"
  },
  "Subtitles": {
    "fr": "Sous-titres",
    "ar": "النص المسموع",
    "de": "Untertitel"
  },
  "Automatic transcript": {
    "fr": "Transcription automatique",
    "ar": "تفريغ صوتي تلقائي",
    "de": "Automatische Transkription"
  },
  "Listening subtitles": {
    "fr": "Sous-titres de l’enregistrement",
    "ar": "النص المسموع للتسجيل",
    "de": "Untertitel zur Aufnahme"
  },
  "Previous transcript passage": {
    "fr": "Passage précédent",
    "ar": "المقطع النصي السابق",
    "de": "Vorheriger Textabschnitt"
  },
  "Next transcript passage": {
    "fr": "Passage suivant",
    "ar": "المقطع النصي التالي",
    "de": "Nächster Textabschnitt"
  },
  "Hide subtitles": {
    "fr": "Masquer les sous-titres",
    "ar": "إخفاء النص المسموع",
    "de": "Untertitel ausblenden"
  },
  "Loading subtitles…": {
    "fr": "Chargement des sous-titres…",
    "ar": "جارٍ تحميل النص المسموع…",
    "de": "Untertitel werden geladen…"
  },
  "Subtitles are not available for this recording yet.": {
    "fr": "Les sous-titres de cet enregistrement ne sont pas encore disponibles.",
    "ar": "النص المسموع لهذا التسجيل غير متاح بعد.",
    "de": "Für diese Aufnahme sind noch keine Untertitel verfügbar."
  },
  "Subtitles could not be loaded. Please try again.": {
    "fr": "Impossible de charger les sous-titres. Veuillez réessayer.",
    "ar": "تعذّر تحميل النص المسموع. حاول مرة أخرى.",
    "de": "Die Untertitel konnten nicht geladen werden. Bitte versuchen Sie es erneut."
  },
  "Expand subtitles": {
    "fr": "Développer les sous-titres",
    "ar": "توسيع النص المسموع",
    "de": "Untertitel erweitern"
  },
  "Compact subtitles": {
    "fr": "Réduire les sous-titres",
    "ar": "تصغير النص المسموع",
    "de": "Untertitel verkleinern"
  },
  "Loading listening exercise…": {
    "fr": "Chargement de l’exercice d’écoute…",
    "ar": "جارٍ تحميل تمرين الاستماع…",
    "de": "Hörübung wird geladen…"
  },
  "The listening exercise could not be loaded.": {
    "fr": "Impossible de charger l’exercice d’écoute.",
    "ar": "تعذّر تحميل تمرين الاستماع.",
    "de": "Die Hörübung konnte nicht geladen werden."
  },
  "Antwort prüfen": {
    "en": "Check answer",
    "fr": "Vérifier la réponse",
    "ar": "تحقّق من الإجابة",
    "de": "Antwort prüfen"
  },
  "Alle prüfen": {
    "en": "Check all",
    "fr": "Tout vérifier",
    "ar": "تحقّق من الكل",
    "de": "Alle prüfen"
  },
  "Retry audio": {
    "fr": "Réessayer l’audio",
    "ar": "إعادة تحميل الصوت",
    "de": "Audio erneut laden"
  },
  "Reconnecting audio…": {
    "fr": "Reconnexion de l’audio…",
    "ar": "جارٍ إعادة الاتصال بالتسجيل…",
    "de": "Audio wird erneut verbunden…"
  },
  "Games": {
    "en": "Games",
    "fr": "Jeux",
    "de": "Spiele",
    "ar": "الألعاب"
  }
}
